import Utilities from './Utilities';
import * as Device from 'expo-device';
import * as Rq from './Rq';
import WebSocketEx from './WebSocketEx';

import {LoginParams, MnmIds, TemplateId, AppMain,
        Lookback, LookbackType, ReturnTypes, BookItem, UTheme, FontInfo, EvtItem, EvtData, IndicatorInfo, IndicatorType} from './Constants';

import {StringTable} from '../StringTable';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Data, OBData, AccData, PosData, OrdData, SysData, GwyData, Bracket, BracketData, OrdDefault, ChartData, MBOData, MBOOrder} from './Data';
import jspb from 'google-protobuf';
import PriceFormat from './PriceFormat';
import { getDeviceToken, isEmulator } from 'react-native-device-info';
import { RFC_2822 } from 'moment';
import { OBOrderLines } from '../C_General/OBOrder';
// import { RecyclerViewBackedScrollView } from 'react-native';

/*   ---------------------------------------------------------------------   */

async function AsyncSetData(sKey: string, sValue: string)
{
  try 
  {
    await AsyncStorage.setItem(StringTable.APP_NAME + ":" + sKey, sValue);
    //alert("Saved: " + sValue);
  } 
  catch (error) 
  {

  }
}

/*   ---------------------------------------------------------------------   */

async function AsyncGetData(sKey : string, oRet : (x)=>void)
 {
  try 
   {
    const value = await AsyncStorage.getItem(StringTable.APP_NAME + ":" + sKey);
    oRet(value);
   }
  catch (error) 
    {
    oRet(null);
    }
  }


/*   =======================================================================  */

export interface IAppSettings
{
  event_trade_adv? : boolean;
}

/*   =======================================================================  */

export interface ISettings
{
token         : string;
iLookBack?    : number;
sAccount?     : string;


iPnlType?     : number;
iWOType?      : number;
bConfActions? : boolean;
iDefQty?      : number;
iDefQtyEvt?   : number;
iOBLevels?    : number;

iControlPage? : number;

//iLBType?      : number;
bOBExpanded?  : boolean;

oAppSettings? : IAppSettings;
oOrdDefaults? : OrdDefault;
oOrdCurrent?  : OrdDefault;

oChartSettings? : IChartSettings;
}

/*   =======================================================================  */

export interface IAppSettings
{
  iTheme?          : number; 
  iFont?           : number;
  iFontsize?       : number;
  bDarkmode?       : boolean;
  bTransparency?   : boolean;

  iAutoRecon?      : number;
  bEventTradingAdv : boolean;
}

/*   =======================================================================  */

export interface IIndicator
{
  iId            : number;
  iPeriodIndex?  : number;
  iPeriod1       : number;
  iPeriod2?      : number;
  iPeriod3?      : number;
}

/*   =======================================================================  */

export interface IChartSettings
{
  bCandles?        : boolean; 

  iChartType?      : number;
  iColIndex?       : number;
  iLineWidth?      : number;

  oIndicators?     : IIndicator[];
  oIndicators2?    : IIndicator[];
}

/*   =======================================================================  */

class Connection
{
public                    oWs     : WebSocketEx | null = null;  
public                    sCxt    : string    | null = null;
public                    sName   : string    | null = null;
public                    sUsr    : string    | null = null;
public                    sPwd    : string    | null = null;
public                    sUrl    : string    | null = null;
public                    sSystem : string    | null = null;
public                    iType   : Number           = 1;
public static             oBytes  : number           = 0.0;
//public                    bCloseOnOpen              = false;
private                   bLoggedIn                 = false;
private                   bReconnect                = false;
public                    iRetry                    = 0;
public                    iRetryInterval            = 100;
// public                    bInProgress               = false;
public                    bInitRequestSent          = false;

 /*   --------------------------------------------------------------------   */

 public static             sDisplaySystem;
 public static             sDisplayGwy;

 /*   --------------------------------------------------------------------   */

public static              oAppSetting : IAppSettings;

public static              MAX_RETRY                = 10;

public static              TYPE_TICKER_PLANT        = 1;
public static              TYPE_ORDER_PLANT         = 2;
public static              TYPE_HISTORY_PLANT       = 3;
public static              TYPE_PNL_PLANT           = 4;
public static              TYPE_REPOSITORY_PLANT    = 5;


public static              MSG_CONNECTION_ERROR     = 0;
public static              MSG_LOGIN_SUCCESS        = 1;
public static              MSG_LOGIN_FAIL           = 2;

public static              MSG_GET_SETTINGS         = 3;

public static              MSG_REF_DATA_SUCCESS     = 4;
public static              MSG_REF_DATA_FAIL        = 5;
public static              MSG_REF_DATA_DUPLICATE   = 6;

public static              MSG_APPLY_REORDER        = 7;
public static              MSG_GET_BARS             = 8;
public static              MSG_CONNECTION_TIMEOUT   = 9;
public static              MSG_CONNECTION_CLOSED    = 10;
public static              MSG_NEW_ORDER_FAILED     = 11;
public static              MSG_SYS_RQ               = 12;
public static              MSG_NAVIGATE_TO          = 13;
public static              MSG_CHANGE_THEME         = 14;
public static              MSG_CHANGE_FONT          = 15;
public static              MSG_UPDATE_FONT          = 16;
public static              MSG_UPDATE_BG            = 17;
public static              MSG_SHOW_SEARCH          = 18;
public static              MSG_SUBSCRIBE            = 19;
public static              MSG_EVT_DATA             = 20;
public static              MSG_EVT_AVBL             = 21;
public static              MSG_FORCE_LOGOUT         = 22;
public static              MSG_UPDATE_EVT_ADV       = 23;
public static              MSG_APP_SETTINGS         = 24;
public static              MSG_SHOW_ABOUT           = 25;
public static              MSG_REQ_REVIEW           = 26;
public static              MSG_SUB_OB               = 27;

// public static              MSG_SET_SETTINGS         = 4;

public static              DEVICE_WEB               = "Web";

public static              DEVICE_NAME              = Device.deviceName? 
                                                      Device.deviceName : 
                                                      Connection.DEVICE_WEB;

public static              APP_NAME                 = Connection.DEVICE_NAME 
                                                      != Connection.DEVICE_WEB? 
                                                      StringTable.APP_NAME + " Pro - Mobile" :
                                                      StringTable.APP_NAME + " Pro - Web";

 public static readonly    NO_ERROR  = "0";
 public static             HANDLE    = 0;
 private                   bDisposed = false;

 public static readonly    WAIT_TM  = 15000;
 private                   oTm?     : NodeJS.Timer;
 private                   oTmOut?  : NodeJS.Timeout;


 public static            oOnGenAlert : (conn        : Connection, 
                                         msg         : number, 
                                         data?       : any | undefined,
                                         store_data? : any) =>void;

 protected                 oOnAlert : (conn        : Connection, 
                                       msg         : number, 
                                       data        : any | undefined,
                                       store_data? : any) =>void;

 private                   oOnMsg   : (x : any[][]) =>void;
 


 private                   bReconnectAttempted = false;

 /*   --------------------------------------------------------------------   */

 public                    sLastReject  : string = "";
//  public                    sLastLogin   : string = "";
 public                    sSession     : string = "";
 public                    sSessionTime : string = "";
 
/*   --------------------------------------------------------------------   */

 public static readonly RECON_OFF           = 31;
 public static readonly RECON_1MIN          = 60;
 public static readonly RECON_3MIN          = 180;
 public static readonly RECON_5MIN          = 300;

 public static oStore                       = new Map<string, Data>(); 
 public static oStoreAddl                   = new Map<string, Data>(); 
 public static oOBStore                     = new Map<string, OBData>(); 
 public static oAccStore                    = new Map<string, AccData>();
 public static oPosStore                    = new Map<string, PosData>(); 
 public static oOrdStore                    = new Map<string, OrdData>(); 
 public static oRoutes                      = new Map<string, string[]>(); 
 public static oBrackets                    = new Map<string, Bracket>();
 public static oMBOStore                    = new Map<string, MBOData>(); 

 /*   --------------------------------------------------------------------   */

 public static bSettingsLocal               = false;
 public static bGotSettings                 = false;

 /*   --------------------------------------------------------------------   */

 public static CXT_TYPE_MKT                 = 0;
 public static CXT_TYPE_OTH                 = 1;
 public static CXT_TYPE_SYS                 = 2;
 public static CXT_TYPE_GWY                 = 3;

 /*   --------------------------------------------------------------------   */

 private iCurrReTry = 0;
 public  iSplType   = Connection.CXT_TYPE_MKT;
 public  sGwySys    = "";

 /*   --------------------------------------------------------------------   */

 public static     iReconType           = Connection.RECON_1MIN;

 /*   --------------------------------------------------------------------   */

  public static oSettings : ISettings[] = 
  [
    {token:"AAPL.Q", iLookBack: LookbackType.Day1},
    {token:"TSLA.Q", },
    {token:"MSFT.Q"},
    {token:"F.Q"},

    {token:"C.Q"},
    {token:"BP.Q"},

    {token:"ES.CME"},
    {token:"YM.CBOT"},

    {token:"CL.NYMEX"},
  ];

/*   -------------------------------------------------------------------   */

public static IsWeb()
{
return(Connection.DEVICE_NAME == Connection.DEVICE_WEB);  
}

/*   -------------------------------------------------------------------   */

public static ResetHandle()
{
Connection.HANDLE = 0;
}

/*   -------------------------------------------------------------------   */

public IsReconnected()
{
return(this.bLoggedIn && this.bReconnectAttempted);
}

/*   -------------------------------------------------------------------   */

public IsReconnecting()
{
return(this.bReconnectAttempted);
}

/*   -------------------------------------------------------------------   */

public ResetRetry()
{
if (this.oWs?.readyState == this.oWs?.OPEN)
  {
  this.iCurrReTry          = 0;  
  this.bReconnectAttempted = false;
  }
}

/*   -------------------------------------------------------------------   */

// public ResetReconnectAttempted()
// {
// if (this.oWs?.readyState == this.oWs?.OPEN)
//   {
//   this.bReconnectAttempted = false;
//   }
// }

/*   -------------------------------------------------------------------   */

public static GetSymbols(oSymbols: Array<any>,
                         iSort   : number)
{
//if (iSort == 0)
  //return(Connection.oSettings.slice());

let oSettCopy = oSymbols.slice();

if (iSort == 0)
  {
  }
else if (iSort == 1)
  {
  oSettCopy.sort( (a, b)=> { return (a.token.localeCompare(b.token) )}  );
  }
else
  {
  oSettCopy.sort( (a, b)=> { return (a.token.localeCompare(b.token) )} );
  oSettCopy.reverse();
  }

//Utilities.Sendlog(JSON.stringify(oSettCopy));

return(oSettCopy);
}

/*   -------------------------------------------------------------------   */

public NoRetry()
{
this.iCurrReTry          = Connection.MAX_RETRY;
this.iRetryInterval      = 100;
this.bReconnectAttempted = false;
}

/*   -------------------------------------------------------------------   */

constructor(sName    : string,
            sSystem  : string,
            sUrl     : string,
            sUsr     : string,
            sPwd     : string,
            iType    : Number,
            oOnMsg   : (x : any[][]) => void,
            oOnAlert : (conn        : Connection, 
                        msg         : number, 
                        data        : any, 
                        store_data? : any) => void,
            iSplType = Connection.CXT_TYPE_MKT,
            sGwySys  = "")
{
  Connection.HANDLE++;


  this.handleError   = this.handleError.bind(this);
  this.handleOpen    = this.handleOpen.bind(this);
  this.handleClose   = this.handleClose.bind(this);
  this.handleMessage = this.handleMessage.bind(this);
  this.CloseInternal = this.CloseInternal.bind(this);

  this.sUsr           = sUsr;
  this.sPwd           = sPwd;
  this.sSystem        = sSystem;
  this.sUrl           = sUrl;
  this.sCxt           = sName;
  this.sName          = sName + "[" + Connection.HANDLE + "]";
  this.iType          = iType;

  this.bLoggedIn      = false;
  //this.bCloseOnOpen   = false;

  this.oOnMsg         = oOnMsg;
  this.oOnAlert       = oOnAlert;

  // this.NoRetry        = this.NoRetry.bind(this);

  this.iSplType       = iSplType;
  this.sGwySys        = sGwySys;

  if (this.iSplType != Connection.CXT_TYPE_MKT)
    this.iCurrReTry = Connection.MAX_RETRY;

  this.NoRetry           = this.NoRetry.bind(this);
  // this.SetReconnect      = this.SetReconnect.bind(this);
  // this.Start             = this.Start.bind(this);
  // this.SetLoginStatus    = this.SetLoginStatus.bind(this);
  // this.GetLoginStatus    = this.GetLoginStatus.bind(this);
  // this.StartConnection    = this.StartConnection.bind(this);
}

/*   ---------------------------------------------------------------------   */

public SetReconnect()
{
this.bReconnect = true;  
}

/*   ---------------------------------------------------------------------   */

public Start()
{
this.iCurrReTry = 0;
this.StartConnection();
}

/*   ---------------------------------------------------------------------   */

public SetLoginStatus(bStatus : boolean)
{
this.bLoggedIn = bStatus;
}

/*   ---------------------------------------------------------------------   */

public GetLoginStatus()
{
return(this.bLoggedIn);
}

/*   ---------------------------------------------------------------------   */

static IsLoggedIn() : boolean
{
if (Connection.bSettingsLocal == true)
  {
  if (ConnectionMkt.oConn)
    {
    if (Connection.iReconType    != Connection.RECON_OFF && 
        ConnectionMkt.oConn?.bReconnectAttempted == true)
      return(true); //Market reconnecting...
    else  
      return(ConnectionMkt.oConn?.GetLoginStatus());
    }
  else
    return(false);
  }

if (ConnectionOrd.oConn)
  return(ConnectionOrd.oConn?.GetLoginStatus());
else
  return(false);
}

/*   ------------------------------------------------------------------------   */

static GetOrdState()
{
// if (!ConnectionMkt.oConn?.oWs?.readyState)
//    return(false);            

// if (!ConnectionHis.oConn?.oWs?.readyState)
//    return(false);

if (ConnectionOrd.oConn?.oWs?.readyState == 1 &&
    ConnectionOrd.oConn?.bLoggedIn       == true)
   return(true);


// if (ConnectionRMS.oConn?.oWs?.readyState == 1)
//    return(true);

return(false);
}

/*   ------------------------------------------------------------------   */

static GetRMSState()
{
// if (!ConnectionMkt.oConn?.oWs?.readyState)
//    return(false);            

// if (!ConnectionHis.oConn?.oWs?.readyState)
//    return(false);

// if (ConnectionOrd.oConn?.oWs?.readyState == 1)
//    return(true);


if (ConnectionRMS.oConn?.oWs?.readyState == 1 &&
    ConnectionRMS.oConn?.bLoggedIn       == true)
   return(true);

return(false);
}

/*   ------------------------------------------------------------------   */

static GetMktState()
{
// if (!ConnectionMkt.oConn?.oWs?.readyState)
//    return(false);            

// if (!ConnectionHis.oConn?.oWs?.readyState)
//    return(false);

if (ConnectionMkt.oConn?.oWs?.readyState == 1 &&
    ConnectionMkt.oConn?.bLoggedIn       == true)
   return(true);


// if (ConnectionHis.oConn?.oWs?.readyState == 1)
//    return(true);

return(false);
}

/*   ------------------------------------------------------------------   */

static GetHisState()
{
// if (!ConnectionMkt.oConn?.oWs?.readyState)
//    return(false);            

// if (!ConnectionHis.oConn?.oWs?.readyState)
//    return(false);

// if (ConnectionMkt.oConn?.oWs?.readyState == 1)
//    return(true);


if (ConnectionHis.oConn?.oWs?.readyState == 1 &&
    ConnectionHis.oConn?.bLoggedIn       == true)
   return(true);

return(false);
}

/*   ------------------------------------------------------------------   */


static IsOrderAvailable(bCheckRMS : boolean = true) : boolean
{
//     return(false);

if (!ConnectionOrd.oConn                  || 
    !ConnectionOrd.oConn.GetLoginStatus() || 
    ConnectionOrd.oConn.oWs?.readyState   != 1)
  return(false);

if (bCheckRMS == false)
  return(true);

if (!ConnectionRMS.oConn                  || 
    !ConnectionRMS.oConn.GetLoginStatus() ||
    ConnectionRMS.oConn.oWs?.readyState   != 1)
  return(false);

return(true);
}

/*   ------------------------------------------------------------------------   */

static IsOrderAvailableText() : string
{
if (!ConnectionOrd.oConn                  || 
    !ConnectionOrd.oConn.GetLoginStatus() || 
    ConnectionOrd.oConn.oWs?.readyState   != 1)
  return("Orders not available");

if (!ConnectionRMS.oConn                  || 
    !ConnectionRMS.oConn.GetLoginStatus() ||
    ConnectionRMS.oConn.oWs?.readyState   != 1)
  return("RMS not available");

return("");
}

/*   ------------------------------------------------------------------------   */

private StartConnection()
{
if (this.sUrl == null || this.bDisposed == true) 
  return;

if (__DEV__)
  Utilities.Sendlog("Connecting (" + this.sName + "): " + this.sUrl + " (" + this.sSystem + ")...");

// this.bInProgress = true;

// if (this.sUsr)
//   this.oWs = new WebSocket(this.sUrl, this.sUsr);
// else
  this.oWs = new WebSocketEx(this.sUrl);

this.oWs.binaryType = "arraybuffer";
// this.oWs.addEventListener('error', this.handleError.bind(this));
// this.oWs.addEventListener('open', this.handleOpen.bind(this));
// this.oWs.addEventListener('close', this.handleClose.bind(this));
// this.oWs.addEventListener('message', this.handleMessage.bind(this));

this.oWs.addEventListener('error', this.handleError);
this.oWs.addEventListener('open', this.handleOpen);
this.oWs.addEventListener('close', this.handleClose);
this.oWs.addEventListener('message', this.handleMessage);

if (this.iCurrReTry == 0)
  {
  // this.bInProgress = false;  

  if (this.oTm != undefined)
    {
    clearInterval(this.oTm);
    //Utilities.Sendlog("Stopping timer " + this.oTm);
    this.oTm = undefined;
    }

  if (__DEV__)
    Utilities.Sendlog(this.sName +  " Setting timer: " + this.oTm);

  this.oTm = setInterval(this.OnTime.bind(this), Connection.WAIT_TM); //20000);

  if (__DEV__)
    Utilities.Sendlog(this.sName +  " Setting timer: " + this.oTm + " done");
  }
}

/*   ---------------------------------------------------------------------   */

static IsMktAndCanReconnect(iSplType : number)
{
return (iSplType              == Connection.CXT_TYPE_MKT && 
        Connection.iReconType != Connection.RECON_OFF);
}

/*   ---------------------------------------------------------------------   */

private OnTime()
{
  if (__DEV__)
    Utilities.Sendlog("Ontime..." + this.sName + " " + this.oTm);

  /*   -------------------------------------------------------------------   */

  if (this.oTm == undefined)
    return;

  /*   -------------------------------------------------------------------   */    

  if (this.oTm != undefined)
    {
    clearInterval(this.oTm);
    //Utilities.Sendlog("Stopping timer " + this.oTm);
    this.oTm = undefined;
    }

  /*   -------------------------------------------------------------------   */    

  if ((this.iSplType == Connection.CXT_TYPE_OTH || 
       Connection.IsMktAndCanReconnect(this.iSplType)) &&
      Connection.bSettingsLocal == true)
    return;

  /*   -------------------------------------------------------------------   */    

  if (this.oTmOut != undefined)
    {
    clearTimeout(this.oTmOut);
    //Utilities.Sendlog("Stopping timer " + this.oTm);
    this.oTmOut = undefined;
    }

  /*   -------------------------------------------------------------------   */    

  if (this.oWs != null && this.bLoggedIn == false)
    {
    if (__DEV__)      
      Utilities.Sendlog("Ontime... Connection timed out..." + this.sName);

    this.iRetry         = Connection.MAX_RETRY;
    this.iCurrReTry     = Connection.MAX_RETRY;
    this.iRetryInterval = 100;

    this.oOnAlert(this, Connection.MSG_CONNECTION_TIMEOUT, this.sName);
    }
}

/*   ---------------------------------------------------------------------   */

handleOpen()
{
if (__DEV__)  
  Utilities.Sendlog("Opened connection (" + this.sName + "): " + this.sUrl + 
                    "...readyState:" + this.oWs?.readyState);

/*   ---------------------------------------------------------------------   */

// if (this.bCloseOnOpen == true)
//   {
//   Utilities.Sendlog("Closing On Open (" + this.sName + ")..."); 
//   this.oWs?.close();
//   this.oWs = null;
//   return;
//   }

/*   ---------------------------------------------------------------------   */  

// if (this.iSplType == Connection.CXT_TYPE_OTH ||
//     this.iSplType == Connection.CXT_TYPE_MKT)
//   this.iCurrReTry = 0;
// else
//   this.iCurrReTry = Connection.MAX_RETRY;

//* UNCOMMENT *//
// if ((this.iSplType             == Connection.CXT_TYPE_OTH || 
//      this.iSplType             == Connection.CXT_TYPE_MKT) &&
//     Connection.bSettingsLocal == true)
if ((this.iSplType == Connection.CXT_TYPE_OTH || 
      Connection.IsMktAndCanReconnect(this.iSplType)) &&
    Connection.bSettingsLocal == true)
  this.iCurrReTry = 0;
else
  this.iCurrReTry = Connection.MAX_RETRY;

/*   ---------------------------------------------------------------------   */

this.iRetryInterval = 100;

/*   ---------------------------------------------------------------------   */

switch(this.iSplType)
  {
  case Connection.CXT_TYPE_MKT:
  case Connection.CXT_TYPE_OTH:
    this.SendLogin();
    break;
  case Connection.CXT_TYPE_SYS:
    this.SendSysRq();
    break;
  case Connection.CXT_TYPE_GWY:
    this.SendGwyRq();
    break;
  }
}

/*   ---------------------------------------------------------------------   */

async CloseInternal()
{
this.oWs?.close();
}

/*   ---------------------------------------------------------------------   */

handleClose(event : CloseEvent | undefined)
{
if (!this.oWs)
  return;

if (this.oWs.bClosedCalled == true)
  return;

this.oWs.bClosedCalled = true;

  // if (this.bReconnectAttempted == true)
  //   return;
  //ConnectionMkt.iLastSsboeHb = 0;

this.oWs.removeEventListener('error', this.handleError);
this.oWs.removeEventListener('open', this.handleOpen);
this.oWs.removeEventListener('close', this.handleClose);
this.oWs.removeEventListener('message', this.handleMessage);
  
if (event == undefined)
  {
  this.CloseInternal();
  }

if (__DEV__)  
  Utilities.Sendlog(this.sName + " closed" + 
                    ", event: " + event + 
                    // ", data: " + event?.data +
                    // ", length: " + event?.length +
                    ", code: " + event?.code + 
                    ", reason: " + event?.reason + 
                    ", wasClean: " + event?.wasClean);

//if (this.bReconnect == false)
//  this.iRetry = Connection.MAX_RETRY;
//  this.oOnAlert(this, Connection.MSG_CONNECTION_CLOSED, null);

if (this.bDisposed == true)
  return;

/*   ---------------------------------------------------------------------   */

let bCanReconn : boolean = false;

/*   ---------------------------------------------------------------------   */

if (this.iSplType == Connection.CXT_TYPE_MKT)
  {
  bCanReconn = Connection.iReconType != Connection.RECON_OFF;

  /*   ---------------------------------------------------------------------   */

  if (bCanReconn && Connection.bSettingsLocal == true)
    {
    if (__DEV__)      
      Utilities.Sendlog("****MKT Closed=> Can Reconnect? " + 
                        bCanReconn + 
                        " Settings Available? " + 
                        Connection.bSettingsLocal + 
                        " Reconnecting? YES");
    }
  else
    {
    if (__DEV__)      
      Utilities.Sendlog("****MKT Closed=> Can Reconnect? " + 
                        bCanReconn + 
                        " Settings Available? " + 
                        Connection.bSettingsLocal + 
                        " Reconnecting? NO");

    // this.iRetry         = Connection.MAX_RETRY;
    // this.iRetryInterval = 100;
  
    // this.oOnAlert(this, Connection.MSG_CONNECTION_CLOSED, null);
  
    // this.bLoggedIn = false;
    // return;
    }
  }

/*   ---------------------------------------------------------------------   */

if ((this.iSplType             == Connection.CXT_TYPE_OTH /*  || 
     this.iSplType             == Connection.CXT_TYPE_MKT*/) &&
    Connection.bSettingsLocal == true)
  {
  this.iCurrReTry++;

  if (this.bLoggedIn == true && this.bReconnectAttempted == false)
    this.bReconnectAttempted = true;
  // else
  //   this.bReconnectAttempted = false;

  this.bLoggedIn = false;

  if (this.iCurrReTry > Connection.MAX_RETRY)
    this.iRetryInterval = 5000;

  Connection.HANDLE++;
  this.sName = this.sCxt + "[" + Connection.HANDLE + "]";

  if (__DEV__)
    Utilities.Sendlog(this.sName + " Restarting..." + this.iCurrReTry);

  if (this.oTmOut != undefined)
    {
    clearTimeout(this.oTmOut);
    this.oTmOut = undefined;
    }

  this.oTmOut = setTimeout(this.StartConnection.bind(this), this.iRetryInterval);
  }
else if (this.iCurrReTry < Connection.MAX_RETRY) //&& this.bInProgress == false)
  {
  this.iCurrReTry++;

  if (this.bLoggedIn == true  && this.bReconnectAttempted == false)
    this.bReconnectAttempted = true;
  // else
  //   this.bReconnectAttempted = false;

  this.bLoggedIn = false;

  Connection.HANDLE++;
  this.sName = this.sCxt + "[" + Connection.HANDLE + "]";

  if (__DEV__)
    Utilities.Sendlog(this.sName + " Restarting..." + this.iCurrReTry);

  if (this.oTmOut != undefined)
    {
    clearTimeout(this.oTmOut);
    this.oTmOut = undefined;
    }

  this.oTmOut = setTimeout(this.StartConnection.bind(this), this.iRetryInterval);
  }
else
  {
  // if (bCanReconn && Connection.bSettingsLocal == true)
  //   {
  //   Utilities.Sendlog("****MKT Closed=> returning ");
  //   }
  // else
    {
    this.iRetry         = Connection.MAX_RETRY;
    this.iRetryInterval = 100;

    this.oOnAlert(this, Connection.MSG_CONNECTION_CLOSED, null);

    this.bLoggedIn = false;
    }
  }
}

/*   ---------------------------------------------------------------------   */

handleError(event)
{
// if ((this.iSplType             == Connection.CXT_TYPE_OTH  || 
//      this.iSplType             == Connection.CXT_TYPE_MKT) &&
//     Connection.bSettingsLocal == true)
if ((this.iSplType == Connection.CXT_TYPE_OTH || 
      Connection.IsMktAndCanReconnect(this.iSplType)) &&
    Connection.bSettingsLocal == true)
  {
  if (this.bLoggedIn == true && this.bReconnectAttempted == false)
    this.bReconnectAttempted = true;
  }

this.bLoggedIn = false;

if (__DEV__)
  Utilities.Sendlog(this.sName + " **error** (disconnected)" +
                    ", event: " + event + 
                    ", data: " + event.data +
                    ", length: " + event.length +
                    ", code: " + event.code + 
                    ", reason: " + event.reason +
                    ", wasClean: " + event.wasClean +
                    ", readyState: " + this.oWs?.readyState.toString());


// if (this.iCurrReTry < 3)
//   {
//   this.iCurrReTry++;
//   Utilities.Sendlog("Restarting..." + this.iCurrReTry);
//   Connection.HANDLE++;
//   this.sName          = this.sCxt + "[" + Connection.HANDLE + "]";
//   this.Start();
//   }

//if (this.bReconnect == false)                  
//  this.oOnAlert(this, Connection.MSG_CONNECTION_ERROR, null);
}

/*   ---------------------------------------------------------------------   */

handleMessage(event)
{
Connection.oBytes += event.data.byteLength;

/*   -------------------------------------------------------------------   */

//new-type
//this.oOnMsg(Connection.ProcessMsg(event.data));

var x = new Uint8Array(event.data, 4, event.data.byteLength - 4);
this.oOnMsg(Connection.ProcessMsg(x));
}

/*   -------------------------------------------------------------------   */

public SendHb()
{

 //Utilities.Sendlog("sending hb..."); 

 if (this.GetLoginStatus() == true)
  this.Send(Utilities.GetMergedMsg(
      MnmIds.MNM_TEMPLATE_ID, TemplateId.HEARTBEAT_REQUEST, //hb

      MnmIds.MNM_USER_MSG, Utilities.GetSsboeNow().toString(),
      ));
}

/*   ---------------------------------------------------------------------   */

public Send(oMsg: Uint8Array)
{
Connection.oBytes += oMsg.byteLength;

if (this.oWs?.readyState == this.oWs?.OPEN)
  this.oWs?.send(oMsg);
}

/*   ---------------------------------------------------------------------   */

public Close()
{

if (__DEV__)
  Utilities.Sendlog("Closing connection (" + this.sName + ")... readyState: " + 
                   this.oWs?.readyState);

/*   ---------------------------------------------------------------------   */

this.iCurrReTry          = Connection.MAX_RETRY;
this.iRetryInterval      = 100;
this.bDisposed           = true;
this.bReconnectAttempted = false;
this.sLastReject         = "";
// this.sLastLogin          = "";
this.sSession            = "";
this.sSessionTime        = "";

/*   ---------------------------------------------------------------------   */

if (this.oTm != undefined)
  {
  clearInterval(this.oTm);
  this.oTm = undefined;
  }

/*   ---------------------------------------------------------------------   */                     

if (this.oTmOut != undefined)
  {
  clearTimeout(this.oTmOut);
  //Utilities.Sendlog("Stopping timer " + this.oTm);
  this.oTmOut = undefined;
  }

// if (this.oWs?.readyState == 0)
//   {
//   this.bCloseOnOpen = true;
//   Utilities.Sendlog("Setting Close On Open (" + this.sName + ")..."); 
//   return;
//   }

/*   ---------------------------------------------------------------------   */                     

//if (this.oWs?.readyState == 1)
  {
  //Utilities.Sendlog("Closing connection (" + this.sName + ")...");
  this.oWs?.close();
  }

/*   ---------------------------------------------------------------------   */                     

this.oWs  = null;
}

/*   ---------------------------------------------------------------------   */

public CloseSimulate()
{
if (__DEV__)  
  Utilities.Sendlog("Closing connection simulate (" + this.sName + ")... readyState: " + 
                   this.oWs?.readyState);

/*   ---------------------------------------------------------------------   */

this.oWs?.close();
}

/*   ---------------------------------------------------------------------   */

public SendLogin() 
{
if (__DEV__)  
  Utilities.Sendlog("Sending login (" + this.sName + ")..." + this.sUsr);  

// var msg = Utilities.GetMergedMsg(
//   MnmIds.MNM_APP_NAME, Connection.APP_NAME,
//   MnmIds.MNM_APP_VERSION, StringTable.APP_VERSION,

//   MnmIds.MNM_PASSWORD, this.sPwd,
//   MnmIds.MNM_USER, this.sUsr,

//   MnmIds.MNM_RITHMIC_INFRASTRUCTURE_PLANT, this.iType,
//   MnmIds.MNM_RITHMIC_SYSTEM_NAME, this.sSystem, //StringTable.SYSTEM,
//   MnmIds.MNM_TEMPLATE_VERSION, StringTable.TEMPLATE_VER,

//   MnmIds.MNM_USER_MSG, this.bReconnect? StringTable.RECONNECT : "new",

//   MnmIds.MNM_TEMPLATE_ID, TemplateId.LOGIN_REQUEST,

//   );

//   Utilities.Sendlog("???****raw login: " + msg);
//  var x = new Uint8Array(msg, 4, msg.byteLength - 4);
//  let [template, keys, values, tokens, usermsgs] = Connection.ProcessMsg(x);
//  Utilities.Sendlog("???****parsed login: " + Utilities.GetKeyValueString(keys, values));

this.Send(Utilities.GetMergedMsg(
  MnmIds.MNM_APP_NAME, Connection.APP_NAME,
  MnmIds.MNM_APP_VERSION, StringTable.APP_VERSION,

  MnmIds.MNM_PASSWORD, this.sPwd,
  MnmIds.MNM_USER, this.sUsr,

  MnmIds.MNM_RITHMIC_INFRASTRUCTURE_PLANT, this.iType,
  MnmIds.MNM_RITHMIC_SYSTEM_NAME, this.sSystem, //StringTable.SYSTEM,
  MnmIds.MNM_TEMPLATE_VERSION, StringTable.TEMPLATE_VER,

  MnmIds.MNM_USER_MSG, this.bReconnect? StringTable.RECONNECT : "new",

  // MnmIds.MNM_USER_MSG, " *** this is a place holder *** ",
  //MnmIds.MNM_AGGREGATED_QUOTES, this.iSplType==Connection.CXT_TYPE_MKT? true : undefined,

  MnmIds.MNM_TEMPLATE_ID, TemplateId.LOGIN_REQUEST,
  ));
}

/*   ---------------------------------------------------------------------   */

public SendLoginInfo() 
{
if (__DEV__)  
  Utilities.Sendlog("Sending login info (" + this.sName + ")..." + this.sUsr);  

this.Send(Utilities.GetMergedMsg(
  MnmIds.MNM_USER_MSG, this.sSession,
  MnmIds.MNM_TEMPLATE_ID, TemplateId.LOGIN_INFO_REQUEST,
  ));
}

/*   ---------------------------------------------------------------------   */

public SendSysRq() 
{
if (__DEV__)  
  Utilities.Sendlog("Sending system rq (" + this.sName + ")...");  

this.Send(Utilities.GetMergedMsg(
  MnmIds.MNM_TEMPLATE_ID, TemplateId.RITHMIC_SYSTEM_INFO_REQUEST,
  ));
}

/*   ---------------------------------------------------------------------   */

public SendGwyRq() 
{
if (__DEV__)  
  Utilities.Sendlog("Sending gwy rq (" + this.sName + ")...");

let oData = ConnectionSys.oSystems.get(this.sGwySys);

this.Send(Utilities.GetMergedMsg(
  MnmIds.MNM_TEMPLATE_ID, TemplateId.GATEWAY_INFO_REQUEST,
  MnmIds.MNM_RITHMIC_SYSTEM_NAME, oData?.system? oData.system : this.sGwySys,
  MnmIds.MNM_USER_MSG, this.sGwySys,
  ));
}

/*   ---------------------------------------------------------------------   */

public static getResonseCode(keys   : Array<any>, 
                             values : Array<any>) 
{
for (let i = 0; i < keys.length; i++)
  {
    switch(keys[i])
      {
      case MnmIds.MNM_RESPONSE_CODE:
        return(values[i]);
      }
  }

return("");  
}

/*   ---------------------------------------------------------------------   */

public static getResonseCodeLogin(keys   : Array<any>, 
                                  values : Array<any>,
                                  oConn  : Connection | null)
{
let sRp = "";

for (let i = 0; i < keys.length; i++)
  {
    switch(keys[i])
      {
      case MnmIds.MNM_RESPONSE_CODE:
        sRp = values[i];
        break;

      case MnmIds.MNM_UNIQUE_USER_ID:
        if (oConn)
          {
          oConn.sSession     = values[i];
          oConn.sSessionTime = Utilities.formatTimeStatusbar(Date.now());

          // oConn.sLastLogin = Utilities.formatTimeStatusbar(Date.now()) + "\nSession: " + 
          //                    values[i];
          }
        break;  
      }
  }

return(sRp);  
}

/*   ---------------------------------------------------------------------   */

public static getResonseError(keys   : Array<any>, 
                              values : Array<any>) 
{
let sCode  : any = undefined;
let sError : any = undefined;

for (let i = 0; i < keys.length; i++)
  {
    switch(keys[i])
      {
      case MnmIds.MNM_RESPONSE_CODE:
        if (sCode == undefined)
          {
          sCode = values[i];
          //alert(sCode);
          }
        else if (sError == undefined)
          sError = values[i];
      }
  }

return([sCode, sError]);
}

/*   ---------------------------------------------------------------------   */

 static ProcessMsg(bytes)
  {
  var reader   = new jspb.BinaryReader(bytes);
  var keys     = new Array();
  var values   = new Array();
  var template = 0;
  var usermsgs = new Array();

  var symbol;
  var exchange;
  var fcm;
  var ib;
  var account;
  var basket_id;
  var status;

  while (reader.nextField())
  {
    if (reader.isEndGroup())
      break;

    var tag      = reader.getFieldNumber();
    var wireType = reader.getWireType();

  //field-type to wire-type mapping

  //  case fieldTypes.INT32:
  // case fieldTypes.INT64:
  // case fieldTypes.UINT32:
  // case fieldTypes.UINT64:
  // case fieldTypes.SINT32:
  // case fieldTypes.SINT64:
  // case fieldTypes.BOOL:
  // case fieldTypes.ENUM:
  // case fieldTypes.VHASH64:
  //   return wireTypes.VARINT;

  // case fieldTypes.DOUBLE:
  // case fieldTypes.FIXED64:
  // case fieldTypes.SFIXED64:
  // case fieldTypes.FHASH64:
  //   return wireTypes.FIXED64;

  // case fieldTypes.STRING:
  // case fieldTypes.MESSAGE:
  // case fieldTypes.BYTES:
  //   return wireTypes.DELIMITED;

  // case fieldTypes.FLOAT:
  // case fieldTypes.FIXED32:
  // case fieldTypes.SFIXED32:
  //   return wireTypes.FIXED32;

  // case fieldTypes.INVALID:
  // case fieldTypes.GROUP:
  // default:
  //   return wireTypes.INVALID;

  switch(wireType)
    {
    case 0: //Varint
      keys.push(tag);
      values.push(reader.readInt32());

      if (tag == MnmIds.MNM_TEMPLATE_ID)
        template = values[values.length - 1];
    break;

    case 1: //Fixed64 - double and fixed64
      keys.push(tag);
      values.push(reader.readDouble());
      //values.push(reader.readFixed64());
      break;

    case 2: //LengthDelimited
      keys.push(tag);
      values.push(reader.readString());

      switch(tag)
        {
        case MnmIds.MNM_USER_MSG:
          usermsgs.push(values[values.length - 1]);
          break;
        case MnmIds.MNM_SYMBOL:
          symbol = values[values.length - 1];
          break;
      // else if (tag == MnmIds.MNM_MTM_SECURITY)
      //   symbol = values[values.length - 1];        
        //tokens.push(values[values.length - 1]);
        case MnmIds.MNM_EXCHANGE:
          exchange = values[values.length - 1];
          break;
        case MnmIds.MNM_FCM_ID:
          fcm = values[values.length - 1];
          break;
        case MnmIds.MNM_IB_ID:
          ib = values[values.length - 1];
          break;          
        case MnmIds.MNM_ACCOUNT_ID:
          account = values[values.length - 1];
          break;
        case MnmIds.MNM_BASKET_ID:
          basket_id = values[values.length - 1];
          break;          
        case MnmIds.MNM_STATUS:
          status = values[values.length - 1];
          break;                    
        }
      break;

    case 5: //Fixed32 = 5 - float and fixed32
      keys.push(tag);
      values.push(reader.readFixed32());
      break;

    case 3: //StartGroup = 3,
    case 4: //EndGroup = 4,

    default:
    try {
        reader.skipField();
        }
    catch{}

    break;
  }

  }

return [[template], 
        keys, 
        values, 
        [symbol, exchange, fcm, ib, account, basket_id, status], 
        usermsgs];
}

/*   ---------------------------------------------------------------------   */

static GetMergedMsg(...args)
{
var writer = new jspb.BinaryWriter();

for (var i = 0; i < arguments.length; i += 2)
  {
  if (typeof(arguments[i+1]) === 'number')
    writer.writeInt32(arguments[i], arguments[i+1]);
  else
    writer.writeString(arguments[i], arguments[i+1]);
  }

var two = writer.getResultBuffer();
var one = Utilities.intToByteArray(two.length);

var merged = new Uint8Array(one.length + two.length);
merged.set(one);
merged.set(two, one.length);

return(merged);
}    

/*   ---------------------------------------------------------------------   */

};

/*   =======================================================================  */

class ConnectionOrd extends Connection
{
public static oConn     : ConnectionOrd | null = null;

public static iUserType;
public static sFCMId = "";
public static sIBId  = "";

/*   ---------------------------------------------------------------------   */  

static m_event : Array<((sToken?    : string,
                         oOrdData?  : OrdData, 
                         oPosData?  : PosData, 
                         dRemPrice? : number,
                         sBasketId? : string) => void)> = [];

/*   =====================================================================   */

public static Init(oLoginParams : LoginParams, 
                   oOnAlert : (conn        : Connection,
                               msg         : number,
                               data        : any,
                               store_data? : any) => void,
                   iRetryCount = 0)
{
try
    {
    
    if (__DEV__)      
      Utilities.Sendlog("**Staring Order...");

    ConnectionOrd.oConn = new ConnectionOrd("Order",
                                            oLoginParams.sSys,
                                            oLoginParams.sUrl,
                                            oLoginParams.sUsr,
                                            oLoginParams.sPwd,
                                            Connection.TYPE_ORDER_PLANT,
                                            ConnectionOrd.oWs_Ord_onmessage,
                                            oOnAlert,
                                            Connection.CXT_TYPE_OTH);

    ConnectionOrd.oConn.iRetry = iRetryCount;
    ConnectionOrd.oConn.Start();                            
    }
catch(error)
    {
    //setLoginState('💥');
    //alert("Order connection failed - " + error);  
    }    
}

/*   -------------------------------------------------------------------   */

static FindValueEvent(oEvent)
{
for (let i = 0; i < ConnectionOrd.m_event.length; i++)
  if (ConnectionOrd.m_event[i] == oEvent)
    return(i);

return(AppMain.IMAGINARY);
}

/*   -------------------------------------------------------------------   */

static BindEvent(onEvent : ((sToken?    : string,
                             oOrdData?  : OrdData,
                             oPosData?  : PosData,
                             dRemPrice? : number,
                             sBasketId? : string) => void), 
                             bSubscribe : boolean) 
{
if (bSubscribe == true)  
  {
    ConnectionOrd.m_event.push(onEvent);

  //console.log("***added new event: " + m_event.length);
  }
else if (bSubscribe == false)
  {
  var iZ = ConnectionOrd.FindValueEvent(onEvent);

  if (iZ != -1)
    ConnectionOrd.m_event.splice(iZ, 1);

  //console.log("***removed event: " + m_event.length);
  }  
else  
  {
  if (__DEV__)    
    Utilities.Sendlog("***UNKNOWN event: " + this.m_event.length);
  }
}

/*   -------------------------------------------------------------------   */

public static Dispose()
{
ConnectionOrd.m_event.slice(0 ,ConnectionOrd.m_event.length);

ConnectionOrd.oConn?.SetLoginStatus(false);
ConnectionOrd.oConn?.SetReconnect();
ConnectionOrd.oConn?.Close();
ConnectionOrd.oConn = null;

ConnectionOrd.sFCMId = "";
ConnectionOrd.sIBId  = "";
}

/*   -------------------------------------------------------------------   */

static NotifyOrder(sToken?    : string,
                   oOrdData?  : OrdData,
                   oPosData?  : PosData,
                   dRemPrice? : number,
                   sBasketId? : string)
{
  if (oOrdData?.basket_id)
    {
    if (__DEV__)      
      Utilities.Sendlog("**Notifying order event for: " + oOrdData?.basket_id);
    }

  for (let i = 0; i < ConnectionOrd.m_event.length; i++)
    {
    ConnectionOrd.m_event[i](sToken, oOrdData, oPosData, dRemPrice, sBasketId);
    }
}

/*   -------------------------------------------------------------------   */

public static SaveDataLocal(sKey: string, sValue: string)
{
AsyncSetData(sKey, sValue);
}

/*   -------------------------------------------------------------------   */

public static SaveWindowsLocal(sValue: string)
{
AsyncSetData("windows", sValue);
}

/*   -------------------------------------------------------------------   */

public static GetDataLocal(sKey : string, oRet : (x)=>void)
{
AsyncGetData(sKey, oRet);
}

/*   -------------------------------------------------------------------   */

public static GetWindowsLocal(oRet : (x)=>void)
{
AsyncGetData("windows", oRet);
}

/*   -------------------------------------------------------------------   */

public static GetPosData(oData   : Data,
                         sAccKey : string = "")
{
if (Connection.oAccStore.size > 0)
  {
  let acckey : string;
  
  if (sAccKey && Connection.oAccStore.has(sAccKey))
    acckey = sAccKey;
  else
    acckey = Connection.oAccStore.keys().next().value;

  let token   = "";

  if (oData.trading_symbol && oData.trading_exchange)
    token = oData.trading_symbol + "." + oData.trading_exchange;
  else
    token = oData.token;

  let key = acckey + token;

  let oPosData = Connection.oPosStore.get(key);

  if (oPosData == undefined)
    {
    oPosData = new PosData(acckey, token);
    Connection.oPosStore.set(key, oPosData);
    }

  return(oPosData);
  }
}

/*   -------------------------------------------------------------------   */

public static Rq_SetUserSettings(sDeviceName, sSettings)
{
if (sDeviceName != Connection.DEVICE_WEB)
  ConnectionOrd.SaveWindowsLocal(sSettings);

if (__DEV__)  
  Utilities.Sendlog("Saving settings=>" + sDeviceName + "<>" + sSettings);
//alert("set->" + global.appName);

ConnectionOrd.oConn?.Send(Utilities.GetMergedMsg(
    MnmIds.MNM_APP_NAME, StringTable.APP_NAME,//global.appName,
    MnmIds.MNM_DEVICE_NAME, sDeviceName,
    MnmIds.MNM_USER_SETTINGS, sSettings,
    MnmIds.MNM_VERSION, StringTable.APP_VERSION, //global.appVersion,

    MnmIds.MNM_USER_MSG, sDeviceName,
    MnmIds.MNM_USER_MSG, sSettings,

    MnmIds.MNM_TEMPLATE_ID, TemplateId.SET_USER_SETTINGS_REQUEST,
    ));
}

/*   -------------------------------------------------------------------   */

public static Rq_SetAppSettings(sDeviceName, sSettings)
{
if (__DEV__)  
  Utilities.Sendlog("Saving app settings=>" + sDeviceName + "<>" + sSettings);
//alert("set->" + global.appName);

ConnectionOrd.oConn?.Send(Utilities.GetMergedMsg(
    MnmIds.MNM_APP_NAME, StringTable.APP_NAME,//global.appName,
    MnmIds.MNM_DEVICE_NAME, sDeviceName,
    MnmIds.MNM_APP_DEFAULT_SETTINGS, sSettings,
    MnmIds.MNM_VERSION, StringTable.APP_VERSION, //global.appVersion,

    MnmIds.MNM_USER_MSG, sDeviceName,
    MnmIds.MNM_USER_MSG, sSettings,

    MnmIds.MNM_TEMPLATE_ID, TemplateId.SET_USER_SETTINGS_REQUEST,
    ));
}

/*   -------------------------------------------------------------------   */

public Rq_GetUserSettings(sDeviceName)
{
//alert("get->" + global.appName);

if (__DEV__)
  Utilities.Sendlog("Getting settings=>" + sDeviceName);

this.Send(Utilities.GetMergedMsg(
    MnmIds.MNM_DEVICE_NAME, sDeviceName,
    MnmIds.MNM_APP_NAME, StringTable.APP_NAME, //global.appName,

    MnmIds.MNM_USER_MSG, sDeviceName,

    MnmIds.MNM_TEMPLATE_ID, TemplateId.GET_USER_SETTINGS_REQUEST,
    ));
}

/*   -------------------------------------------------------------------   */

public Rq_LoadRefData(oEvtData : EvtData)
{
//alert("get->" + global.appName);

if (oEvtData.bLdRefData)
  return;

/*   -------------------------------------------------------------------   */  

oEvtData.bLdRefData = true;

/*   -------------------------------------------------------------------   */
  
if (__DEV__)
  Utilities.Sendlog("Load Ref Data=>");

/*   -------------------------------------------------------------------   */    

if (!oEvtData.oEvtList)
  {
  if (__DEV__)    
    Utilities.Sendlog("Load Ref Data=> undefined");

  return;
  }

let oParams:any[] = new Array(0);

for (let [key, oData] of oEvtData.oEvtList?.entries()) 
  {
  if (oData.oCallData)
    {
    oParams.push(MnmIds.MNM_SYMBOL);
    oParams.push(oData.oCallData.symbol);

    oParams.push(MnmIds.MNM_EXCHANGE);
    oParams.push(oData.oCallData.exchange);
    }

  if (oData.oPutData)
    {
    oParams.push(MnmIds.MNM_SYMBOL);
    oParams.push(oData.oPutData.symbol);

    oParams.push(MnmIds.MNM_EXCHANGE);
    oParams.push(oData.oPutData.exchange);
    }    
  }

oParams.push(MnmIds.MNM_USER_MSG);
oParams.push(oEvtData.sToken);

oParams.push(MnmIds.MNM_TEMPLATE_ID);
oParams.push(TemplateId.WS_TMPLT_ID_PVT_RQ_LOAD_REF_DATA);

this.Send(Utilities.GetMergedMsg(
    ...oParams
    ));
}

/*   -------------------------------------------------------------------   */

public Rq_GetAccounts()
{
if (__DEV__)  
  Utilities.Sendlog("Getting accounts=>");

this.Send(Utilities.GetMergedMsg(

    MnmIds.MNM_FCM_ID, ConnectionOrd.sFCMId,
    MnmIds.MNM_IB_ID, ConnectionOrd.sIBId,
    MnmIds.MNM_USER_TYPE, Rq.UserType.USER_TYPE_TRADER,

    MnmIds.MNM_TEMPLATE_ID, TemplateId.ACCOUNT_LIST_REQUEST,
    ));
}

/*   -------------------------------------------------------------------   */

public Rq_GetRoutes()
{
if (__DEV__)  
  Utilities.Sendlog("Getting routes=>");

this.Send(Utilities.GetMergedMsg(

    MnmIds.MNM_SUBSCRIBE_FLAG, false,

    MnmIds.MNM_TEMPLATE_ID, TemplateId.TRADE_ROUTES_REQUEST,
    ));
}

/*   -------------------------------------------------------------------   */

public Rq_OrderSessionConfig()
{
if (__DEV__)  
  Utilities.Sendlog("Setting order session config=>");

this.Send(Utilities.GetMergedMsg(

    MnmIds.MNM_USER_MSG, "defer",
    MnmIds.MNM_SHOULD_DEFER_REQUEST, true,

    MnmIds.MNM_TEMPLATE_ID, TemplateId.ORDER_SESSION_CONFIG_REQUEST,
    ));
}

/*   -------------------------------------------------------------------   */

public Rq_GetOrders(oAccData)
{
  if (__DEV__)  
    Utilities.Sendlog("Getting orders=>" + oAccData.key);

  this.Send(Utilities.GetMergedMsg(
  
      MnmIds.MNM_FCM_ID, oAccData.fcm_id,
      MnmIds.MNM_IB_ID, oAccData.ib_id,
      MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,
  
      MnmIds.MNM_TEMPLATE_ID, TemplateId.SHOW_ORDERS_REQUEST,
      ));  

  if (__DEV__)      
    Utilities.Sendlog("Sub orders=>" + oAccData.key);

  this.Send(Utilities.GetMergedMsg(

    MnmIds.MNM_FCM_ID, oAccData.fcm_id,
    MnmIds.MNM_IB_ID, oAccData.ib_id,
    MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,

    MnmIds.MNM_TEMPLATE_ID, TemplateId.SUBSCRIBE_FOR_ORDER_UPDATES_REQUEST,
    ));


  if (__DEV__)    
    Utilities.Sendlog("Getting brackets=>" + oAccData.key);    

  this.Send(Utilities.GetMergedMsg(
  
      MnmIds.MNM_FCM_ID, oAccData.fcm_id,
      MnmIds.MNM_IB_ID, oAccData.ib_id,
      MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,
  
      MnmIds.MNM_TEMPLATE_ID, TemplateId.SHOW_BRACKETS_REQUEST,
      ));

  this.Send(Utilities.GetMergedMsg(
  
      MnmIds.MNM_FCM_ID, oAccData.fcm_id,
      MnmIds.MNM_IB_ID, oAccData.ib_id,
      MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,
  
      MnmIds.MNM_TEMPLATE_ID, TemplateId.SHOW_BRACKET_STOPS_REQUEST,
      ));

  this.Send(Utilities.GetMergedMsg(
  
      MnmIds.MNM_FCM_ID, oAccData.fcm_id,
      MnmIds.MNM_IB_ID, oAccData.ib_id,
      MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,
  
      MnmIds.MNM_TEMPLATE_ID, TemplateId.SUBSCRIBE_TO_BRACKET_UPDATES_REQUEST,
      ));            
}

/*   -------------------------------------------------------------------   */

public Rq_GetAccountRMS()
{
  if (__DEV__)  
    Utilities.Sendlog("Getting RMS settings=>");

  this.Send(Utilities.GetMergedMsg(
  
      // MnmIds.MNM_FCM_ID, oAccData.fcm_id,
      // MnmIds.MNM_IB_ID, oAccData.ib_id,
      MnmIds.MNM_FCM_ID, ConnectionOrd.sFCMId,
      MnmIds.MNM_IB_ID, ConnectionOrd.sIBId,
      MnmIds.MNM_USER_TYPE, Rq.UserType.USER_TYPE_TRADER,
  
      MnmIds.MNM_TEMPLATE_ID, TemplateId.ACCOUNT_RMS_INFO_REQUEST,
      ));  

}

/*   -------------------------------------------------------------------   */

public Rq_ExitPosition(sAccKey    : string | undefined,
                       sToken     : string,
                       sWindowName: string)
{
if (__DEV__)  
  Utilities.Sendlog("Sending exit pos=> account: " + sAccKey + " token: " + sToken);  

if (sAccKey == undefined)
  {
  alert("account not found");    

  if (__DEV__)
    Utilities.Sendlog("Sending exit pos=>account not found: " + sAccKey);
  return;
  }

let oMktData = Connection.oStore.get(sToken);

if (oMktData == undefined)
  oMktData = Connection.oStoreAddl.get(sToken);

let oAccData = Connection.oAccStore.get(sAccKey);

if (oMktData == undefined)
  {
  alert("market data not found");    

  if (__DEV__)
    Utilities.Sendlog("Sending exit pos=>market data not found");
  return;
  }

if (oAccData == undefined)
  {
  alert("account not found");

  if (__DEV__)
    Utilities.Sendlog("Sending exit pos=>account not found");
  return;
  }

let sExchange = oMktData.trading_exchange? oMktData.trading_exchange : 
                      oMktData.exchange;

  this.Send(Utilities.GetMergedMsg(

    MnmIds.MNM_FCM_ID, oAccData.fcm_id,
    MnmIds.MNM_IB_ID, oAccData.ib_id,
    MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,

    MnmIds.MNM_SYMBOL, oMktData.trading_symbol? 
                        oMktData.trading_symbol : 
                        oMktData.symbol,
    MnmIds.MNM_EXCHANGE, sExchange,

    MnmIds.MNM_MANUAL_OR_AUTO, Rq.OrderPlacement.MANUAL,


    MnmIds.MNM_USER_MSG, oAccData.key + sToken,
    MnmIds.MNM_WINDOW_NAME, sWindowName,

    MnmIds.MNM_TEMPLATE_ID, TemplateId.EXIT_POSITION_REQUEST,
    ));
                
}

/*   -------------------------------------------------------------------   */

public Rq_ExitPositionAcc(sAccKey    : string | undefined,
                          sWindowName: string)
{
if (__DEV__)  
  Utilities.Sendlog("Sending exit pos acc=> account: " + sAccKey);

if (sAccKey == undefined)
  {
  alert("account not found");    

  if (__DEV__)
    Utilities.Sendlog("Sending exit pos acc=>account not found: " + sAccKey);
  return;
  }

let oAccData = Connection.oAccStore.get(sAccKey);

if (oAccData == undefined)
  {
  alert("account not found");

  if (__DEV__)
    Utilities.Sendlog("Sending exit pos acc=>account not found");
  return;
  }

  this.Send(Utilities.GetMergedMsg(

    MnmIds.MNM_FCM_ID, oAccData.fcm_id,
    MnmIds.MNM_IB_ID, oAccData.ib_id,
    MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,

    MnmIds.MNM_MANUAL_OR_AUTO, Rq.OrderPlacement.MANUAL,

    MnmIds.MNM_USER_MSG, oAccData.key,
    MnmIds.MNM_WINDOW_NAME, sWindowName,

    MnmIds.MNM_TEMPLATE_ID, TemplateId.EXIT_POSITION_REQUEST,
    ));
                
}

/*   -------------------------------------------------------------------   */

public Rq_PlaceOrder(sAccKey       : string | undefined,
                     sToken        : string,
                     iTxn          : number,
                     iQty          : number | undefined,
                     sWindowName   : string,
                     iPriceType    : number = Rq.PriceType.MARKET,
                     dPrice        : number | undefined = undefined,
                     iCanAfter?    : number,
                     iCanAt?       : number,
                     iBrTargetTks? : number,
                     iBrStopTks?   : number,
                     bBrTrail?     : boolean) : boolean
{
if (__DEV__)  
  Utilities.Sendlog("Sending order=> account: " + sAccKey + " token: " + sToken + " txn: " + 
                        Rq.TransactionType.GetDisplay(iTxn) + " qty: " + iQty + " type: " + 
                        Rq.PriceType.GetDisplay(iPriceType) + " price: " + dPrice);  

/*   -------------------------------------------------------------------   */                       

if (sAccKey == undefined)
  {
    alert("account not found");

    if (__DEV__)
      Utilities.Sendlog("Sending order=>account not found: " + sAccKey);
    return(false);
  }

/*   -------------------------------------------------------------------   */  

if (iQty == undefined)
  {
    alert("specify a default qty for order");

    if (__DEV__)
      Utilities.Sendlog("Sending order=>Specify a default qty for order");
    return(false);
  }

/*   -------------------------------------------------------------------   */  

let oMktData = Connection.oStore.get(sToken);

if (oMktData == undefined)
  oMktData = Connection.oStoreAddl.get(sToken);

let oAccData = Connection.oAccStore.get(sAccKey);

if (oMktData == undefined)
  {
  alert("market data not found");

  if (__DEV__)
    Utilities.Sendlog("Sending order=>market data not found");
  return(false);
  }

/*   -------------------------------------------------------------------   */  

if (oAccData == undefined)
  {
  alert("account not found");

  if (__DEV__)
    Utilities.Sendlog("Sending order=>account not found");
  return(false);
  }

/*   -------------------------------------------------------------------   */  

if (dPrice == undefined && iPriceType != Rq.PriceType.MARKET)
  {
  alert("price not available");

  if (__DEV__)
    Utilities.Sendlog("Sending order=>price unavailable");
  return(false);
  }

/*   -------------------------------------------------------------------   */    

// if (dPrice == undefined && iPriceType != Rq.PriceType.MARKET)
//   {
//   alert("Set a default order quantity in settings");
//   Utilities.Sendlog("Sending order=>Set a default order quantity in settings");
//   return;
//   }

/*   -------------------------------------------------------------------   */    

let sExchange = oMktData.trading_exchange? oMktData.trading_exchange : 
                                           oMktData.exchange;


let oRoutes   = Connection.oRoutes.get(oAccData.fcm_id +
                                       oAccData.ib_id  +
                                       sExchange);


/*   -------------------------------------------------------------------   */  

if (oRoutes == undefined || oRoutes.length == 0)
  {
  alert("route not found");

  if (__DEV__)
    Utilities.Sendlog("Sending order=>route not found");
  return(false);
  }

/*   -------------------------------------------------------------------   */  

if (__DEV__)
  Utilities.Sendlog("Sending order=>" + oMktData.trading_symbol + 
                                  "/" + oMktData.symbol + "/"
                                      + oRoutes[0]);  

/*   -------------------------------------------------------------------   */

let bBracket  = false;
let iBrType   = 0;

if (iBrTargetTks || iBrStopTks)
  {
  bBracket = true;

  if (iBrTargetTks && iBrStopTks)
    {
    iBrType = Rq.BracketType.TARGET_AND_STOP;
    }
  else if (iBrTargetTks)
    {
    iBrType = Rq.BracketType.TARGET_ONLY;
    }
  else if (iBrStopTks)
    {
    iBrType = Rq.BracketType.STOP_ONLY;
    }
  }

/*   -------------------------------------------------------------------   */

switch (iPriceType)
  {
  case Rq.PriceType.MARKET:
  case Rq.PriceType.LIMIT:
  case Rq.PriceType.STOP_MARKET:
  case Rq.PriceType.STOP_LIMIT:
    this.Send(Utilities.GetMergedMsg(

        //MnmIds.MNM_PRICE_TO_FILL, dPrice,

        MnmIds.MNM_FCM_ID, oAccData.fcm_id,
        MnmIds.MNM_IB_ID, oAccData.ib_id,
        MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,

        MnmIds.MNM_SYMBOL, oMktData.trading_symbol? 
                           oMktData.trading_symbol : 
                           oMktData.symbol,
        MnmIds.MNM_EXCHANGE, sExchange,

        MnmIds.MNM_QUAN_TO_FILL, iQty,
        MnmIds.MNM_TRANSACTION_TYPE, iTxn,
        MnmIds.MNM_PRICE_TYPE, iPriceType,
        MnmIds.MNM_DURATION, Rq.Duration.DAY,

        MnmIds.MNM_TRADE_ROUTE, oRoutes[0],
        MnmIds.MNM_MANUAL_OR_AUTO, Rq.OrderPlacement.MANUAL,

        MnmIds.MNM_PRICE_TO_FILL, (iPriceType != Rq.PriceType.MARKET && iPriceType != Rq.PriceType.STOP_MARKET)? dPrice : undefined,
        MnmIds.MNM_TRIGGER_PRICE, (iPriceType == Rq.PriceType.STOP_MARKET || iPriceType == Rq.PriceType.STOP_LIMIT)? dPrice : undefined,

        MnmIds.MNM_CANCEL_AFTER_SECS, iCanAfter,
        MnmIds.MNM_CANCEL_AT_SSBOE, iCanAt,

        MnmIds.MNM_BRACKET_TYPE, bBracket? iBrType : undefined,
        MnmIds.MNM_USER_TYPE, bBracket? Rq.UserType.USER_TYPE_TRADER : undefined,

        MnmIds.MNM_TARGET_TICKS, iBrTargetTks,
        MnmIds.MNM_TARGET_QUANTITY, iBrTargetTks? iQty : undefined,

        MnmIds.MNM_STOP_TICKS, iBrStopTks,
        MnmIds.MNM_STOP_QUANTITY, iBrStopTks? iQty : undefined,
        MnmIds.MNM_BRACKET_TRAILING_FIELD_ID, bBrTrail? true : undefined,

        MnmIds.MNM_USER_MSG, oAccData.key + sToken,
        // MnmIds.MNM_USER_TAG, ConnectionOrd.oConn?.sSession,
        MnmIds.MNM_WINDOW_NAME, sWindowName,

        MnmIds.MNM_TEMPLATE_ID, bBracket? TemplateId.BRACKET_ORDER_REQUEST : TemplateId.NEW_ORDER_REQUEST,
        ));
        
    return(true);
  // case Rq.PriceType.LIMIT:
  //     this.Send(Utilities.GetMergedMsg(
  
  //         MnmIds.MNM_FCM_ID, oAccData.fcm_id,
  //         MnmIds.MNM_IB_ID, oAccData.ib_id,
  //         MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,
  
  //         MnmIds.MNM_SYMBOL, oMktData.trading_symbol? oMktData.trading_symbol : oMktData.symbol,
  //         MnmIds.MNM_EXCHANGE, oMktData.trading_exchange? oMktData.trading_exchange : oMktData.exchange,
  
  //         MnmIds.MNM_QUAN_TO_FILL, iQty,
  //         MnmIds.MNM_TRANSACTION_TYPE, iTxn,
  //         MnmIds.MNM_PRICE_TYPE, iPriceType,
  //         MnmIds.MNM_DURATION, Rq.Duration.DAY,
  
  //         MnmIds.MNM_PRICE_TO_FILL, dPrice,

  //         MnmIds.MNM_TRADE_ROUTE, oRoutes[0],
  //         MnmIds.MNM_MANUAL_OR_AUTO, Rq.OrderPlacement.MANUAL,
  
  //         MnmIds.MNM_CANCEL_AFTER_SECS, iCanAfter,
  //         MnmIds.MNM_CANCEL_AT_SSBOE, iCanAt,

  //         MnmIds.MNM_TARGET_QUANTITY, iBrTargetTks? iQty : undefined,
  //         MnmIds.MNM_TARGET_TICKS, iBrTargetTks,
  //         MnmIds.MNM_STOP_QUANTITY, iQty,
  //         MnmIds.MNM_STOP_TICKS, iBrStopTks? iQty : undefined,
  
  //         MnmIds.MNM_USER_MSG, oAccData.key + sToken,
  
  //         MnmIds.MNM_TEMPLATE_ID, (iBrTargetTks || iBrStopTks)? TemplateId.BRACKET_ORDER_REQUEST : TemplateId.NEW_ORDER_REQUEST,
  //         ));
  //     break;
    // case Rq.PriceType.STOP_MARKET:
    //   this.Send(Utilities.GetMergedMsg(
  
    //       MnmIds.MNM_FCM_ID, oAccData.fcm_id,
    //       MnmIds.MNM_IB_ID, oAccData.ib_id,
    //       MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,
  
    //       MnmIds.MNM_SYMBOL, oMktData.trading_symbol? oMktData.trading_symbol : oMktData.symbol,
    //       MnmIds.MNM_EXCHANGE, oMktData.trading_exchange? oMktData.trading_exchange : oMktData.exchange,
  
    //       MnmIds.MNM_QUAN_TO_FILL, iQty,
    //       MnmIds.MNM_TRANSACTION_TYPE, iTxn,
    //       MnmIds.MNM_PRICE_TYPE, iPriceType,
    //       MnmIds.MNM_DURATION, Rq.Duration.DAY,
  
    //       MnmIds.MNM_TRIGGER_PRICE, dPrice,

    //       MnmIds.MNM_TRADE_ROUTE, oRoutes[0],
    //       MnmIds.MNM_MANUAL_OR_AUTO, Rq.OrderPlacement.MANUAL,
  
    //       MnmIds.MNM_CANCEL_AFTER_SECS, iCanAfter,
    //       MnmIds.MNM_CANCEL_AT_SSBOE, iCanAt,
  
    //       MnmIds.MNM_TARGET_QUANTITY, iBrTargetTks? iQty : undefined,
    //       MnmIds.MNM_TARGET_TICKS, iBrTargetTks,
    //       MnmIds.MNM_STOP_QUANTITY, iQty,
    //       MnmIds.MNM_STOP_TICKS, iBrStopTks? iQty : undefined,
  
    //       MnmIds.MNM_USER_MSG, oAccData.key + sToken,
  
    //       MnmIds.MNM_TEMPLATE_ID, (iBrTargetTks || iBrStopTks)? TemplateId.BRACKET_ORDER_REQUEST : TemplateId.NEW_ORDER_REQUEST,
    //       ));
    //   break;          
    // case Rq.PriceType.STOP_LIMIT:
    //   this.Send(Utilities.GetMergedMsg(
  
    //       MnmIds.MNM_FCM_ID, oAccData.fcm_id,
    //       MnmIds.MNM_IB_ID, oAccData.ib_id,
    //       MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,
  
    //       MnmIds.MNM_SYMBOL, oMktData.trading_symbol? oMktData.trading_symbol : oMktData.symbol,
    //       MnmIds.MNM_EXCHANGE, oMktData.trading_exchange? oMktData.trading_exchange : oMktData.exchange,
  
    //       MnmIds.MNM_QUAN_TO_FILL, iQty,
    //       MnmIds.MNM_TRANSACTION_TYPE, iTxn,
    //       MnmIds.MNM_PRICE_TYPE, iPriceType,
    //       MnmIds.MNM_DURATION, Rq.Duration.DAY,
  
    //       MnmIds.MNM_PRICE_TO_FILL, dPrice,
    //       MnmIds.MNM_TRIGGER_PRICE, dPrice,

    //       MnmIds.MNM_TRADE_ROUTE, oRoutes[0],
    //       MnmIds.MNM_MANUAL_OR_AUTO, Rq.OrderPlacement.MANUAL,
  
    //       MnmIds.MNM_CANCEL_AFTER_SECS, iCanAfter,
    //       MnmIds.MNM_CANCEL_AT_SSBOE, iCanAt,
  
    //       MnmIds.MNM_TARGET_QUANTITY, iBrTargetTks? iQty : undefined,
    //       MnmIds.MNM_TARGET_TICKS, iBrTargetTks,
    //       MnmIds.MNM_STOP_QUANTITY, iQty,
    //       MnmIds.MNM_STOP_TICKS, iBrStopTks? iQty : undefined,
  
    //       MnmIds.MNM_USER_MSG, oAccData.key + sToken,
  
    //       MnmIds.MNM_TEMPLATE_ID, (iBrTargetTks || iBrStopTks)? TemplateId.BRACKET_ORDER_REQUEST : TemplateId.NEW_ORDER_REQUEST,
    //       ));
    //   break;
    }

  return(false);
}

/*   -------------------------------------------------------------------   */

public Rq_CancelAllOrdersAcc(sAccKey     : string | undefined,
                             sWindowName : string)
{
if (__DEV__)  
  Utilities.Sendlog("Canceling all orders=> account: " + sAccKey);

if (sAccKey == undefined)
  {
  alert("account not found");

  if (__DEV__)
    Utilities.Sendlog("Canceling all orders=>account not found: " + sAccKey);
  return;
  }

let oAccData = Connection.oAccStore.get(sAccKey);

if (oAccData == undefined)
  {
  alert("account not found");

  if (__DEV__)
    Utilities.Sendlog("Canceling all orders=>account not found");
  return;
  }

this.Send(Utilities.GetMergedMsg(

MnmIds.MNM_FCM_ID, oAccData.fcm_id,
MnmIds.MNM_IB_ID, oAccData.ib_id,
MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,

MnmIds.MNM_MANUAL_OR_AUTO, Rq.OrderPlacement.MANUAL,
MnmIds.MNM_USER_TYPE, Rq.UserType.USER_TYPE_TRADER,

MnmIds.MNM_USER_MSG, sAccKey,
MnmIds.MNM_WINDOW_NAME, sWindowName,

MnmIds.MNM_TEMPLATE_ID, TemplateId.CANCEL_ALL_ORDERS_REQUEST,
));
}

/*   -------------------------------------------------------------------   */

public Rq_CancelOrder(sAccKey    : string | undefined,
                      sBasketId  : string,
                      sWindowName: string)
{
if (__DEV__)  
  Utilities.Sendlog("Canceling order=> account: " + sAccKey + " basket: " + sBasketId);  

if (sAccKey == undefined)
  {
    alert("account not found");

    if (__DEV__)
      Utilities.Sendlog("Canceling order=>account not found: " + sAccKey);
    return;
  }

let oAccData = Connection.oAccStore.get(sAccKey);

if (oAccData == undefined)
  {
  alert("account not found");    

  if (__DEV__)
    Utilities.Sendlog("Canceling order=>account not found");
  return;
  }

this.Send(Utilities.GetMergedMsg(

    MnmIds.MNM_FCM_ID, oAccData.fcm_id,
    MnmIds.MNM_IB_ID, oAccData.ib_id,
    MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,

    MnmIds.MNM_BASKET_ID, sBasketId,

    MnmIds.MNM_MANUAL_OR_AUTO, Rq.OrderPlacement.MANUAL,


    MnmIds.MNM_USER_MSG, sBasketId,
    MnmIds.MNM_WINDOW_NAME, sWindowName,

    MnmIds.MNM_TEMPLATE_ID, TemplateId.CANCEL_ORDER_REQUEST,
    ));
}

/*   -------------------------------------------------------------------   */

public Rq_LinkOrders(sAccKey : string | undefined,
                     oOrders : OrdData[])
{
if (__DEV__)  
  Utilities.Sendlog("Linking orders=> " + oOrders.length);  

if (sAccKey == undefined)
  {
    alert("account not found");

    if (__DEV__)
      Utilities.Sendlog("Canceling order=>account not found: " + sAccKey);
    return;
  }

let oAccData = Connection.oAccStore.get(sAccKey);

if (oAccData == undefined)
  {
  alert("account not found");    

  if (__DEV__)
    Utilities.Sendlog("Canceling order=>account not found");
  return;
  }

let oReq : any[] = Array(0);

for (let i = 0; i < oOrders.length; i++)
  {
  oReq.push(MnmIds.MNM_FCM_ID);
  oReq.push(oAccData.fcm_id);

  oReq.push(MnmIds.MNM_IB_ID);
  oReq.push(oAccData.ib_id);

  oReq.push(MnmIds.MNM_ACCOUNT_ID);
  oReq.push(oAccData.acc_id);

  oReq.push(MnmIds.MNM_ACCOUNT_ID);
  oReq.push(oAccData.acc_id);

  oReq.push(MnmIds.MNM_BASKET_ID);
  oReq.push(oOrders[i].basket_id);
  }

oReq.push(MnmIds.MNM_TEMPLATE_ID);
oReq.push(TemplateId.LINK_ORDERS_REQUEST);


this.Send(Utilities.GetMergedMsg(
    ...oReq
    ));
}

/*   -------------------------------------------------------------------   */

public Rq_ModifyOrder(sAccKey    : string | undefined,
                      sBasketId  : string,
                      dNewPrice  : number,
                      sWindowName: string)
{
if (__DEV__)  
  Utilities.Sendlog("Modifying order=> account: " + sAccKey + " basket: " + sBasketId + " price: " + dNewPrice);  

if (sAccKey == undefined)
{
alert("account not found");  

if (__DEV__)
  Utilities.Sendlog("Modifying order=>account not found: " + sAccKey);
return;
}

let oAccData = Connection.oAccStore.get(sAccKey);

if (oAccData == undefined)
{
alert("account not found");  

if (__DEV__)
  Utilities.Sendlog("Modifying order=>account not found");
return;
}

let oOrdData = Connection.oOrdStore.get(sBasketId);

if (oOrdData == undefined)
{
alert("order not found");  

if (__DEV__)
  Utilities.Sendlog("Modifying order=>order not found");
return;
}

let iNum = MnmIds.MNM_PRICE_TO_FILL;

switch (oOrdData.price_type_api)
  {
  case Rq.PriceType.MARKET:
  default:
    return;
  case Rq.PriceType.LIMIT:
    this.Send(Utilities.GetMergedMsg(

      MnmIds.MNM_FCM_ID, oAccData.fcm_id,
      MnmIds.MNM_IB_ID, oAccData.ib_id,
      MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,
      
      MnmIds.MNM_BASKET_ID, sBasketId,
      MnmIds.MNM_SYMBOL, oOrdData.symbol,
      MnmIds.MNM_EXCHANGE, oOrdData.exchange,
      MnmIds.MNM_PRICE_TYPE, oOrdData.price_type_api,
      
      MnmIds.MNM_PRICE_TO_FILL, dNewPrice,
      
      MnmIds.MNM_MANUAL_OR_AUTO, Rq.OrderPlacement.MANUAL,
      
      
      MnmIds.MNM_USER_MSG, sBasketId,
      MnmIds.MNM_WINDOW_NAME, sWindowName,

      MnmIds.MNM_TEMPLATE_ID, TemplateId.MODIFY_ORDER_REQUEST,
      ));
    break;
  case Rq.PriceType.LIMIT_IF_TOUCHED:
  case Rq.PriceType.STOP_LIMIT:
      this.Send(Utilities.GetMergedMsg(

        MnmIds.MNM_FCM_ID, oAccData.fcm_id,
        MnmIds.MNM_IB_ID, oAccData.ib_id,
        MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,
        
        MnmIds.MNM_BASKET_ID, sBasketId,
        MnmIds.MNM_SYMBOL, oOrdData.symbol,
        MnmIds.MNM_EXCHANGE, oOrdData.exchange,
        MnmIds.MNM_PRICE_TYPE, oOrdData.price_type_api,
        
        MnmIds.MNM_PRICE_TO_FILL, dNewPrice,
        MnmIds.MNM_TRIGGER_PRICE, dNewPrice,
        
        MnmIds.MNM_MANUAL_OR_AUTO, Rq.OrderPlacement.MANUAL,
        
        
        MnmIds.MNM_USER_MSG, sBasketId,
        MnmIds.MNM_WINDOW_NAME, sWindowName,

        MnmIds.MNM_TEMPLATE_ID, TemplateId.MODIFY_ORDER_REQUEST,
        ));
      break;
  case Rq.PriceType.MARKET_IF_TOUCHED:
  case Rq.PriceType.STOP_MARKET:
    this.Send(Utilities.GetMergedMsg(

      MnmIds.MNM_FCM_ID, oAccData.fcm_id,
      MnmIds.MNM_IB_ID, oAccData.ib_id,
      MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,
      
      MnmIds.MNM_BASKET_ID, sBasketId,
      MnmIds.MNM_SYMBOL, oOrdData.symbol,
      MnmIds.MNM_EXCHANGE, oOrdData.exchange,
      MnmIds.MNM_PRICE_TYPE, oOrdData.price_type_api,
      
      MnmIds.MNM_PRICE_TO_FILL, oOrdData.limit_price,
      MnmIds.MNM_TRIGGER_PRICE, dNewPrice,
      
      MnmIds.MNM_MANUAL_OR_AUTO, Rq.OrderPlacement.MANUAL,
      
      
      MnmIds.MNM_USER_MSG, sBasketId,
      MnmIds.MNM_WINDOW_NAME, sWindowName,

      MnmIds.MNM_TEMPLATE_ID, TemplateId.MODIFY_ORDER_REQUEST,
      ));
    break;
  }


}

/*   -------------------------------------------------------------------   */

public Rq_ModifyBkt(sAccKey    : string | undefined,
                    sBasketId  : string,
                    iLevel     : number,
                    oData      : OrdData,
                    sWindowName: string)
{
if (__DEV__)  
  Utilities.Sendlog("Modifying order br=> account: " + sAccKey + " basket: " + sBasketId);  

if (sAccKey == undefined)
  {
  alert("account not found");  

  if (__DEV__)
    Utilities.Sendlog("Modifying order=>account not found: " + sAccKey);
  return;
  }

let oAccData = Connection.oAccStore.get(sAccKey);

if (oAccData == undefined)
  {
  alert("account not found");  

  if (__DEV__)
    Utilities.Sendlog("Modifying order=>account not found");
  return;
  }

let oOrdData = Connection.oOrdStore.get(sBasketId);

if (oOrdData == undefined)
  {
  alert("order not found");  

  if (__DEV__)
    Utilities.Sendlog("Modifying order=>order not found");
  return;
  }

  if (oData.price_type_api == Rq.PriceType.LIMIT)
      this.Send(Utilities.GetMergedMsg(

      MnmIds.MNM_FCM_ID, oAccData.fcm_id,
      MnmIds.MNM_IB_ID, oAccData.ib_id,
      MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,
      
      MnmIds.MNM_BASKET_ID, sBasketId,

      MnmIds.MNM_LEVEL, oData.oBrData?.level,
      MnmIds.MNM_TARGET_TICKS, iLevel,
      
      MnmIds.MNM_USER_MSG, sBasketId,
      MnmIds.MNM_WINDOW_NAME, sWindowName,

      MnmIds.MNM_TEMPLATE_ID, TemplateId.UPDATE_TARGET_BRACKET_LEVEL_REQUEST,
      ));
  else
      this.Send(Utilities.GetMergedMsg(

      MnmIds.MNM_FCM_ID, oAccData.fcm_id,
      MnmIds.MNM_IB_ID, oAccData.ib_id,
      MnmIds.MNM_ACCOUNT_ID, oAccData.acc_id,
      
      MnmIds.MNM_BASKET_ID, sBasketId,

      MnmIds.MNM_LEVEL, oData.oBrData?.level,
      MnmIds.MNM_STOP_TICKS, iLevel,
      
      
      MnmIds.MNM_USER_MSG, sBasketId,
      MnmIds.MNM_WINDOW_NAME, sWindowName,

      MnmIds.MNM_TEMPLATE_ID, TemplateId.UPDATE_STOP_BRACKET_LEVEL_REQUEST,
      ));


}

/*   -------------------------------------------------------------------   */

public Rq_CancelAllOrders(oData      : PosData | undefined,
                          sWindowName: string)
{
if (__DEV__)  
  Utilities.Sendlog("Canceling orders=> ...");  

if (oData == undefined)
  {
  alert("account not found");    

  if (__DEV__)
    Utilities.Sendlog("Canceling orders=>account not found");
  return;
  }

/*   -------------------------------------------------------------------   */  

if (oData.orders_working.length == 0)
  {
  if (__DEV__)    
    Utilities.Sendlog("Canceling orders=>no orders to cancel");
  return;
  }

/*   -------------------------------------------------------------------   */

for (let i = 0; i < oData.orders_working.length; i++)
  this.Rq_CancelOrder(oData.acc_key, oData.orders_working[i], sWindowName);  
}

/*   -------------------------------------------------------------------   */

public Rq_ReversePosition(sToken     : string,
                          oPosData   : PosData | undefined,
                          sWindowName: string)
{
if (__DEV__)  
  Utilities.Sendlog("Reversing Pos=> ...");  

if (oPosData == undefined)
  {
  alert("account not found");    

  if (__DEV__)
    Utilities.Sendlog("Reversing Pos=>account not found");
  return;
  }

/*   -------------------------------------------------------------------   */  

if (oPosData.net_qty == undefined)
  {
  alert("account data not available");    

  if (__DEV__)
    Utilities.Sendlog("Reversing Pos=>net qty is undefined");
  return;
  }  

/*   -------------------------------------------------------------------   */  

if (oPosData.net_qty == 0)
  {
  if (__DEV__)    
    Utilities.Sendlog("Reversing Pos=>net qty is zero");
  return;
  }

/*   -------------------------------------------------------------------   */  

ConnectionOrd.oConn?.Rq_PlaceOrder(oPosData.acc_key,
                                   sToken,
                                   oPosData.net_qty < 0?
                                   Rq.TransactionType.BUY: 
                                   Rq.TransactionType.SELL,
                                   Math.abs(2 * oPosData.net_qty),
                                   sWindowName);

}

/*   -------------------------------------------------------------------   */

private static LoginResponseOrd(keys, values) 
{
if (Connection.getResonseCodeLogin(keys, 
                                   values,
                                   ConnectionOrd.oConn) == Connection.NO_ERROR)
    {
    //ConnectionOrd.oConn?.ResetRetry();

    if (ConnectionOrd.oConn?.GetLoginStatus() == true)
      {
      if (__DEV__)        
        Utilities.Sendlog("Order already logged in");  
      return;
      }

    /*   -----------------------------------------------------------------   */

    for (let i = 0; i < keys.length; i++)
    {
      switch(keys[i])
        {
        case MnmIds.MNM_FCM_ID:
          ConnectionOrd.sFCMId = values[i];
          break;
        case MnmIds.MNM_IB_ID:
          ConnectionOrd.sIBId = values[i];
          break;
        case MnmIds.MNM_USER_TYPE:
          ConnectionOrd.iUserType = values[i];
          break;
        // case MnmIds.MNM_UNIQUE_USER_ID:
        //   if (ConnectionOrd.oConn)
        //     ConnectionOrd.oConn.sLastLogin = values[i];
        //   break;
        }          
    }

    /*   -----------------------------------------------------------------   */

    // alert(ConnectionOrd.sFCMId + "/" + ConnectionOrd.sIBId + "/" + ConnectionOrd.iUserType);
    

    // sLogin_State = "Sign out"
    // setStatus(sLogin_State);
    // setMktStatus(true);
  
    //setStatus("Sign out");
    //setBarStatus(true);

    ConnectionOrd.oConn?.SetLoginStatus(true);

    if (__DEV__)
      Utilities.Sendlog("Order login status: " + ConnectionOrd.oConn?.GetLoginStatus());

    // CompleteLoginOrd();

    //alert("getting user settings...");

    ConnectionOrd.oConn?.Rq_OrderSessionConfig();
    ConnectionOrd.oConn?.SendLoginInfo();
    ConnectionOrd.oConn?.Rq_GetAccounts();
    ConnectionOrd.oConn?.Rq_GetAccountRMS();
    ConnectionOrd.oConn?.Rq_GetRoutes();

    if (__DEV__)    
      Utilities.Sendlog("Order=> ***Settings type*** - local: " + Connection.bSettingsLocal)

    if (Connection.bSettingsLocal == false)
      {
      ConnectionOrd.oConn?.Rq_GetUserSettings(Connection.DEVICE_NAME);
      }
    else
      {
      ConnectionOrd.SaveSettings();
      }

    ConnectionOrd.oConn?.oOnAlert(ConnectionOrd.oConn, 
                                  Connection.MSG_LOGIN_SUCCESS,
                                  null);


    ConnectionOrd.oConn?.ResetRetry();
    }
  else
    {
    if (__DEV__)
      Utilities.Sendlog("Order login failure...");
    ConnectionOrd.oConn?.NoRetry();

    ConnectionOrd.oConn?.oOnAlert(ConnectionOrd.oConn, 
                                  Connection.MSG_LOGIN_FAIL,
                                  null);

    // setUsrInvalid(true);
    // setPwdInvalid(true);
    // CloseConnection();
    }  
}

/*   ---------------------------------------------------------------------   */

static ApplyReOrder(oStore    : Map<any, any>,
                    oSettings : any[])
{
  Connection.oSettings = oSettings;
  Connection.oStore    = oStore;

  if (__DEV__)  
    Utilities.Sendlog("apply reorder...");

  if (ConnectionMkt.oConn)
    Connection.oOnGenAlert(ConnectionMkt.oConn, Connection.MSG_APPLY_REORDER);

  ConnectionOrd.SaveSettings()

  //alert("first: " + Connection.oSettings[0].token);

}

/*   ---------------------------------------------------------------------   */

static async NavigateTo(iIndex : number)
{
if (ConnectionMkt.oConn)  
  Connection.oOnGenAlert(ConnectionMkt.oConn, 
                         Connection.MSG_NAVIGATE_TO, 
                         iIndex);
}

/*   ---------------------------------------------------------------------   */

static async NavigateToToken(sToken : string)
{
if (ConnectionMkt.oConn)  
  {
  let z = Utilities.FindItem(Connection.oSettings, sToken);

  if (z != AppMain.IMAGINARY)
    Connection.oOnGenAlert(ConnectionMkt.oConn, 
                           Connection.MSG_NAVIGATE_TO, 
                           z);
  }
}

/*   ---------------------------------------------------------------------   */

static async ChangeTheme(oTheme : UTheme)
{
if (ConnectionMkt.oConn)  
  Connection.oOnGenAlert(ConnectionMkt.oConn, 
                         Connection.MSG_CHANGE_THEME, 
                         oTheme);
}

/*   ---------------------------------------------------------------------   */

static async ChangeFont()
{
if (ConnectionMkt.oConn)  
  Connection.oOnGenAlert(ConnectionMkt.oConn, 
                         Connection.MSG_CHANGE_FONT);
}

/*   ---------------------------------------------------------------------   */

static async SaveAppSettings()
{
if (ConnectionMkt.oConn)  
  Connection.oOnGenAlert(ConnectionMkt.oConn, 
                         Connection.MSG_APP_SETTINGS);
}

/*   ---------------------------------------------------------------------   */

static async RequestReview()
{
if (ConnectionMkt.oConn)  
  Connection.oOnGenAlert(ConnectionMkt.oConn, 
                         Connection.MSG_REQ_REVIEW);
}

/*   ---------------------------------------------------------------------   */

static async SetDefSymbol(sSymbol : string | undefined)
{
if (AppMain.sDef_Symbol == sSymbol)
  return;

AppMain.sDef_Symbol = sSymbol;

if (ConnectionMkt.oConn)  
  Connection.oOnGenAlert(ConnectionMkt.oConn, 
                         Connection.MSG_APP_SETTINGS);
}

/*   ---------------------------------------------------------------------   */

static async ChangeBackground(bValue : boolean)
{
if (FontInfo.bDarkMode == bValue)
  return;

FontInfo.ChangeMode(bValue);

if (ConnectionMkt.oConn)  
  Connection.oOnGenAlert(ConnectionMkt.oConn, 
                         Connection.MSG_UPDATE_BG);
}

/*   ---------------------------------------------------------------------   */

static async ChangeEventTradeAdv(bValue : boolean)
{
if (AppMain.bEventTradeAdv == bValue)
  return;

AppMain.bEventTradeAdv = bValue;

//not working
// if (ConnectionOrd.oConn)
//   {
//   let oSett : IAppSettings = {bEventTradingAdv: bValue};

//   ConnectionOrd.Rq_SetAppSettings(Connection.DEVICE_NAME, 
//                                   JSON.stringify(oSett));
//   }

if (ConnectionMkt.oConn)  
  Connection.oOnGenAlert(ConnectionMkt.oConn, 
                         Connection.MSG_UPDATE_EVT_ADV);
}

/*   ---------------------------------------------------------------------   */

static async ChangeReconnType(iValue : number)
{
if (Connection.iReconType == iValue)
  return;

/*   ---------------------------------------------------------------------   */  

Connection.iReconType = iValue;

/*   ---------------------------------------------------------------------   */  

if (Connection.iReconType == Connection.RECON_OFF)
  ConnectionMkt.oConn?.NoRetry();
else
  ConnectionMkt.oConn?.ResetRetry();

  /*   ---------------------------------------------------------------------   */  

ConnectionOrd.SaveAppSettings();

// if (ConnectionMkt.oConn)  
//   Connection.oOnGenAlert(ConnectionMkt.oConn, 
//                          Connection.MSG_UPDATE_EVT_ADV);
}

/*   ---------------------------------------------------------------------   */

static async ChangeTransparency(bValue : boolean)
{
if (FontInfo.bTransparency == bValue)
  return;

FontInfo.ChangeTransparency(bValue);

if (ConnectionMkt.oConn)  
  Connection.oOnGenAlert(ConnectionMkt.oConn, 
                         Connection.MSG_UPDATE_BG);
}

/*   ---------------------------------------------------------------------   */

static async UpdateFont()
{
if (ConnectionMkt.oConn)  
  Connection.oOnGenAlert(ConnectionMkt.oConn, 
                         Connection.MSG_UPDATE_FONT);
}

/*   ---------------------------------------------------------------------   */

static ShowSearch(sToken : any)
{
if (ConnectionMkt.oConn)  
  Connection.oOnGenAlert(ConnectionMkt.oConn, 
                         Connection.MSG_SHOW_SEARCH,
                         sToken);
}

/*   ---------------------------------------------------------------------   */

// static IsLoggedIn() : boolean
// {
// if (ConnectionOrd.oConn)
//   return(ConnectionOrd.oConn?.GetLoginStatus());
// else
//   return(false);
// }

/*   -------------------------------------------------------------------   */

// static GetSettings()
// {
// for (let i = 0, j = Connection.oSettings.length; i < j; i++)
// Connection.oSettings
// }

/*   -------------------------------------------------------------------   */

  public static CopyOrdDefault(oSource : OrdDefault,
                               oTarget : OrdDefault)
  {
    oTarget.cancel_after_en  = oSource.cancel_after_en;
    oTarget.cancel_after_sec = oSource.cancel_after_sec;
  
    oTarget.cancel_at_en     = oSource.cancel_at_en;
    oTarget.cancel_at_hr     = oSource.cancel_at_hr;
    oTarget.cancel_at_min    = oSource.cancel_at_min;
    oTarget.cancel_at_sec    = oSource.cancel_at_sec;
    //oTarget.cancel_at_type   = oSource.cancel_at_type;
    //oTarget.cancel_at_err    = oSource.cancel_at_err;
  
    oTarget.bracket_target_en  = oSource.bracket_target_en;
    oTarget.bracket_target_tks = oSource.bracket_target_tks;

    oTarget.bracket_stop_en    = oSource.bracket_stop_en;
    oTarget.bracket_stop_tks   = oSource.bracket_stop_tks;
  
    oTarget.bracket_stop_trl   = oSource.bracket_stop_trl;

    return(oTarget);
  }

  /*   -------------------------------------------------------------------   */

  public static CopyOrdCurrent(oSource : OrdDefault,
                               oTarget : OrdDefault)
  {
    // oTarget.cancel_after_en  = oSource.cancel_after_en;
    oTarget.cancel_after_sec = oSource.cancel_after_sec;
  
    // oTarget.cancel_at_en     = oSource.cancel_at_en;
    // oTarget.cancel_at_hr     = oSource.cancel_at_hr;
    // oTarget.cancel_at_min    = oSource.cancel_at_min;
    // oTarget.cancel_at_sec    = oSource.cancel_at_sec;
    //oTarget.cancel_at_type   = oSource.cancel_at_type;
    //oTarget.cancel_at_err    = oSource.cancel_at_err;
  
    // oTarget.bracket_target_en  = oSource.bracket_target_en;
    oTarget.bracket_target_tks = oSource.bracket_target_tks;

    // oTarget.bracket_stop_en    = oSource.bracket_stop_en;
    oTarget.bracket_stop_tks   = oSource.bracket_stop_tks;
  
    // oTarget.bracket_stop_trl   = oSource.bracket_stop_trl;

    return(oTarget);
  }

  /*   -------------------------------------------------------------------   */

  public static CopyChtCurrent(oSource : IChartSettings,
                               oTarget : IChartSettings)
  {
    oTarget.iChartType = oSource.iChartType;
    oTarget.iColIndex  = oSource.iColIndex;
    oTarget.iLineWidth = oSource.iLineWidth;
  
    if (oSource.oIndicators2)
      {
      oTarget.oIndicators2 = new Array(0);

      for (let i = 0; i < oSource.oIndicators2.length; i++)
        {
        oTarget.oIndicators2.push({
                                 iId: oSource.oIndicators2[i].iId,
                                 iPeriod1: oSource.oIndicators2[i].iPeriod1,
                                 iPeriod2: oSource.oIndicators2[i].iPeriod2,
                                 iPeriod3: oSource.oIndicators2[i].iPeriod3,
                                 });
        }
      }

    return(oTarget);
  }

  /*   -------------------------------------------------------------------   */

  public static GetCurrFromDefault(oDefault : OrdDefault | undefined,
                                   oCurrent : OrdDefault)
  {
    if (oDefault?.cancel_after_en)
      {
      oCurrent.cancel_after_en  = oDefault.cancel_after_en;
      oCurrent.cancel_after_sec = oDefault.cancel_after_sec;
      }
      
    if (oDefault?.cancel_at_en)
      {
      oCurrent.cancel_at_en     = oDefault.cancel_at_en;
      oCurrent.cancel_at_hr     = oDefault.cancel_at_hr;
      oCurrent.cancel_at_min    = oDefault.cancel_at_min;
      oCurrent.cancel_at_sec    = oDefault.cancel_at_sec;
      //oCurrent.cancel_at_type   = oDefault.cancel_at_type;
      //oCurrent.cancel_at_err    = oDefault.cancel_at_err;
      }
    else
      {
      let oDt                 = new Date(Date.now());
      oCurrent.cancel_at_hr   = oDt.getHours();
      oCurrent.cancel_at_min  = oDt.getMinutes();
      oCurrent.cancel_at_sec  = 0;
      }
  
    if (oDefault?.bracket_target_en)
      {
      oCurrent.bracket_target_en  = oDefault.bracket_target_en;
      oCurrent.bracket_target_tks = oDefault.bracket_target_tks;
      }

    if (oDefault?.bracket_stop_en)
      {
      oCurrent.bracket_stop_en    = oDefault.bracket_stop_en;
      oCurrent.bracket_stop_tks   = oDefault.bracket_stop_tks;
      }
  
    if (oDefault?.bracket_stop_trl)
      oCurrent.bracket_stop_trl   = oDefault.bracket_stop_trl;

    return(oCurrent);
  }

  /*   -------------------------------------------------------------------   */

  public static GetCurrFromCurrent(oSvCurrent : OrdDefault | undefined,
                                   oCurrent   : OrdDefault)
  {
  if (!oSvCurrent)
    return(oCurrent);

  oCurrent.cancel_after_sec   = oSvCurrent.cancel_after_sec;
    
  oCurrent.bracket_target_tks = oSvCurrent.bracket_target_tks;

  oCurrent.bracket_stop_tks   = oSvCurrent.bracket_stop_tks;

  return(oCurrent);
  }

  /*   -------------------------------------------------------------------   */

static SaveSettings(sToken               : string | null = null, 
                    bRemove              : boolean       = false,
                    sReplaceToken        : string | null = null,
                    bManualAdd           : boolean       = false,
                    oData?               : Data)
{
if (__DEV__)  
  Utilities.Sendlog("SaveSettings=> called");

if (sToken == null)
    {
    ConnectionOrd.Rq_SetUserSettings(Connection.DEVICE_NAME, 
                                     JSON.stringify(ConnectionOrd.oSettings));
    return;    
    } 

if (bRemove == true)
    {
    if (Utilities.FindAndDeleteItem(ConnectionOrd.oSettings, sToken) == true)
      {
      if (__DEV__)        
        Utilities.Sendlog("Removed: " + sToken + " ok");// + JSON.stringify(ConnectionOrd.oSettings));
      }
    }
else
    {
    let z = Utilities.FindItem(ConnectionOrd.oSettings, sToken);

    if (z == AppMain.IMAGINARY)
        {
        if (sReplaceToken)
          {
          z = Utilities.FindItem(ConnectionOrd.oSettings, sReplaceToken);

          if (z != AppMain.IMAGINARY)
            {
            ConnectionOrd.oSettings[z].token = sToken;

            if (__DEV__)
              Utilities.Sendlog("Replaced: " + sReplaceToken + " with " + sToken + " ok");// + JSON.stringify(ConnectionOrd.oSettings));
            return;
            }
          }

        if (bManualAdd == true && AppMain.sDef_Symbol)
          {
          let z         = Utilities.FindItem(ConnectionOrd.oSettings, AppMain.sDef_Symbol);
          let oFromData = Connection.oStore.get(AppMain.sDef_Symbol);

          if (z != AppMain.IMAGINARY && oFromData != undefined)
            {
            let oSett : ISettings = ConnectionOrd.oSettings[z];

            ConnectionOrd.oSettings.push({
                    token: sToken,
                    bConfActions: oSett.bConfActions,
                    iControlPage: oSett.iControlPage,
                    iDefQty: oSett.iDefQty,
                    iDefQtyEvt: oSett.iDefQtyEvt,
                    iLookBack: oFromData.lookback.LookbackType,
                    iOBLevels: oSett.iOBLevels,
                    iPnlType: oSett.iPnlType,
                    iWOType: oSett.iWOType,
                    sAccount: oSett.sAccount,
                    bOBExpanded: oSett.bOBExpanded,

                    oOrdDefaults: oSett.oOrdDefaults? 
                                  ConnectionOrd.CopyOrdDefault(oSett.oOrdDefaults, 
                                                               new OrdDefault()) : undefined,

                    oOrdCurrent: oSett.oOrdCurrent? 
                                 ConnectionOrd.CopyOrdCurrent(oSett.oOrdCurrent, 
                                                              new OrdDefault()) : undefined,

                    oChartSettings: oSett.oChartSettings? 
                                 ConnectionOrd.CopyChtCurrent(oSett.oChartSettings, 
                                                              {}) : undefined,                                                              
                    });

              if (oData)
                {
                oData.lookback   = oFromData.lookback;
                oData.sv_account = oFromData.sv_account;
                }
                    
              if (__DEV__)                
                Utilities.Sendlog("Added: " + sToken + " ok" + " inherited: " + AppMain.sDef_Symbol); // + JSON.stringify(ConnectionOrd.oSettings));

              ConnectionOrd.Rq_SetUserSettings(Connection.DEVICE_NAME, 
                                               JSON.stringify(ConnectionOrd.oSettings));

              return;
            }
          }

        ConnectionOrd.oSettings.push({token:sToken})

        if (__DEV__)
          Utilities.Sendlog("Added: " + sToken + " ok"); // + JSON.stringify(ConnectionOrd.oSettings));
        }
    }

/*   ---------------------------------------------------------------------   */    

ConnectionOrd.Rq_SetUserSettings(Connection.DEVICE_NAME, 
                                 JSON.stringify(ConnectionOrd.oSettings));  
}

/*   ---------------------------------------------------------------------   */

// public static SaveSettingsSymbol(sToken        : string,
//                                  sAccount      : string | undefined,
//                                  iPnlType?     : number,
//                                  iWOType?      : number,
//                                  bConfActions? : boolean,
//                                  iDefQty?      : number,
//                                  iDefQtyEvt?   : number,
//                                  iOBLevels?    : number,
//                                  iControlPage? : number,
//                                  )

public static SaveSettingsSymbol(oSettings : ISettings)
{
if (__DEV__)
  Utilities.Sendlog("SaveSettings Sym=> called");

let z       = Utilities.FindItem(ConnectionOrd.oSettings, oSettings.token);
let bUpdate = false;

if (z == AppMain.IMAGINARY)
  return;

let oSett = ConnectionOrd.oSettings[z];

if (oSettings.sAccount && oSett.sAccount != oSettings.sAccount)
  {
  oSett.sAccount = oSettings.sAccount;
  bUpdate        = true;
  }

if (oSettings.iPnlType != undefined && oSett.iPnlType != oSettings.iPnlType)
  {
  oSett.iPnlType = oSettings.iPnlType;
  bUpdate        = true;
  }

if (oSettings.iWOType != undefined && oSett.iWOType != oSettings.iWOType)
  {
  oSett.iWOType  = oSettings.iWOType;
  bUpdate        = true;
  }

if (oSettings.bConfActions != undefined && oSett.bConfActions != oSettings.bConfActions)
  {
  oSett.bConfActions = oSettings.bConfActions;
  bUpdate            = true;
  }  

if (oSettings.iDefQty != undefined && oSett.iDefQty != oSettings.iDefQty)
  {
  oSett.iDefQty = oSettings.iDefQty;
  bUpdate       = true;
  }  

if (oSettings.iDefQtyEvt != undefined && oSett.iDefQtyEvt != oSettings.iDefQtyEvt)
  {
  oSett.iDefQtyEvt = oSettings.iDefQtyEvt;
  bUpdate          = true;
  }    

if (oSettings.iOBLevels != undefined && oSett.iOBLevels != oSettings.iOBLevels)
  {
  oSett.iOBLevels  = oSettings.iOBLevels;
  bUpdate          = true;
  }      

/*   ---------------------------------------------------------------------   */    

if (oSettings.iControlPage != undefined && oSett.iControlPage != oSettings.iControlPage)
  {
  oSett.iControlPage = oSettings.iControlPage;
  bUpdate            = true;
  }      

/*   ---------------------------------------------------------------------   */    

if (oSettings.oOrdDefaults)
  {
  oSett.oOrdDefaults = oSettings.oOrdDefaults;
  bUpdate            = true;
  }      

/*   ---------------------------------------------------------------------   */    

if (oSettings.oOrdCurrent)
  {
  oSett.oOrdCurrent = oSettings.oOrdCurrent;
  bUpdate           = true;
  }      

/*   ---------------------------------------------------------------------   */    

if (oSettings.oChartSettings       &&
    (oSett.oChartSettings?.iChartType  != oSettings.oChartSettings.iChartType ||
     oSett.oChartSettings?.iColIndex   != oSettings.oChartSettings.iColIndex  ||
     oSett.oChartSettings?.iLineWidth  != oSettings.oChartSettings.iLineWidth ||
     ConnectionOrd.IsIndicatorChanged(oSett.oChartSettings?.oIndicators2,
                                      oSettings.oChartSettings?.oIndicators2) 
                                     == true))
  {
  oSett.oChartSettings = oSettings.oChartSettings;
  bUpdate              = true;
  }      

/*   ---------------------------------------------------------------------   */    

if (oSettings.bOBExpanded != undefined)
  {
  oSett.bOBExpanded = oSettings.bOBExpanded;
  bUpdate           = true;
  }      

/*   ---------------------------------------------------------------------   */    

if (bUpdate)
  ConnectionOrd.Rq_SetUserSettings(Connection.DEVICE_NAME, 
                                   JSON.stringify(ConnectionOrd.oSettings));  
}

/*   ---------------------------------------------------------------------   */

public static IsIndicatorChanged(oIndsS?      : IIndicator[],
                                 oIndsT?      : IIndicator[])
{
if (oIndsS == undefined)
  {
  if (oIndsT != undefined)
    return(true);
  else  
    return(false);
  }

if (oIndsT == undefined)
  {
  if (oIndsS != undefined)
    return(true);
  else  
    return(false);
  }  

if (oIndsS.length != oIndsT.length)
  return(true);

for (let i = 0; i < oIndsS.length; i++)
  {
  if (!ConnectionOrd.IsIndFound(oIndsS[i], oIndsT))
    return(true);
    
  // if (oIndsS[i].iId          != oIndsT[i].iId      ||
  //     oIndsS[i].iPeriod1     != oIndsT[i].iPeriod1 ||
  //     oIndsS[i].iPeriod2     != oIndsT[i].iPeriod2)
  //   return(true);
  }

return(false);
}

/*   ---------------------------------------------------------------------   */

public static IsIndFound(oIndS : IIndicator,
                         oIndT : IIndicator[])
{
for (let i = 0; i < oIndT.length; i++)
  {
  if (oIndS.iId          == oIndT[i].iId      &&
      oIndS.iPeriod1     == oIndT[i].iPeriod1 &&
      oIndS.iPeriod2     == oIndT[i].iPeriod2 &&
      oIndS.iPeriod3     == oIndT[i].iPeriod3)
    return(true);
  }

return(false);  
}

/*   ---------------------------------------------------------------------   */

public static GetIndicatorList(iIndicator : number | undefined,
                               iPeriod1   : number,
                               iPeriod2   : number,
                               iPeriod3   : number)
{
if (iIndicator == undefined)
  return(undefined);

 let oInds : IIndicator[]  = new Array(0);

 oInds.push({iId: iIndicator, 
             iPeriod1: iPeriod1,
             iPeriod2: iPeriod2,
             iPeriod3: iPeriod3,
             });
            //  iPeriodIndex: iPeriodIndex == undefined? 0:iPeriodIndex});
 
 return(oInds);
}

/*   ---------------------------------------------------------------------   */

// public static SaveSettingsLB(sToken       : string,
//                              iLBType      : number | undefined
//                              )
                          
// {
// Utilities.Sendlog("SaveSettings LB=> called");

// let z       = Utilities.FindItem(ConnectionOrd.oSettings, sToken);
// let bUpdate = false;

// if (z == AppMain.IMAGINARY)
//   return;

// let oSett = ConnectionOrd.oSettings[z];

// if (iLBType && oSett.iLBType != iLBType)
//   {
//   oSett.iLBType = iLBType;
//   bUpdate       = true;
//   }

// /*   ---------------------------------------------------------------------   */    

// if (bUpdate)
//   ConnectionOrd.SetUserSettings(Connection.DEVICE_NAME, 
//                                 JSON.stringify(ConnectionOrd.oSettings));
// }

/*   ---------------------------------------------------------------------   */

static SaveSettingsWithReplace(sNewToken     : string, 
                               sReplaceToken : string)
{
if (__DEV__)  
  Utilities.Sendlog("SaveSettingsWithReplace=> called");

Utilities.FindAndDeleteItem(ConnectionOrd.oSettings, sNewToken);

let z = Utilities.FindItem(ConnectionOrd.oSettings, sReplaceToken);

if (z != AppMain.IMAGINARY)
  {
  ConnectionOrd.oSettings[z].token = sNewToken;

  if (__DEV__)
    Utilities.Sendlog("Replaced: " + sReplaceToken + " with " + sNewToken + " ok"); // + JSON.stringify(ConnectionOrd.oSettings));
  }
else
  {
  ConnectionOrd.oSettings.push({token:sNewToken})

  if (__DEV__)
    Utilities.Sendlog("Added: " + sNewToken + " ok");// + JSON.stringify(ConnectionOrd.oSettings));
  }

/*   ---------------------------------------------------------------------   */    

ConnectionOrd.Rq_SetUserSettings(Connection.DEVICE_NAME, 
                                 JSON.stringify(ConnectionOrd.oSettings));  
}

/*   ---------------------------------------------------------------------   */

private static CompleteGetSettings(keys, values) : boolean
{
  if (__DEV__)
    Utilities.Sendlog("Order=> Got settings..." + Utilities.GetKeyValueString(keys, values));

  let bReturn             = false;
  

  for (let i = 0; i < keys.length; i++)
  {
  switch(keys[i])
    {
    case MnmIds.MNM_RESPONSE_CODE:
      Connection.bGotSettings = true;
      bReturn                 = true;
      break;
    case MnmIds.MNM_USER_SETTINGS:
      let settings = JSON.parse(values[i]);

      if (__DEV__)
        Utilities.Sendlog("Order=> **parsed settings=> ok");// + JSON.stringify(settings));

      //if (settings.length > 0)
          {
          Connection.oSettings = settings;

          if (Connection.DEVICE_NAME != Connection.DEVICE_WEB)
            this.SaveWindowsLocal(values[i]);
          }

      break;
    }
  }

//   if (ConnectionMkt.oConn != null)
//     {
//     //alert("Market assertion failed");
//     //console.trace();
//     return;
//     }

  //StartMkt();
  //Utilities.Sendlog("Getting symbol ref data...");

  // ConnectionMkt.getSymbols().forEach (oItem =>
  //   {
  //   GetSymbolInfo(oItem.token, "auto");
  //   });
  return(bReturn);
}

/*   ---------------------------------------------------------------------   */

static ProcessRoutes(keys, values)
{
  let sFCM, sIB, sExchange, sRoute, oDefault;

  /*   -------------------------------------------------------------------   */

  for (let i = 0, j = keys.length; i < j; i++)  
  {
  switch (keys[i])
    {
    case MnmIds.MNM_FCM_ID:
      sFCM = values[i];
      break;
    case MnmIds.MNM_IB_ID:
      sIB = values[i];
      break;
    case MnmIds.MNM_EXCHANGE:
      sExchange = values[i];
      break;
    case MnmIds.MNM_DEFAULT_ROUTE:
      oDefault = values[i];
      break;
    case MnmIds.MNM_TRADE_ROUTE:
      sRoute = values[i];
      break;
    }
  }

  /*   -------------------------------------------------------------------   */

  if (sFCM && sIB && sExchange && sRoute)
    {
    let key    = sFCM + sIB + sExchange;
    let routes = Connection.oRoutes.get(key);

    if (routes == undefined)
      {
      routes = new Array(0);
      Connection.oRoutes.set(key, routes);
      }

    if (oDefault)
      routes.unshift(sRoute);
    else
      routes.push(sRoute);
    }
}

/*   ---------------------------------------------------------------------   */

static ProcessAccounts(tokens, keys, values)
{
  let [, , fcm, ib, account, ] = tokens;

  if (account != undefined && fcm != undefined && ib != undefined)
    {
    let key      = fcm + ib + account;
    let oAccData = new AccData(fcm, ib, account, key);

    //alert(key);

    for (let i = 0; i < keys.length; i++)
    {
      switch(keys[i])
        {
        case MnmIds.MNM_ACCOUNT_CURRENCY:
          oAccData.currency = values[i];

          if (__DEV__)
            Utilities.Sendlog("Currency: " + values[i]);
          break;

        case MnmIds.MNM_AUTO_LIQ_THRESHOLD_CURRENT_VALUE:
          {
          //oAccData.altv = Number(values[i]);
          }
          break;

        }
    }

    ConnectionOrd.oAccStore.set(key, oAccData)

    ConnectionOrd.oConn?.Rq_GetOrders(oAccData);
    //ConnectionOrd.oConn?.Rq_GetAccountRMS(oAccData);
    ConnectionOrd.oConn?.Rq_SubscribeRMS(oAccData);

    if (ConnectionRMS.oConn?.GetLoginStatus() == true)
      {
      ConnectionRMS.oConn?.Rq_Subscribe(oAccData);
      oAccData.sub_pnl = true;
      }
    }
}

/*   ---------------------------------------------------------------------   */

public Rq_SubscribeRMS(oData : AccData)
{
return;

Utilities.Sendlog("Subscribing for RMS Updates=> " + oData.key);

this.Send(Utilities.GetMergedMsg(
  MnmIds.MNM_FCM_ID, oData.fcm_id,
  MnmIds.MNM_IB_ID, oData.ib_id,
  MnmIds.MNM_ACCOUNT_ID, oData.acc_id,


  MnmIds.MNM_MESSAGE_ID, 1, //altv

  MnmIds.MNM_USER_MSG, oData.key,

  MnmIds.MNM_REQUEST,  'subscribe',
  MnmIds.MNM_TEMPLATE_ID, TemplateId.RMS_UPDATES_REQUEST,
  ));

}

/*   -------------------------------------------------------------------   */

static ProcessBrackets(keys, values, tokens)
{
  let [symbol, exchange, fcm, ib, account, basket_id] = tokens;

  if (!basket_id)
    return;

  if (__DEV__)
  Utilities.Sendlog("Order=> Bracket " + Utilities.GetKeyValueString(keys, values));

  let iQtyS     : number | undefined = undefined;
  let iQtyRelS  : number | undefined = undefined;
  let iTicksS   : number | undefined = undefined;
  let iQtyT     : number | undefined = undefined;
  let iQtyRelT  : number | undefined = undefined;
  let iTicksT   : number | undefined = undefined;

  for (let i = 0, j = keys.length; i < j; i++)  
    {
    switch (keys[i])
      {
      case MnmIds.MNM_STOP_QUANTITY:
        iQtyS = Number(values[i]);
        break;

      case MnmIds.MNM_STOP_TICKS:
        iTicksS = Number(values[i]);
        break;

      case MnmIds.MNM_STOP_QUANTITY_RELEASED:
        iQtyRelS = Number(values[i]);
        break;
      case MnmIds.MNM_TARGET_QUANTITY:
        iQtyT = Number(values[i]);
        break;

      case MnmIds.MNM_TARGET_TICKS:
        iTicksT = Number(values[i]);
        break;

      case MnmIds.MNM_TARGET_QUANTITY_RELEASED:
        iQtyRelT = Number(values[i]);
        break;

      }
    }

  /*   -----------------------------------------------------------   */

  if (iTicksT != undefined)
    {
    if (ConnectionOrd.ProcessBracket(basket_id, 
                                     iQtyT, 
                                     iQtyRelT, 
                                     iTicksT, 
                                     true))
        {
        ConnectionOrd.NotifyOrder(undefined,
                                  undefined, 
                                  undefined, 
                                  undefined,
                                  basket_id);
        }
    }

  if (iTicksS != undefined)
    {
    if (ConnectionOrd.ProcessBracket(basket_id,
                                     iQtyS, 
                                     iQtyRelS, 
                                     iTicksS, 
                                     false))
        {
        ConnectionOrd.NotifyOrder(undefined,
                                  undefined, 
                                  undefined, 
                                  undefined,
                                  basket_id);
        }
    }
}

/*   ---------------------------------------------------------------------   */

static ProcessBracket(sBasketId : string,
                      iQty      : number | undefined,
                      iQtyRel   : number | undefined,
                      iLevel    : number | undefined,
                      bTarget   : boolean)
{
  if (sBasketId == undefined || 
      iQty      == undefined || 
      iQtyRel   == undefined || 
      iLevel    == undefined)
    return(false);

  /*   -----------------------------------------------------------   */

  let oBrData = Connection.oBrackets.get(sBasketId);

  if (oBrData == undefined)
    {
    oBrData = new Bracket();
    Connection.oBrackets.set(sBasketId, oBrData);
    }

  /*   -----------------------------------------------------------   */

  let oBr : BracketData[];

  /*   -----------------------------------------------------------   */

  if (bTarget)
    {
    oBr = oBrData.targets;
    }
  else
    {
    oBr = oBrData.stops;
    }

  /*   -----------------------------------------------------------   */

  let bDelete;
  let oData : BracketData | undefined = undefined;

  if (iQty <= iQtyRel)
    bDelete = true;
  else
    bDelete = false;

  /*   -----------------------------------------------------------   */

  let z = Bracket.Find(oBr, iLevel);

  /*   -----------------------------------------------------------   */  

  if (z == AppMain.IMAGINARY)
    {
    if (bDelete == true)
      {
      if (!oBrData.stops.length && !oBrData.targets.length)
        Connection.oBrackets.delete(sBasketId);

      return(false);
      }

    oData = new BracketData();

    //if (oBr.length == 0)
      oBr.push(oData);

    oBr.sort((a, b) => {return(a.level - b.level)})
    // else
    //   {
    //   for (let i = 0; i < oBr.length; i++)
    //     {
    //     if (iLevel < oBr[i].level)
    //     }
    //   }
      
    }
  else
    {
    if (bDelete == true)
      {
      Bracket.FindAndDelete(oBr, iLevel);

      if (!oBrData.stops.length && !oBrData.targets.length)
        Connection.oBrackets.delete(sBasketId);

      return(true);
      }
    else
      oData = oBr[z];
    }

  /*   -----------------------------------------------------------   */      

  if (oData)
    {
    oData.qty_org = iQty;
    oData.qty_rel = iQtyRel;
    oData.level		= iLevel;
    }

return(true);    
}

/*   ---------------------------------------------------------------------   */

static ProcessOrder(keys, values, tokens, insert=false)
{
  let [symbol, exchange, fcm, ib, account, basket_id, status] = tokens;

  //Utilities.Sendlog("Order=> Brd " + Utilities.GetKeyValueString(keys, values));

  let o_status = status + "";

  if (o_status.endsWith("Failed"))
    {
    return;
    }
  else if (o_status == "Modify received from client" ||
           o_status == "Cancel received from client"	||
           o_status.startsWith ("receipt") == true	||
           o_status.startsWith("wave")    == true	||
           o_status.startsWith("reports") == true)
    {
    return;
    }


  let oOrdData = Connection.oOrdStore.get(basket_id);
  let oPosData : PosData | undefined = undefined;
  let bNew     = false;
  let bUpdate  = false;

  if (oOrdData == undefined)
    {
    //Utilities.Sendlog("Order=>adding new order: "  + basket_id);

    oOrdData = new OrdData();
    Connection.oOrdStore.set(basket_id, oOrdData);

    oOrdData.fcm_id    = fcm;
    oOrdData.ib_id     = ib;
    oOrdData.acc_id    = account;
    oOrdData.acc_key   = fcm + ib + account;

    oOrdData.symbol    = symbol;
    oOrdData.exchange  = exchange;
    oOrdData.token     = symbol + "." + exchange;

    oOrdData.basket_id = basket_id;

    let poskey         = oOrdData.acc_key + oOrdData.token;

    oPosData = Connection.oPosStore.get(poskey);

    if (oPosData == undefined)
      {
      oPosData = new PosData(oOrdData.acc_key, oOrdData.token);
      Connection.oPosStore.set(poskey, oPosData);
      }

    if (insert == false)
      oPosData.orders.push(basket_id);
    else
      oPosData.orders.unshift(basket_id);
      
    bNew = true;

    //Utilities.Sendlog(poskey + " order add: " + basket_id + " token: " + oOrdData.token);
    //   {
    //   let oOrders = oAccData.orders.get(oOrdData.token);

    //   if (oOrders == undefined)
    //     {
    //     oOrders = new Array(0);
    //     oAccData.orders.set(oOrdData.token, oOrders);
    //     }

    //   oOrders.push(basket_id);
    //   }
    }
  else
    oPosData = Connection.oPosStore.get(oOrdData.acc_key + oOrdData.token);

  /*   -------------------------------------------------------------------   */  

  let dOldLimit : number | undefined;
  let sOldLink  : string | undefined;
  let dOldStop  : number | undefined;

  /*   -------------------------------------------------------------------   */    

  for (let i = 0, j = keys.length; i < j; i++)  
    {
    switch (keys[i])
      {
      case MnmIds.MNM_QUANTITY:
        if (oOrdData.qty != values[i])
          bUpdate = true;

        oOrdData.qty = values[i];
        break;

      case MnmIds.MNM_PRICE:
        if (bNew == false)
          dOldLimit = oOrdData.limit_price;

        oOrdData.limit_price = values[i];
        //Utilities.Sendlog(oOrdData.token + " ->" + oOrdData.limit_price);
        break;
          
      case MnmIds.MNM_TRIGGER_PRICE:
        if (bNew == false)
          dOldStop = oOrdData.trigger_price;

        oOrdData.trigger_price = values[i];
        break;
                
      case MnmIds.MNM_TRANSACTION_TYPE:
        oOrdData.txn_type_api = values[i];
        oOrdData.txn_type     = Rq.TransactionType.GetDisplay(values[i]);
        break;

      case MnmIds.MNM_EXCHANGE_ORDER_ID:
        oOrdData.exch_order_id = values[i];
        break;        

      case MnmIds.MNM_TRADE_ROUTE:
        oOrdData.route = values[i];
        break;

      case MnmIds.MNM_PRICE_TYPE:
          oOrdData.price_type_api = values[i];
          oOrdData.price_type     = Rq.PriceType.GetDisplay(values[i]);
        break;
          
      case MnmIds.MNM_AVG_FILL_PRICE:
        oOrdData.fill_price = values[i];
        break;

      case MnmIds.MNM_TEXT:
      case MnmIds.MNM_REPORT_TEXT:
      case MnmIds.MNM_REMARKS:        
        oOrdData.remarks = values[i];
        break;

      case MnmIds.MNM_REPORT_TYPE:
      case MnmIds.MNM_COMPLETION_REASON:
        oOrdData.completion_reason = Rq.CompletionReason.GetDisplay(values[i]);
        break;
    
      case MnmIds.MNM_STATUS:
        oOrdData.status = values[i];
        break;

      case MnmIds.MNM_SECONDS_SINCE_BOE:
        oOrdData.time = values[i];
        break;

      case MnmIds.MNM_BRACKET_TYPE:
        oOrdData.bracket_type = values[i];
        break;

      case MnmIds.MNM_ORIGINAL_BASKET_ID:
        oOrdData.org_basket_id = values[i];
        break;        

      case MnmIds.MNM_LINKED_BASKET_IDS:
        if (bNew == false)
          sOldLink = oOrdData.linked_orders;

        oOrdData.linked_orders = values[i];
        break;
  
      }  
    }

    /*   -----------------------------------------------------------------   */

    // if (oOrdData.price_type_api != Rq.PriceType.MARKET)
    //   {
    //   let oOBData = Connection.oOBStore.get(oOrdData.token);

    //   if (oOBData != undefined)
    //     {
    //     if (bNew == false)
    //       {
    //       switch (oOrdData.price_type_api)
    //         {
    //         case Rq.PriceType.LIMIT:
    //           if (dOldLimit != undefined && dOldLimit != oOrdData.limit_price)
    //             ConnectionOrd.DeleteOrderAtPrice(oOrdData, oOBData, dOldLimit);
    //           break;

    //         default:
    //           if (dOldStop != undefined && dOldStop != oOrdData.trigger_price)
    //             ConnectionOrd.DeleteOrderAtPrice(oOrdData, oOBData, dOldStop);
    //           break;
    //         }
    //       }

    //     /*   -------------------------------------------------------------   */
        
    //     switch (oOrdData.price_type_api)
    //       {
    //       case Rq.PriceType.LIMIT:
    //         ConnectionOrd.AddOrderAtPrice(oOrdData, oOBData, oOrdData.limit_price);
    //         break;

    //       default:
    //         ConnectionOrd.AddOrderAtPrice(oOrdData, oOBData, oOrdData.trigger_price);
    //         break;
    //       }

    //     }
    //   }

  /*   -------------------------------------------------------------------   */    
  
  if (oPosData != undefined)
    {
    if (oOrdData.status == "complete")
      {
      if (oPosData.orders_working.length > 0)
        {
        if (Utilities.FindAndDeleteString(oPosData.orders_working, 
                                          basket_id) == true)
          {
          switch (oOrdData.price_type_api)
            {
            case Rq.PriceType.MARKET:
              ConnectionOrd.NotifyOrder(oPosData.token,
                                        oOrdData, 
                                        oPosData, 
                                        undefined);
              break;
            case Rq.PriceType.LIMIT:
              ConnectionOrd.NotifyOrder(oPosData.token,
                                        oOrdData, 
                                        oPosData, 
                                        oOrdData.limit_price);
              break;

            default:
              ConnectionOrd.NotifyOrder(oPosData.token,
                                        oOrdData, 
                                        oPosData, 
                                        oOrdData.trigger_price);
              break;
            }
          }
        }
      }
    else //open
      {
      if (bNew == true)
        {
        if (insert == false)
          oPosData.orders_working.push(basket_id);
        else
          oPosData.orders_working.unshift(basket_id);

          switch (oOrdData.price_type_api)
            {
            case Rq.PriceType.MARKET:
              break;
            case Rq.PriceType.LIMIT:
              if (dOldLimit != oOrdData.limit_price)
                ConnectionOrd.NotifyOrder(oPosData.token, oOrdData, oPosData, dOldLimit);
              else
                ConnectionOrd.NotifyOrder(oPosData.token, oOrdData, oPosData);
              break;

            default:
              if (dOldStop != oOrdData.trigger_price)
                ConnectionOrd.NotifyOrder(oPosData.token, oOrdData, oPosData, dOldStop);
              else
                ConnectionOrd.NotifyOrder(oPosData.token, oOrdData, oPosData);

              break;
            }
        }
      else //modify
        {
          switch (oOrdData.price_type_api)
          {
          case Rq.PriceType.MARKET:
            break;
          case Rq.PriceType.LIMIT:
            if (dOldLimit != oOrdData.limit_price || sOldLink != oOrdData.linked_orders)
              ConnectionOrd.NotifyOrder(oPosData.token, oOrdData, oPosData, dOldLimit);
            else if (bUpdate == true)
              ConnectionOrd.NotifyOrder(oPosData.token, oOrdData, oPosData);
            break;

          default:
            if (dOldStop != oOrdData.trigger_price || sOldLink != oOrdData.linked_orders)
              ConnectionOrd.NotifyOrder(oPosData.token, oOrdData, oPosData, dOldStop);
            else if (bUpdate = true)
              ConnectionOrd.NotifyOrder(oPosData.token, oOrdData, oPosData);
            break;
          }

        // if (bUpdate                 == true && 
        //     oOrdData.price_type_api != Rq.PriceType.MARKET)
        //   ConnectionOrd.NotifyOrder(oPosData.token, oOrdData, oPosData);
        }
      }
    }

  // let oAccData = Connection.oAccStore.get(acckey);

  // if (oAccData == undefined)
  //   return;
}

/*   ---------------------------------------------------------------------   */

// private static DeleteOrderAtPrice(oOrder : OrdData,
//                                   oOB    : OBData,
//                                   dPrice : number)
// {
// let oBookItem = oOB.FindItem(dPrice);

// if (oBookItem != undefined)
//   Utilities.FindAndDeleteString(oBookItem.orders, oOrder.basket_id);
// }

// /*   ---------------------------------------------------------------------   */

// private static AddOrderAtPrice(oOrder : OrdData,
//                                oOB    : OBData,
//                                dPrice : number | undefined)
// {
// if (dPrice == undefined)
//   return;

// let oBookItem = oOB.FindItem(dPrice);

// if (oBookItem != undefined)
//   {
//   let z = Utilities.FindString(oBookItem.orders, oOrder.basket_id);

//   if (z == AppMain.IMAGINARY)
//     oBookItem.orders.push(oOrder.basket_id);
//   }
// }

/*   ---------------------------------------------------------------------   */

/*   ---------------------------------------------------------------------   */

private static oWs_Ord_onmessage(x : any[][])
{
let [template, keys, values, tokens, usermsgs] = x;

//alert("ord")
//Utilities.Sendlog("Order=>"  + template[0] + ": " + Utilities.GetKeyValueString(keys, values));  

switch (template[0])
  {
  case TemplateId.HEARTBEAT_RESPONSE:
    return;

  case TemplateId.SHOW_BRACKETS_RESPONSE:
    ConnectionOrd.ProcessBrackets(keys, values, tokens);
    return;

  case TemplateId.SHOW_BRACKET_STOPS_RESPONSE:
    ConnectionOrd.ProcessBrackets(keys, values, tokens);
    return;

  case TemplateId.BRACKET_UPDATES:
    ConnectionOrd.ProcessBrackets(keys, values, tokens);
    return;

  case TemplateId.MODIFY_ORDER_RESPONSE:
    if (__DEV__)
      Utilities.Sendlog("Order=>"  + template[0] + ": " + Utilities.GetKeyValueString(keys, values));
    return;    

  case TemplateId.CANCEL_ALL_ORDERS_RESPONSE:
    if (__DEV__)
      Utilities.Sendlog("Order Cancel All=>"  + template[0] + ": " + Utilities.GetKeyValueString(keys, values));
    return;    
  
  case TemplateId.EXIT_POSITION_RESPONSE:
    if (__DEV__)
      Utilities.Sendlog("Order Exit Pos=>"  + template[0] + ": " + Utilities.GetKeyValueString(keys, values));
    return;    
  
  case TemplateId.ORDER_SESSION_CONFIG_RESPONSE:
    if (__DEV__)
      Utilities.Sendlog("Order config=>"  + template[0] + ": " + Utilities.GetKeyValueString(keys, values));  
    return;    

  case TemplateId.REJECT_RESPONSE:
    if (ConnectionOrd.oConn)
      {
      ConnectionOrd.oConn.sLastReject = Utilities.formatTimeStatusbar(Date.now()) + ": " + 
                                        Utilities.GetKeyValueStringForce(keys, values);
      }

    if (__DEV__)      
      Utilities.Sendlog("****????Ord REJECT response: " + ConnectionOrd.oConn?.sLastReject);
    return;

  case TemplateId.SHOW_ORDERS_RESPONSE:
    //Utilities.Sendlog("Order=>"  + template[0] + ": " + Utilities.GetKeyValueString(keys, values));
    return;

  case TemplateId.WS_TMPLT_ID_PVT_RP_LOAD_REF_DATA:
    if (__DEV__)
      Utilities.Sendlog("Load Ref Data=>"  + template[0] + ": " + Utilities.GetKeyValueString(keys, values));  
    return;

  case TemplateId.RMS_ACCOUNT_UPDATES:
    if (__DEV__)
      Utilities.Sendlog("RMS Updates=>"  + template[0] + ": " + Utilities.GetKeyValueString(keys, values));  

    ConnectionRMS.ProcessRMSAccount(keys, values, tokens);
    return;

  case TemplateId.RMS_UPDATES_RESPONSE:
    if (__DEV__)
      Utilities.Sendlog("RMS Updates response=>"  + template[0] + ": " + Utilities.GetKeyValueString(keys, values));  
    return;    

  case TemplateId.RITHMIC_ORDER_NOTIFICATION:
    ConnectionOrd.ProcessOrder(keys, values, tokens, true);
    return;

  case TemplateId.EXCHANGE_ORDER_NOTIFICATION:
    ConnectionOrd.ProcessOrder(keys, values, tokens);
    return;

  case TemplateId.NEW_ORDER_RESPONSE:
    let [code, error]  = Connection.getResonseError(keys, values);

    if (error != undefined && error != undefined)
      alert(error);
      
    ConnectionOrd.oConn?.oOnAlert(ConnectionOrd.oConn, 
                                  Connection.MSG_NEW_ORDER_FAILED,
                                  error);
    return;    
      
  case TemplateId.LOGIN_RESPONSE:
    Utilities.Sendlog("unique login order: " + Utilities.GetKeyValueString(keys, values));
    
    ConnectionOrd.LoginResponseOrd(keys, values);
    return;

  case TemplateId.LOGIN_INFO_RESPONSE:
    //Utilities.Sendlog("login info Order: " + Utilities.GetKeyValueString(keys, values));
    return;

  case TemplateId.ACCOUNT_RMS_INFO_RESPONSE:
    if (__DEV__)
      Utilities.Sendlog("RMS: " + Utilities.GetKeyValueString(keys, values));
    return;

  case TemplateId.ACCOUNT_LIST_RESPONSE:
    if (__DEV__)
      Utilities.Sendlog("Account list=> " + Utilities.GetKeyValueString(keys, values));

    ConnectionOrd.ProcessAccounts(tokens, keys, values);
    // let [, , fcm, ib, account, ] = tokens;

    // if (account != undefined && fcm != undefined && ib != undefined)
    //   {
    //   let key      = fcm + ib + account;
    //   let oAccData = new AccData(fcm, ib, account, key);

    //   //alert(key);

    //   ConnectionOrd.oAccStore.set(key, oAccData)

    //   ConnectionOrd.oConn?.Rq_GetOrders(oAccData);
    //   ConnectionOrd.oConn?.Rq_GetAccountRMS(oAccData);


    //   if (ConnectionRMS.oConn?.GetLoginStatus() == true)
    //     {
    //     ConnectionRMS.oConn?.Rq_Subscribe(oAccData);
    //     oAccData.sub_pnl = true;
    //     }
    //   }

    // for (let i = 0; i < keys.length; i++)
    // {
    //   switch(keys[i])
    //     {
    //     case MnmIds.MNM_ACCOUNT_ID:
    //       let oAccData = new AccData(values[i]);

    //       ConnectionOrd.oAccStore.set(oAccData.acc_id, oAccData)

    //         if (ConnectionRMS.oConn?.GetLoginStatus() == true)
    //           {
    //           ConnectionRMS.oConn?.Rq_Subscribe(oAccData.acc_id);
    //           oAccData.sub_pnl = true;
    //           }
    //       break;
    //     }
    // }

    return;    

  case TemplateId.TRADE_ROUTES_RESPONSE:
    //Utilities.Sendlog("Route=> " + Utilities.GetKeyValueString(keys, values));
    ConnectionOrd.ProcessRoutes(keys, values);
    return;
  case TemplateId.GET_USER_SETTINGS_RESPONSE:
    //alert("settings got");
    if (__DEV__)
      Utilities.Sendlog("got settings : " + Utilities.GetKeyValueString(keys, values));

    //Utilities.Sendlog("login: " + GetKeyValueString(keys, values));
    //CompleteGetSettings(keys, values);
    //Utilities.Sendlog("got settings : " + Utilities.GetKeyValueString(keys, values));

    Connection.bSettingsLocal = true;
    // ConnectionMkt.oConn?.ResetRetry();
    // ConnectionOrd.oConn?.ResetRetry();
    // ConnectionRMS.oConn?.ResetRetry();
    // ConnectionHis.oConn?.ResetRetry();

    if (ConnectionOrd.CompleteGetSettings(keys, values) == true)
      ConnectionOrd.oConn?.oOnAlert(ConnectionOrd.oConn, 
                                    Connection.MSG_GET_SETTINGS,
                                    null);

    return;

  case TemplateId.SET_USER_SETTINGS_RESPONSE:
    //Utilities.Sendlog("login: " + GetKeyValueString(keys, values));
    //CompleteSetSettings(keys, values);
    if (__DEV__)
      Utilities.Sendlog("settings saved..." + Utilities.GetKeyValueString(keys, values)); 

    // ConnectionOrd.oConn?.oOnAlert(ConnectionOrd.oConn, 
    //                               Connection.MSG_SET_SETTINGS,
    //                               x);

    return;


  }
}

/*   ---------------------------------------------------------------------   */

}

/*   =======================================================================  */

class ConnectionRMS extends Connection
{
public static oConn     : ConnectionRMS | null = null;

/*   ---------------------------------------------------------------------   */  

public static Init(oLoginParams : LoginParams, 
                   oOnAlert : (conn        : Connection,
                               msg         : number,
                               data        : any,
                               store_data? : any) => void,
                   iRetryCount = 0)
{
try
    {
    if (__DEV__)      
      Utilities.Sendlog("**Staring RMS...");

    ConnectionRMS.oConn = new ConnectionRMS("RMS",
                                            oLoginParams.sSys,
                                            oLoginParams.sUrl,
                                            oLoginParams.sUsr,
                                            oLoginParams.sPwd,
                                            Connection.TYPE_PNL_PLANT,
                                            ConnectionRMS.oWs_RMS_onmessage,
                                            oOnAlert,
                                            Connection.CXT_TYPE_OTH);

    ConnectionRMS.oConn.iRetry = iRetryCount;
    ConnectionRMS.oConn.Start();                            
    }
catch(error)
    {
    //setLoginState('💥');
    //alert("Order connection failed - " + error);  
    }    
}

/*   -------------------------------------------------------------------   */

public static Dispose()
{
 ConnectionRMS.oConn?.SetLoginStatus(false);
 ConnectionRMS.oConn?.SetReconnect();
 ConnectionRMS.oConn?.Close();
 ConnectionRMS.oConn = null;
}

/*   -------------------------------------------------------------------   */

public Rq_Subscribe(oData : AccData)
{
if (__DEV__)  
  Utilities.Sendlog("Subscribing for=> " + oData.key);

this.Send(Utilities.GetMergedMsg(
  MnmIds.MNM_FCM_ID, oData.fcm_id,
  MnmIds.MNM_IB_ID, oData.ib_id,
  MnmIds.MNM_ACCOUNT_ID, oData.acc_id,

  MnmIds.MNM_USER_MSG, oData.key,

  MnmIds.MNM_TEMPLATE_ID, TemplateId.PNL_POSITION_SNAPSHOT_REQUEST,
  ));

this.Send(Utilities.GetMergedMsg(
    MnmIds.MNM_FCM_ID, oData.fcm_id,
    MnmIds.MNM_IB_ID, oData.ib_id,
    MnmIds.MNM_ACCOUNT_ID, oData.acc_id,

    MnmIds.MNM_USER_MSG, oData.key,

    MnmIds.MNM_REQUEST,  Rq.Request.SUBSCRIBE,
    MnmIds.MNM_TEMPLATE_ID, TemplateId.PNL_POSITION_UPDATES_REQUEST,
    ));

}

/*   -------------------------------------------------------------------   */

public Rq_Unsubscribe(oData : AccData)
{
if (__DEV__)  
  Utilities.Sendlog("Unsub for=> " + oData.key);

this.Send(Utilities.GetMergedMsg(
    MnmIds.MNM_FCM_ID, oData.fcm_id,
    MnmIds.MNM_IB_ID, oData.ib_id,
    MnmIds.MNM_ACCOUNT_ID, oData.acc_id,

    MnmIds.MNM_USER_MSG, oData.key,

    MnmIds.MNM_REQUEST, Rq.Request.UNSUBSCRIBE,
    MnmIds.MNM_TEMPLATE_ID, TemplateId.PNL_POSITION_UPDATES_REQUEST,
    ));
}

/*   ---------------------------------------------------------------------   */

private static LoginResponseRMS(keys, values) 
{
if (Connection.getResonseCodeLogin(keys, 
                                   values,
                                   ConnectionRMS.oConn) == Connection.NO_ERROR)
    {
    if (ConnectionRMS.oConn?.GetLoginStatus() == true)
      {
      if (__DEV__)        
        Utilities.Sendlog("RMS already logged in");  
      return;
      }

    /*   -----------------------------------------------------------------   */

    ConnectionRMS.oConn?.SetLoginStatus(true);

    if (__DEV__)
      Utilities.Sendlog("RMS login status: " + ConnectionRMS.oConn?.GetLoginStatus());


    ConnectionRMS.oConn?.SendLoginInfo();


    for (let [key, value] of Connection.oAccStore.entries()) 
        {
        if (value.sub_pnl == false)
          {
          ConnectionRMS.oConn?.Rq_Subscribe(value);
          value.sub_pnl = true;
          }
        }


    ConnectionRMS.oConn?.oOnAlert(ConnectionRMS.oConn, 
                                  Connection.MSG_LOGIN_SUCCESS,
                                  null);

    ConnectionRMS.oConn?.ResetRetry();
    }
  else
    {
    if (__DEV__)      
      Utilities.Sendlog("RMS login failure...");

    ConnectionRMS.oConn?.NoRetry();

    ConnectionRMS.oConn?.oOnAlert(ConnectionRMS.oConn, 
                                  Connection.MSG_LOGIN_FAIL,
                                  null);
    }  
}

/*   ---------------------------------------------------------------------   */

public static ProcessRMSAccount(keys : any[], values : any[], tokens : any[])
{
let [symbol, exchange, fcm, ib, account, ] = tokens;

let acckey = fcm + ib + account;

let oAccData = Connection.oAccStore.get(acckey);

if (oAccData == undefined)
  {
  return;
  }

for (let i = 0; i < keys.length; i++)
  {
  switch(keys[i])
    {
      // case MnmIds.MNM_MTM_SECURITY:
      //   break;           
      case MnmIds.MNM_ACCOUNT_BALANCE:
          oAccData.acc_balance = values[i];
        break;

      case MnmIds.MNM_OPEN_POSITION_PNL:
          oAccData.pnl_open = values[i];
        break;
      case MnmIds.MNM_CLOSED_POSITION_PNL:
          oAccData.pnl_closed = values[i];
        break;            
      case MnmIds.MNM_MTM_ACCOUNT:
          oAccData.pnl = values[i];
        break;
      case MnmIds.MNM_NET_QUANTITY:
          oAccData.net_qty = values[i];
        break;

      case MnmIds.MNM_AUTO_LIQ_THRESHOLD_CURRENT_VALUE:
        {
        //oAccData.altv = Number(values[i]);
        }
        break;

      case MnmIds.MNM_ORDER_BUY_QTY:
          oAccData.working_buys = values[i];
        break;            
      case MnmIds.MNM_ORDER_SELL_QTY:
          oAccData.working_sells = values[i];
        break;                        

      case MnmIds.MNM_FILL_BUY_QTY:
          oAccData.fill_buy_qty = values[i];
        break;
      case MnmIds.MNM_FILL_SELL_QTY:
          oAccData.fill_sell_qty = values[i];
        break;
      case MnmIds.MNM_OPEN_POSITION_QUANTITY:
          oAccData.open_net_qty = values[i];
        break;

    }
  }
}

/*   ---------------------------------------------------------------------   */

private static oWs_RMS_onmessage(x : any[][])
{
let [template, keys, values, tokens, usermsgs] = x;

 //Utilities.Sendlog("RMS=>"  + Utilities.GetKeyValueString(keys, values));  

switch (template[0])
  {
  case TemplateId.HEARTBEAT_RESPONSE:
    return;
      
  case TemplateId.LOGIN_RESPONSE:
    if (__DEV__)
      Utilities.Sendlog("unique login rms: " + Utilities.GetKeyValueString(keys, values));

    ConnectionRMS.LoginResponseRMS(keys, values);
    return;

  case TemplateId.LOGIN_INFO_RESPONSE:
    //Utilities.Sendlog("login info RMS: " + Utilities.GetKeyValueString(keys, values));
    return;

  case TemplateId.REJECT_RESPONSE:
    if (ConnectionRMS.oConn)
      {
      ConnectionRMS.oConn.sLastReject = Utilities.formatTimeStatusbar(Date.now()) + ": " + 
                                        Utilities.GetKeyValueStringForce(keys, values);
      }

    if (__DEV__)      
      Utilities.Sendlog("****????RMS REJECT response: " + ConnectionRMS.oConn?.sLastReject);

    return;
  
  case TemplateId.ACCOUNT_PNL_POSITION_UPDATE:
    ConnectionRMS.ProcessRMSAccount(keys, values, tokens);
    // let [symbol, exchange, fcm, ib, account, ] = tokens;

    // let acckey = fcm + ib + account;

    // let oAccData = Connection.oAccStore.get(acckey);

    // if (oAccData == undefined)
    //   {
    //   return;
    //   }

    // for (let i = 0; i < keys.length; i++)
    //   {
    //   switch(keys[i])
    //     {
    //       // case MnmIds.MNM_MTM_SECURITY:
    //       //   break;           
    //       case MnmIds.MNM_ACCOUNT_BALANCE:
    //           oAccData.acc_balance = values[i];
    //         break;

    //       case MnmIds.MNM_OPEN_POSITION_PNL:
    //           oAccData.pnl_open = values[i];
    //         break;
    //       case MnmIds.MNM_CLOSED_POSITION_PNL:
    //           oAccData.pnl_closed = values[i];
    //         break;            
    //       case MnmIds.MNM_MTM_ACCOUNT:
    //           oAccData.pnl = values[i];
    //         break;
    //       case MnmIds.MNM_NET_QUANTITY:
    //           oAccData.net_qty = values[i];
    //         break;

    //       case MnmIds.MNM_AUTO_LIQ_THRESHOLD_CURRENT_VALUE:
    //         oAccData.altv = values[i];
    //         break;

    //       case MnmIds.MNM_ORDER_BUY_QTY:
    //           oAccData.working_buys = values[i];
    //         break;            
    //       case MnmIds.MNM_ORDER_SELL_QTY:
    //           oAccData.working_sells = values[i];
    //         break;                        

    //       case MnmIds.MNM_FILL_BUY_QTY:
    //           oAccData.fill_buy_qty = values[i];
    //         break;
    //       case MnmIds.MNM_FILL_SELL_QTY:
    //           oAccData.fill_sell_qty = values[i];
    //         break;
    //       case MnmIds.MNM_OPEN_POSITION_QUANTITY:
    //           oAccData.open_net_qty = values[i];
    //         break;

    //     }
    //   }

    return;

  case TemplateId.INSTRUMENT_PNL_POSITION_UPDATE:
    let [symbol, exchange, fcm, ib, account, ] = tokens;

    // if (account != undefined)
    //   Utilities.Sendlog(Utilities.GetKeyValueString(keys, values));

    let token  = symbol + "." + exchange;
    let acckey = fcm + ib + account;
    let key    = acckey + token;

    //alert(key);

    let oPosData = Connection.oPosStore.get(key);

    if (oPosData == undefined)
      {
      oPosData = new PosData(acckey, token);
      Connection.oPosStore.set(key, oPosData);
      //alert("new key" + key);

      // let oAccData = Connection.oAccStore.get(acckey);

      // if (oAccData != undefined)
      //   oAccData.positions.push(oPosData);
      }

    for (let i = 0; i < keys.length; i++)
      {
      switch(keys[i])
        {
          // case MnmIds.MNM_MTM_SECURITY:
          //   break;           
          case MnmIds.MNM_OPEN_POSITION_PNL:
              oPosData.open_pnl = values[i];
            break;           
          // case MnmIds.MNM_OPEN_POSITION_QUANTITY:
          //   break;            
          case MnmIds.MNM_CLOSED_POSITION_PNL:
              oPosData.closed_pnl = values[i];
            break;
          case MnmIds.MNM_AVG_OPEN_FILL_PRICE:
              oPosData.avg_open_fillprice = values[i];

              //Utilities.Sendlog("Avg Open: " + values[i]);
            break;            
          case MnmIds.MNM_MTM_SECURITY:
              oPosData.total_pnl = values[i];
            break;            
          case MnmIds.MNM_CLOSED_POSITION_QUANTITY:
            oPosData.closed_pos_qty = values[i];
            break;
          case MnmIds.MNM_OPEN_POSITION_QUANTITY:
            oPosData.open_pos_qty = values[i];
            break;

          case MnmIds.MNM_ORDER_BUY_QTY:
            if (values[i] != oPosData.order_buy_qty)
              {
              oPosData.order_buy_qty = values[i];
              //Utilities.Sendlog("buy: " + oPosData.order_buy_qty);
              }
            break;
          case MnmIds.MNM_ORDER_SELL_QTY:
            if (values[i] != oPosData.order_sell_qty)
              {
              oPosData.order_sell_qty = values[i];
              //Utilities.Sendlog("sell: " + oPosData.order_sell_qty);
              }

            break;

          case MnmIds.MNM_BUY_QTY:
            oPosData.buy_qty = values[i];
            //Utilities.Sendlog("buy qty: " + values[i]);
            break;
          case MnmIds.MNM_SELL_QTY:
            oPosData.sell_qty = values[i];
            break;            

          case MnmIds.MNM_NET_QUANTITY:
            oPosData.net_qty = values[i];
            break;
        }
      }
    return;
  }
}

/*   ---------------------------------------------------------------------   */

}

/*   =======================================================================  */

class ConnectionMkt extends Connection
{
//public static readonly BOOK_LEVEL          = 1000;
public static oConn : ConnectionMkt | null = null;

public static iMsg                         = 0;
public static iLastSsboeHb                 = 0;
public static iLastSsboe_Msg               = 0;
//public static bEco                         = false;

/*   -------------------------------------------------------------------   */

public static Init(oLoginParams : LoginParams,
                   oOnAlert : (conn        : Connection,
                               msg         : number,
                               data        : any,
                               store_data? : any) => void,
                   iRetryCount = 0)
{
try
  {
  if (__DEV__)    
    Utilities.Sendlog("**Staring Market...");

  ConnectionMkt.oConn = new ConnectionMkt("Market",
                                          oLoginParams.sSys,
                                          oLoginParams.sUrl,
                                          oLoginParams.sUsr,
                                          oLoginParams.sPwd,
                                          Connection.TYPE_TICKER_PLANT,
                                          ConnectionMkt.oWs_Mkt_onmessage,
                                          oOnAlert,
                                          Connection.CXT_TYPE_MKT);

  ConnectionMkt.oConn.iRetry = iRetryCount;
  ConnectionMkt.oConn.Start();
  }
catch(error)
  {
  //setLoginState('💥');
  //alert("Order connection failed - " + error);
  }
}

/*   -------------------------------------------------------------------   */

public static Dispose()
{
// if (ConnectionMkt.oConn?.GetLoginStatus())
//   {
//   for (let [key, value] of Connection.oStore.entries())
//     {
//     if (value.sub_mkt == true)
//       {
//       ConnectionMkt.oConn.Rq_Unsubscribe(value.symbol,
//                                          value.exchange,
//                                          value.token);
//       value.sub_mkt = false;
//       }
//     }
//   }

ConnectionMkt.iLastSsboe_Msg = 0;
ConnectionMkt.iLastSsboeHb   = 0;
ConnectionMkt.iMsg           = 0;

ConnectionMkt.oConn?.SetLoginStatus(false);
ConnectionMkt.oConn?.SetReconnect();
ConnectionMkt.oConn?.Close();
ConnectionMkt.oConn = null;
}

/*   -------------------------------------------------------------------   */

static getMktItem(symbol   : string,
                  exchange : string,
                  token    : string) : Data
{
let oData = Connection.oStoreAddl.get(token);

if (oData)
  return(oData);

return(new Data(symbol, exchange, token, ConnectionHis.oDefaultLookBack));
// return ({symbol:symbol, exchange:exchange, token: token,
//          mode: "", last: 0.0, last_size:0,
//          bid:0, bid_size:0, ask:0, ask_size:0, vol:0, nc:0.0, pc:0.0, time:0,
//          f2qp:2, display_fmt: "", closes:[0], times: [],
//          lookback: ConnectionHis.oDefaultLookBack,
//          closes_got:false, update_chart: false, sub_bars: false,
//          year_closes:[], month_closes:[], year_times:[], month_times:[],
//          mode_got:false,
//          trade_got: false, bbo_got:false,
//          msgs:0, msgs_curr:0
//          });
}

/*   -------------------------------------------------------------------   */

public Rq_Binary_RefData(sUSymbol   : string,
                         sUExchange : string,
                         sToken     : string)
{
if (__DEV__)  
  Utilities.Sendlog("Requesting event contracts..." + sUSymbol);

this.Send(Utilities.GetMergedMsg(
    MnmIds.MNM_UNDERLYING_SYMBOL, sUSymbol,

    MnmIds.MNM_USER_MSG, sToken,
    MnmIds.MNM_USER_MSG, sUSymbol,
    MnmIds.MNM_USER_MSG, sUExchange,

    MnmIds.MNM_TEMPLATE_ID, TemplateId.BINARY_CONTRACT_REF_DATA_REQUEST,
    ));
}

/*   -------------------------------------------------------------------   */

public Rq_RefData_Cycle(sSymbol, sExchange, sToken, sUsrMsg, sReplaceToken)
{
//Utilities.Sendlog("Requesting (cycle)=>" + sSymbol + "<>" + sExchange);
this.Send(Utilities.GetMergedMsg(
    MnmIds.MNM_SYMBOL, sSymbol,
    MnmIds.MNM_EXCHANGE, sExchange,

    MnmIds.MNM_USER_MSG, sToken,
    MnmIds.MNM_USER_MSG, "cycle",
    MnmIds.MNM_USER_MSG, sUsrMsg,
    MnmIds.MNM_USER_MSG, sReplaceToken,

    MnmIds.MNM_TEMPLATE_ID, TemplateId.REFERENCE_DATA_REQUEST,
    ));
}

/*   -------------------------------------------------------------------   */

public Rq_RefData_Final(sSymbol, sExchange, sToken, sUsrMsg, sReplaceToken)
{
//Utilities.Sendlog("Requesting (final)=>" + sSymbol + "<>" + sExchange);
this.Send(Utilities.GetMergedMsg(
    MnmIds.MNM_SYMBOL, sSymbol,
    MnmIds.MNM_EXCHANGE, sExchange,

    MnmIds.MNM_USER_MSG, sToken,
    MnmIds.MNM_USER_MSG, "final",
    MnmIds.MNM_USER_MSG, sUsrMsg,
    MnmIds.MNM_USER_MSG, sReplaceToken,

    MnmIds.MNM_TEMPLATE_ID, TemplateId.REFERENCE_DATA_REQUEST,
    ));
}

/*   -------------------------------------------------------------------   */

public Rq_RefData_Merge(oMsg, sSymbol, sExchange, sToken, sUsrMsg)
{
//Utilities.Sendlog("Requesting (final)=>" + sSymbol + "<>" + sExchange);
var oMsgNew =
Utilities.GetMergedMsg(
    MnmIds.MNM_SYMBOL, sSymbol,
    MnmIds.MNM_EXCHANGE, sExchange,

    MnmIds.MNM_USER_MSG, sToken,
    MnmIds.MNM_USER_MSG, "final",
    MnmIds.MNM_USER_MSG, sUsrMsg,

    MnmIds.MNM_TEMPLATE_ID, TemplateId.REFERENCE_DATA_REQUEST,
    );

 return( Utilities.MergeMsg(oMsg, oMsgNew) );
}

/*   -------------------------------------------------------------------   */

public Rq_Subscribe(sSymbol, sExchange, sToken)
{
if (__DEV__)  
  Utilities.Sendlog("Subscribing=> " + sSymbol + "<>" + sExchange);

this.Send(
//let oMsgNew =
  Utilities.GetMergedMsg(
    MnmIds.MNM_SYMBOL, sSymbol,
    MnmIds.MNM_EXCHANGE, sExchange,

    MnmIds.MNM_USER_MSG, sToken,

    MnmIds.MNM_REQUEST,  Rq.Request.SUBSCRIBE,
    MnmIds.MNM_MESSAGE_ID,  Rq.MktUpdateBits.LAST_TRADE +
                            Rq.MktUpdateBits.BBO +
                            Rq.MktUpdateBits.HIGH_LOW +
                            // MktUpdateBits.ORDER_BOOK +
                            Rq.MktUpdateBits.MARKET_MODE +
                            Rq.MktUpdateBits.SETTLEMENT +
                            Rq.MktUpdateBits.CLOSE + 
                            Rq.MktUpdateBits.ADJUSTED_CLOSE,
    MnmIds.MNM_TEMPLATE_ID, TemplateId.MARKET_DATA_UPDATE_REQUEST,
    )
    );

    //to remove
    //if (sToken == "ESU2.CME")
  //   {
  //   var x = new Uint8Array(oMsgNew, 4, oMsgNew.byteLength - 4);
  //   let [template, keys, values, tokens, usermsgs] = Connection.ProcessMsg(x);
  //   Utilities.Sendlog("SD:Req:=> " + Utilities.GetKeyValueString(keys, values));
  //   Utilities.Sendlog("SD:raw:=> " + oMsgNew);
  //   }

  // this.Send(oMsgNew);
}

/*   -------------------------------------------------------------------   */

// public static GetOBLevel(oData  : OBData,
//                          dPrice : number | undefined)
// {
// if (dPrice == undefined || oData.book.length != oData.book_levels)
//   return(AppMain.IMAGINARY);

// if (dPrice > oData.book[0].Price || 
//     dPrice < oData.book[oData.book_levels - 1].Price) 
//     return(AppMain.IMAGINARY);

// let iLevel = Math.round((oData.book[0].Price - dPrice)/oData.qpc);

// if (iLevel >= oData.book_levels)
//   return(AppMain.IMAGINARY);

// return(iLevel);
// }

public static GetOBLevel(dAnchor  : number | undefined,
                         dPrice   : number | undefined,
                         dQPC     : number,
                         dCeiling : number)
{
if (dPrice == undefined || dAnchor == undefined)
  return(AppMain.IMAGINARY);

if (dPrice > dAnchor) 
  return(AppMain.IMAGINARY);

let iLevel = Math.round((dAnchor - dPrice)/dQPC);

if (iLevel >= dCeiling)
  return(AppMain.IMAGINARY);

return(iLevel);
}

/*   -------------------------------------------------------------------   */

//private static bSubMBO = false;

public Rq_GetMBO(oData : OrdData)
{
if (oData.limit_price == undefined)
  return;

// if (ConnectionMkt.bSubMBO)
//   return;

// ConnectionMkt.bSubMBO = true;

//let oOBData = ConnectionMkt.oOBStore.get(oData.token);

// let oMBOData : MBOData | undefined;

// if (oOBData)
//   oMBOData = ConnectionMkt.GetMBOData(oOBData);

// if (oMBOData)
//   return;

// oMBOData = new MBOData();
// oMBOData.dPrice = oData.limit_price;
// oOBData?.oMBOData?.push(oMBOData);

if (__DEV__)
  Utilities.Sendlog("Getting MBO=> " + oData.token + " price: " + oData.limit_price);  

this.Send(
//var oMsgNew1 =
  Utilities.GetMergedMsg(

  MnmIds.MNM_EXCHANGE, oData.exchange,
  MnmIds.MNM_SYMBOL, oData.symbol,
  MnmIds.MNM_MARKET_DEPTH_PRICE, oData.limit_price,

  MnmIds.MNM_REQUEST, Rq.Request.SUBSCRIBE,

  MnmIds.MNM_USER_MSG, oData.basket_id,
  // MnmIds.MNM_USER_MSG, oData.token,
  MnmIds.MNM_USER_MSG, oData.exch_order_id,
  MnmIds.MNM_TEMPLATE_ID, TemplateId.DEPTH_BY_ORDER_UPDATES_REQUEST,
 // );
  ));

this.Send(
  //var oMsgNew2 = 
  Utilities.GetMergedMsg(

    MnmIds.MNM_EXCHANGE, oData.exchange,
    MnmIds.MNM_SYMBOL, oData.symbol,
    MnmIds.MNM_MARKET_DEPTH_PRICE, oData.limit_price,


    MnmIds.MNM_USER_MSG, oData.basket_id,
    // MnmIds.MNM_USER_MSG, oData.token,
    MnmIds.MNM_USER_MSG, oData.exch_order_id,
    MnmIds.MNM_TEMPLATE_ID, TemplateId.DEPTH_BY_ORDER_SNAPSHOT_REQUEST,
    //);
    ));

    //this.Send(Utilities.MergeMsg(oMsgNew1, oMsgNew2));
}

/*   -------------------------------------------------------------------   */

public Rq_UnSubscribeMBO(oData    : OrdData,
                         oMBOData : MBOData)
{
if (oData.limit_price == undefined)
  return;

if (__DEV__)  
  Utilities.Sendlog("Unsubscribing MBO=> " + oData.token + " price: " + oMBOData.dPrice);  

this.Send(
  Utilities.GetMergedMsg(

  MnmIds.MNM_EXCHANGE, oData.exchange,
  MnmIds.MNM_SYMBOL, oData.symbol,
  MnmIds.MNM_MARKET_DEPTH_PRICE, oMBOData.dPrice,

  MnmIds.MNM_REQUEST, Rq.Request.UNSUBSCRIBE,

  MnmIds.MNM_USER_MSG, oData.basket_id,
  // MnmIds.MNM_USER_MSG, oData.token,
  MnmIds.MNM_USER_MSG, oData.exch_order_id,
  MnmIds.MNM_TEMPLATE_ID, TemplateId.DEPTH_BY_ORDER_UPDATES_REQUEST,
 // );
  ));

}

/*   -------------------------------------------------------------------   */

public static GetOBLevelAlt(dAnchor  : number | undefined,
                            dPrice   : number | undefined,
                            oData    : Data) : number
{
try
  {
  if (dPrice == undefined || dAnchor == undefined)
    return(AppMain.IMAGINARY);

  if (dPrice > dAnchor) 
    return(AppMain.IMAGINARY);

  let iLevel = Math.round((dAnchor - dPrice)/oData.qpc);

  if (iLevel >= oData.book_levels)
    return(AppMain.IMAGINARY);

  return(iLevel);
  }
catch
  {
  return(AppMain.IMAGINARY);
  }
}

/*   -------------------------------------------------------------------   */

public static GetOBLevelAltUnbridled(dAnchor  : number,
                                     dPrice   : number,
                                     oData    : Data)
{
// if (dPrice == undefined || dAnchor == undefined)
//   return(AppMain.IMAGINARY);

// if (dPrice > dAnchor) 
//   return(AppMain.IMAGINARY);

let iLevel = Math.round((dAnchor - dPrice)/oData.qpc);

// if (iLevel >= oData.book_levels)
//   return(AppMain.IMAGINARY);

return(iLevel);
}

/*   -------------------------------------------------------------------   */

// public static GetOBLevelAvg(oData   : OBData,
//                             dPrice  : number,
//                             bPosNeg : boolean)
// {
// if (oData.book.length != oData.book_levels)
// return(AppMain.IMAGINARY);

// if (dPrice > oData.book[0].Price || 
//     dPrice < oData.book[oData.book_levels - 1].Price) 
// return(AppMain.IMAGINARY);

// let iLevel : number;

// if (bPosNeg == false)
//   iLevel = Math.ceil((oData.book[0].Price - dPrice)/oData.qpc);
// else
//   iLevel = Math.floor((oData.book[0].Price - dPrice)/oData.qpc);

// if (iLevel >= oData.book_levels)
// return(AppMain.IMAGINARY);

// return(iLevel);

// /*   -------------------------------------------------------------------   */
// }

// public static GetOBLevelAvg(dAnchor : number | undefined,
//                             dPrice  : number | undefined,
//                             oData   : Data,
//                             bPosNeg : boolean)
// {
// if (dPrice == undefined || dAnchor == undefined || oData == undefined)
//   return(AppMain.IMAGINARY);

// if (dPrice < dAnchor) 
//   return(AppMain.IMAGINARY);

// let iLevel : number;

// if (bPosNeg == false)
//   iLevel = Math.ceil((dAnchor - dPrice)/oData.qpc);
// else
//   iLevel = Math.floor((dAnchor - dPrice)/oData.qpc);

// if (iLevel >= oData.book_levels)
//   return(AppMain.IMAGINARY);

// return(iLevel);
// }

/*   -------------------------------------------------------------------   */

public static GetMBOData(oOBData : OBData) : MBOData | undefined
{
if (!oOBData.oMBOData)
  {
  oOBData.oMBOData = new Array(0);
  return;
  }

if (oOBData.oMBOData.length)
  return(oOBData.oMBOData[0]);
}

/*   -------------------------------------------------------------------   */

static GetBook(oData  : Data) : OBData | undefined
{
let sSymbol;
let sExchange;
let bFM = false;

if (oData.sub_mkt == false)
  {
  if (__DEV__)    
    Utilities.Sendlog("Getting book=> symbol not subscribed- may be not a visible item..." + oData.token);

  return(undefined);
  }

if (oData.trading_symbol)
  {
  if (sSymbol != oData.trading_symbol)
    bFM = true;

  sSymbol = oData.trading_symbol;
  }
else
  sSymbol = oData.symbol;

// if (oData.trading_exchange)
//   sExchange = oData.trading_exchange;
// else
  sExchange = oData.exchange;  

let token   = sSymbol + "." + sExchange;


let oOBData = Connection.oOBStore.get(token);

if (oOBData != undefined)
  {
  ConnectionMkt.AssignDataToOB(oOBData, oData);
  //Utilities.Sendlog("Init book levels : " + oData.token + ":" + token);
  return(oOBData);
  }
else
  {
  oOBData = new OBData();
  Connection.oOBStore.set(token, oOBData);

  ConnectionMkt.AssignDataToOB(oOBData, oData);
  ConnectionMkt.RepopulateBook(oOBData, oData);
  //Utilities.Sendlog("Populating book levels : " + oData.token + ":" + token + ":" + oOBData.book.length);

  return(oOBData);
  }
}

/*   -------------------------------------------------------------------   */

static AssignDataToOB(oOBData : OBData,
                      oData   : Data)
{
  if (oData.bContSymbol == true)
    {
    if (oOBData.oFMData != oData)
      oOBData.oFMData = oData;
    }
  else
    {
    if (oOBData.oData != oData)
      oOBData.oData = oData;
    }
}

/*   -------------------------------------------------------------------   */

static UnassignDataFromOB(oData : Data)
{
let token;

if (oData.bContSymbol == true)
  token = oData.trading_symbol + "." + oData.exchange;
else
  token = oData.token;

let oOBData = Connection.oOBStore.get(token);

if (oOBData != undefined)
  {
  if (oData.bContSymbol == true)
    oOBData.oFMData = null;
  else
    oOBData.oData = null;
  }
}

/*   -------------------------------------------------------------------   */

static SubscribeOB(oData     : Data,
                   bCompress : boolean = false,
                   bConform  : boolean = false) : OBData | null
{
//if (oData.obo_visible == true)
  //return;

let sSymbol = oData.trading_symbol?
              oData.trading_symbol : 
              oData.symbol;

let sExchange = /*oData.trading_exchange?
                oData.trading_exchange : */
                oData.exchange;

let oOBData = Connection.oOBStore.get(sSymbol + "." + sExchange);

if (oOBData == undefined)
  {
  if (__DEV__)    
    Utilities.Sendlog("Getting book=> " + "initializing..." + oData.token);

  oOBData = ConnectionMkt.GetBook(oData);

  if (oOBData == null)
    {
    if (__DEV__)      
      Utilities.Sendlog("Getting book=> " + "not found - " + sSymbol + "<>" + sExchange);

    return(null);
    }
  }

if (bConform == false)
  {
  if (oOBData.sub_ob != 0)
    {
    if (__DEV__)      
      Utilities.Sendlog("Getting book=> " + "already exists");

    oOBData.sub_ob++;
    return(oOBData);
    }

  oOBData.compress = bCompress;
  oOBData.sub_ob++;
  }

ConnectionMkt.RepopulateBook(oOBData, oData);
//oOBData.clear = true;

ConnectionMkt.oConn?.Rq_SubscribeOB(sSymbol,
                                    oData.exchange,
                                    oData.token);

//oOBData.sub_ob = true;

return(oOBData);
}

/*   -------------------------------------------------------------------   */

static GetOB(oData : Data) : OBData | undefined
{
let sSymbol = oData.trading_symbol?
              oData.trading_symbol : 
              oData.symbol;

let sExchange = /*oData.trading_exchange?
                oData.trading_exchange : */
                oData.exchange;

return(Connection.oOBStore.get(sSymbol + "." + sExchange));

}

/*   -------------------------------------------------------------------   */

static UnSubscribeOB(oData : Data)
{
// if (oData.obo_visible == false)
//   return;

let sSymbol = oData.trading_symbol?
              oData.trading_symbol : 
              oData.symbol;

let sExchange = /*oData.trading_exchange?
                oData.trading_exchange : */
                oData.exchange;

let oOBData = Connection.oOBStore.get(sSymbol + "." + sExchange);

if (__DEV__)
  Utilities.Sendlog("Unsub book=> " + sSymbol + " -count: " + oOBData?.sub_ob);

if (oOBData == undefined)
  {
  if (__DEV__)    
    Utilities.Sendlog("Unsub book=> " + sSymbol + " undefined");

  return;
  }

if (oOBData.sub_ob == 0)
  {
  if (__DEV__)    
    Utilities.Sendlog("Unsub book=> " + sSymbol + " no subscription");

  return;
  }

oOBData.sub_ob -= 1;

if (oOBData.sub_ob == 0)
  ConnectionMkt.oConn?.Rq_UnsubscribeOB(sSymbol,
                                        sExchange,
                                        oData.token);
}

/*   -------------------------------------------------------------------   */

public Rq_SubscribeOB(sSymbol, sExchange, sToken)
{
if (__DEV__)  
  Utilities.Sendlog("Getting book=> (actual request) " + sSymbol + "<>" + sExchange);

this.Send(Utilities.GetMergedMsg(
    MnmIds.MNM_SYMBOL, sSymbol,
    MnmIds.MNM_EXCHANGE, sExchange,

    MnmIds.MNM_USER_MSG, sToken,

    MnmIds.MNM_REQUEST,  Rq.Request.SUBSCRIBE,
    MnmIds.MNM_MESSAGE_ID,  Rq.MktUpdateBits.ORDER_BOOK,
                            
    MnmIds.MNM_TEMPLATE_ID, TemplateId.MARKET_DATA_UPDATE_REQUEST,
    ));
}

/*   -------------------------------------------------------------------   */

public Rq_Subscribe_Merge(oMsg, sSymbol, sExchange, sToken)
{
if (__DEV__)  
  Utilities.Sendlog("Getting data (merge)=> " + sSymbol + "<>" + sExchange);

var oMsgNew =
Utilities.GetMergedMsg(
    MnmIds.MNM_SYMBOL, sSymbol,
    MnmIds.MNM_EXCHANGE, sExchange,

    MnmIds.MNM_USER_MSG, sToken,

    MnmIds.MNM_REQUEST, Rq.Request.SUBSCRIBE,
    MnmIds.MNM_MESSAGE_ID, Rq.MktUpdateBits.LAST_TRADE +
                           Rq.MktUpdateBits.BBO +
                           Rq.MktUpdateBits.HIGH_LOW +
                          //  MktUpdateBits.ORDER_BOOK +
                           Rq.MktUpdateBits.MARKET_MODE +
                           Rq.MktUpdateBits.SETTLEMENT +
                           Rq.MktUpdateBits.CLOSE +
                           Rq.MktUpdateBits.ADJUSTED_CLOSE,
    MnmIds.MNM_TEMPLATE_ID, TemplateId.MARKET_DATA_UPDATE_REQUEST,
    );

  //to remove
  //if (sToken == "ESU2.CME")
    // {
    // var x = new Uint8Array(oMsgNew, 4, oMsgNew.byteLength - 4);
    // let [template, keys, values, tokens, usermsgs] = Connection.ProcessMsg(x);
    // Utilities.Sendlog("SD:msg:=> " + Utilities.GetKeyValueString(keys, values));
    // Utilities.Sendlog("SD:raw:=> " + oMsgNew);
    // }

  return( Utilities.MergeMsg(oMsg, oMsgNew) );
}

/*   -------------------------------------------------------------------   */

public Rq_Snapshot(sSymbol, sExchange, sToken)
{
if (__DEV__)  
  Utilities.Sendlog("Getting snapshot data=> " + sSymbol + "<>" + sExchange);

this.Send(Utilities.GetMergedMsg(
    MnmIds.MNM_SYMBOL, sSymbol,
    MnmIds.MNM_EXCHANGE, sExchange,

    MnmIds.MNM_USER_MSG, sToken,

    MnmIds.MNM_MESSAGE_ID, Rq.MktUpdateBits.LAST_TRADE +
                           Rq.MktUpdateBits.BBO +
                           Rq.MktUpdateBits.HIGH_LOW +
                           Rq.MktUpdateBits.MARKET_MODE,
    MnmIds.MNM_TEMPLATE_ID, TemplateId.MRKT_DATA_SNAPSHOT_REQUEST,
    ));
}

/*   -------------------------------------------------------------------   */

public Rq_Snapshot_Merge(oMsg, sSymbol, sExchange, sToken)
{
//Utilities.Sendlog("Getting data snapshot=> " + sSymbol + "<>" + sExchange);
var oMsgNew =
Utilities.GetMergedMsg(
    MnmIds.MNM_SYMBOL, sSymbol,
    MnmIds.MNM_EXCHANGE, sExchange,

    MnmIds.MNM_USER_MSG, sToken,

    MnmIds.MNM_MESSAGE_ID, Rq.MktUpdateBits.LAST_TRADE +
                           Rq.MktUpdateBits.BBO +
                           Rq.MktUpdateBits.HIGH_LOW +
                           Rq.MktUpdateBits.MARKET_MODE +
                           Rq.MktUpdateBits.CLOSE +
                           Rq.MktUpdateBits.SETTLEMENT +
                           Rq.MktUpdateBits.ADJUSTED_CLOSE,
    MnmIds.MNM_TEMPLATE_ID, TemplateId.MRKT_DATA_SNAPSHOT_REQUEST,
    );

  return( Utilities.MergeMsg(oMsg, oMsgNew) );
}

/*   -------------------------------------------------------------------   */

public Rq_Unsubscribe(sSymbol, sExchange, sToken)
{
if (__DEV__)  
  Utilities.Sendlog("Unsubscribing=> " + sSymbol + "<>" + sExchange);

//this.Send(
let oMsgNew =   
  Utilities.GetMergedMsg(
    MnmIds.MNM_SYMBOL, sSymbol,
    MnmIds.MNM_EXCHANGE, sExchange,

    MnmIds.MNM_USER_MSG, sToken,

    MnmIds.MNM_REQUEST, Rq.Request.UNSUBSCRIBE,
    MnmIds.MNM_MESSAGE_ID, Rq.MktUpdateBits.LAST_TRADE +
                           Rq.MktUpdateBits.BBO +
                           Rq.MktUpdateBits.HIGH_LOW +
                           Rq.MktUpdateBits.MARKET_MODE +
                           Rq.MktUpdateBits.SETTLEMENT +
                           Rq.MktUpdateBits.CLOSE + 
                           Rq.MktUpdateBits.ADJUSTED_CLOSE,
    MnmIds.MNM_TEMPLATE_ID, TemplateId.MARKET_DATA_UPDATE_REQUEST,
    )
    //);

    // {
    //   var x = new Uint8Array(oMsgNew, 4, oMsgNew.byteLength - 4);
    //   let [template, keys, values, tokens, usermsgs] = Connection.ProcessMsg(x);
    //   Utilities.Sendlog("SD:msg:=> " + Utilities.GetKeyValueString(keys, values));
    //   Utilities.Sendlog("SD:raw:=> " + oMsgNew);
    //   }
  
   this.Send(oMsgNew);
}

/*   ---------------------------------------------------------------------   */

public Rq_UnsubscribeOB(sSymbol, sExchange, sToken)
{
if (__DEV__)  
  Utilities.Sendlog("Unsub book=> " + sSymbol + "<>" + sExchange);

this.Send(Utilities.GetMergedMsg(
    MnmIds.MNM_SYMBOL, sSymbol,
    MnmIds.MNM_EXCHANGE, sExchange,

    MnmIds.MNM_USER_MSG, sToken,

    MnmIds.MNM_REQUEST, Rq.Request.UNSUBSCRIBE,
    MnmIds.MNM_MESSAGE_ID, Rq.MktUpdateBits.ORDER_BOOK,
    MnmIds.MNM_TEMPLATE_ID, TemplateId.MARKET_DATA_UPDATE_REQUEST,
    ));
}

/*   ---------------------------------------------------------------------   */

// public static getSymbols()
// {
//   return(
//   [
//     {token:"AAPL.Q"},
//     {token:"TSLA.Q"},
//     {token:"MSFT.Q"},
//     {token:"F.Q"},

//     {token:"C.Q"},
//     {token:"BP.Q"},

//     {token:"ES.CME"},
//     {token:"YM.CBOT"},

//     {token:"CL.NYMEX"},

//     // {token:"VHT.Q"},
//     // {token:"VTI.Q"},
//     // {token:"VOO.Q"},
//     // {token:"DE.Q"},

//     // {token:"EMD.CME"},
//     // {token:"GE.CME"},
//     // {token:"NQ.CME"},

//     // {token:"NG.NYMEX"},

//     // {token:"ZN.CBOT"},
//     // {token:"ZT.CBOT"},
//     // {token:"ZC.CBOT"},

//     ]);
//   }

  /*   -------------------------------------------------------------------   */

//   public static getSymbols2()
// {
//   return(
//   [
//     {symbol:"AAPL", exchange:"Q", update: false},
//     {symbol:"TSLA", exchange:"Q", update: false},
//     {symbol:"MSFT", exchange:"Q", update: false},
//     {symbol:"F", exchange:"Q", update: false},

//     {symbol:"C", exchange:"Q", update: false},
//     {symbol:"BP", exchange:"Q", update: false},

//     {symbol:"ES", exchange:"CME", update: false},
//     {symbol:"YM", exchange:"CBOT", update: false},

//     {symbol:"CL", exchange:"NYMEX", update: false},

//     ]);
//   }

  /*   -------------------------------------------------------------------   */

  public static GetImages()
  {
  if (ConnectionMkt.oConn == null)
    return;

  /*   -------------------------------------------------------------------   */

  let oMsg : Uint8Array | null = null;

  /*   -------------------------------------------------------------------   */

  //Utilities.Sendlog("GetImages(): Getting data snapshot=> ");

  for (let [key, value] of ConnectionMkt.oStore.entries())
    {
    if (!key)
      continue;

    oMsg = ConnectionMkt.oConn.Rq_Snapshot_Merge(oMsg,
                                                 value.symbol,
                                                 value.exchange,
                                                 value.token)
    }

  if (oMsg != null)
      {
      ConnectionMkt.oConn.Send(oMsg);
      //Utilities.Sendlog("Requesting snapshot (auto) for " + oStore.length);
      }
  }

  /*   -------------------------------------------------------------------   */

  private static ProcessEventContract(keys    : Array<any>,
                                      values  : Array<any>,
                                      tokens  : Array<any>,
                                      usrmsgs : Array<any>)
  {
    // let sUSymbol   : string | undefined;
    // let sUExchange : string | undefined;
    let sExpiry    : string | undefined;
    let sPutCall   : string | undefined;
    //let sSymbol    : string | undefined;
    let dStrike    : number | undefined;
    let oEvtItem   : EvtItem | undefined;
    let oEvtData   : EvtData | undefined;
    let oData      : Data | undefined;

    /*   -----------------------------------------------------------------   */

    let [sUToken, sUSymbol, sUExchange] = usrmsgs;
    let [symbol, exchange]              = tokens;

    /*   -----------------------------------------------------------------   */

    let oUData = Connection.oStore.get(sUToken);

    if (oUData == undefined)
      {
      return;
      // if (sUSymbol && sUExchange)
      //   {
      //   let sToken = sUSymbol + "." + sUExchange;
      //   oData      = Connection.oStore.get(sToken);
  
      //   if (oData == undefined)
      //     return;
      //   }
      // else
      //   return;
      }
  
    /*   -------------------------------------------------------------------   */

    let token;

    if (symbol && exchange)
      {
      token = symbol + "." + exchange;

      oData = Connection.oStoreAddl.get(token);

      if (oData == undefined)
        {
        oData = new Data(symbol, exchange, token, ConnectionHis.oDefaultLookBack);
        Connection.oStoreAddl.set(token, oData);

        if (__DEV__)
          Utilities.Sendlog("Event Contract: adding " + token);
        }
      }

    /*   -------------------------------------------------------------------   */
  
    for (let i = 0, j = keys.length; i < j; i++)
    {
    switch(keys[i])
      {
      case MnmIds.MNM_RESPONSE_CODE:
        if (values[i] == 0)
          {
          if (oUData.evt_avbl == false)
              {
              if (oUData.evt)
                {
                oUData.evt     = new Map([...oUData.evt].sort((a, b) => a[1].iDiff - b[1].iDiff));
                let oEvt       = ConnectionMkt.GetEvtList(oUData);
                oUData.evt_exp = oEvt.evtlist;

                if (oUData.evt_exp && oUData.evt_exp.length)
                  {
                  if (oEvt.index != undefined && oEvt.index < oUData.evt_exp.length - 1)
                    oUData.evt_index = oEvt.index;
                  else
                    oUData.evt_index = oUData.evt_exp.length - 1;

                  oEvtData = oUData.evt_exp[oUData.evt_index]; //ConnectionMkt.GetEvtData(oUData);
                  //oUData.evt_index = 0;
                  }
                }

              if (oEvtData)
                {
                oUData.evt_avbl = true;

                ConnectionOrd.oConn?.Rq_LoadRefData(oEvtData);

                ConnectionMkt.oConn?.oOnAlert(ConnectionMkt.oConn,
                                              Connection.MSG_EVT_DATA,
                                              oEvtData);
                }
              }

          //Utilities.Sendlog(usermsgs[0] +  " - market data error: " + Utilities.GetKeyValueString(keys, values)); 
          return;
          }

        return;
      // case MnmIds.MNM_SYMBOL:
      //   sSymbol = values[i];
      //   break;
      case MnmIds.MNM_STRIKE_PRICE:
        dStrike = values[i]; //Utilities.round(values[i], 2);
        break;
      // case MnmIds.MNM_UNDERLYING_SYMBOL:
      //   sUSymbol = values[i];
      //   break;
      // case MnmIds.MNM_UNDERLYING_EXCHANGE:
      //   sUExchange = values[i];
      //   break;
      case MnmIds.MNM_EXPIRATION_DATE:
        sExpiry = values[i];
        break;

      case MnmIds.MNM_EXPIRATION_TIME:
        if (oData)
          oData.expiry_time = values[i];
        break;

      case MnmIds.MNM_PUT_CALL_INDICATOR:
        sPutCall = values[i];
        break;

      case MnmIds.MNM_PRICE_DISPLAY_FORMAT:
        if (oData)
          oData.display_fmt = values[i];
        break;

      case MnmIds.MNM_MIN_QPRICE_CHANGE:
        if (oData)
          {
          oData.qpc = values[i];

          let split = (values[i] + 1).toString().split('.');

          if (split.length > 1)
            oData.f2qp = split[1].length;
          else if (split.length == 1)
            oData.f2qp = 0;
          }
        break;
      }
    }

  /*   -------------------------------------------------------------------   */

  if (symbol && !dStrike)
    {
    let res = symbol.split(" ");

    if (res.length == 2)
      dStrike = Number.parseInt(res[1].substring(1));
    }

  /*   -------------------------------------------------------------------   */

  if (symbol && dStrike && sPutCall && sExpiry)
    {
    if (!oUData.evt)
      {
      oUData.evt     = new Map();
      }

    oEvtData = oUData.evt.get(sExpiry);

    if (!oEvtData)
      {
      var oExp  = Utilities.FormatYYYYMMDD_EVT(sExpiry);

      oEvtData = new EvtData(oUData.token, 
                             sUSymbol, 
                             sUExchange, 
                             oExp.sFmt,
                             oExp.sFmtDt,
                             oExp.iDiff);
      oUData.evt.set(sExpiry, oEvtData);

      // if (oData.evt_avbl == false)
      //   {
      //   oData.evt_avbl = true;

      //   ConnectionMkt.oConn?.oOnAlert(ConnectionMkt.oConn,
      //                                 Connection.MSG_EVT_DATA,
      //                                 oEvtData);
      //   }
      }

    /*   -----------------------------------------------------------------   */

    oEvtItem = oEvtData.oEvtList?.get(dStrike);

    if (!oEvtItem)
      {
      oEvtItem  = new EvtItem(dStrike);
      oEvtData.oEvtList?.set(dStrike, oEvtItem);
      }

    /*   -----------------------------------------------------------------   */      

    if (sPutCall == "Put")
      {
      if (__DEV__)        
        Utilities.Sendlog("event put: " + dStrike + "<->" + symbol);

      oEvtItem.sPutToken = token;
      oEvtItem.oPutData  = oData;
      }
    else
      {
      if (__DEV__)        
        Utilities.Sendlog("event call: " + dStrike + "<->" + symbol);

      oEvtItem.sCallToken = token;
      oEvtItem.oCallData  = oData;
      }
    }
  }

  /*   -------------------------------------------------------------------   */

  public static GetEvtList(oData : Data)
  {
  let oEvtLast  : EvtData   | undefined = undefined;
  let oEvtList  : EvtData[] | undefined = undefined;

  let iLastDiff : number             = -1;
  let iIndex    : number | undefined = undefined;

  if (!oData.evt || oData.evt.size == 0)
    return({evtlist:oEvtList, index:undefined}); //oEvtLast);

  oEvtList = new Array(0);

  for (var [sExpiry, oEvtData] of oData.evt.entries()) 
    {
    oEvtLast = oEvtData;

    if (oEvtData.iDiff >= 0)
      {
      oEvtList.push(oEvtData);

      switch(iLastDiff)
        {
        case -1:
          iIndex    = oEvtList.length - 1;
          iLastDiff = oEvtData.iDiff;
          break;
        case 0:
          if (oEvtData.iDiff < 5)
            {
            if (oEvtList.length == 2 && oEvtList[0]?.iDiff == 0)
              {
              oEvtList.splice(0, 1);
              }

            iIndex    = oEvtList.length - 1;
            iLastDiff = oEvtData.iDiff;
            }
          break;

        // default:
        //   if (iLastDiff < 5)
        //     {
        //       iIndex    = oEvtList.length - 1;
        //       iLastDiff = oEvtData.iDiff;
                
        //     }
          // break;    
        }
      }
    }

  if (!oEvtList.length && oEvtLast)
    {
    oEvtList.push(oEvtLast);
    iIndex = 0;
    }

    //to remove
  // if (oEvtLast)
  //   {
  //   oEvtList.push(oEvtLast);
  //   oEvtList.push(oEvtLast);
  //   oEvtList.push(oEvtLast);
  //   oEvtList.push(oEvtLast);
  //   oEvtList.push(oEvtLast);
  //   oEvtList.push(oEvtLast);
  //   oEvtList.push(oEvtLast);
  //   oEvtList.push(oEvtLast);
  //   }

  return({evtlist: oEvtList, index:iIndex});
  }

  /*   -------------------------------------------------------------------   */

  private static LoginResponseMkt(keys   : Array<any>,
                                  values : Array<any>)
  {
  if (Connection.getResonseCodeLogin(keys, 
                                     values,
                                     ConnectionMkt.oConn) == Connection.NO_ERROR)
    {
    //  if (Connection.iReconType != Connection.RECON_OFF)
    //     ConnectionOrd.oConn?.ResetRetry();

     if (ConnectionMkt.oConn?.GetLoginStatus() == true)
      {
      if (__DEV__)        
        Utilities.Sendlog("Market already logged in");

      return;
      }

    /*   -----------------------------------------------------------------   */

    //Battery.getBatteryLevelAsync().then(level => {iBatt = level * 100});

    //mkt_status = true;

    /*   -----------------------------------------------------------------   */

    ConnectionMkt.oConn?.SetLoginStatus(true);

    if (__DEV__)
      Utilities.Sendlog("Market login status: " + ConnectionMkt.oConn?.GetLoginStatus());

    /*   -----------------------------------------------------------------   */

    //ConnectionMkt.CompleteLoginMkt();

        /*   -----------------------------------------------------------------   */

    ConnectionMkt.oConn?.SendLoginInfo();


    ConnectionMkt.oConn?.oOnAlert(ConnectionMkt.oConn,
                                  Connection.MSG_LOGIN_SUCCESS,
                                  null);

    if (Connection.iReconType != Connection.RECON_OFF)                              
      ConnectionMkt.oConn?.ResetRetry();

    // if (ConnectionHis.oConn != null)
    //   {
    //   //alert("History assertion failed");
    //   //console.trace();
    //   return;
    //   }

    // StartHis();

    // CompleteLoginMkt();
    }
  else
    {
    if (__DEV__)      
      Utilities.Sendlog("Market login failure...");

    ConnectionMkt.oConn?.NoRetry();

    ConnectionMkt.oConn?.oOnAlert(ConnectionMkt.oConn,
                                  Connection.MSG_LOGIN_FAIL,
                                  null);
    // setUsrInvalid(true);
    // setPwdInvalid(true);
    // CloseConnection();
    }
}

/*   ---------------------------------------------------------------------   */

public static GetSymbolsFromSettings_one_by_one(bReconnected : boolean = false)
{
  let oMsg : Uint8Array | null = null;

  /*   -------------------------------------------------------------------   */

  for (let i = 0; i < Connection.oSettings.length; i++)
    {
    let sToken  = Connection.oSettings[i].token;
    let iLBType = Connection.oSettings[i].iLookBack;
    let oVals   = Utilities.processToken(sToken);

    /*   -----------------------------------------------------------------   */

    if (oVals.length != 2)
      continue;

    /*   -----------------------------------------------------------------   */

    let sSymbol   = oVals[0];
    let sExchange = oVals[1];
    let oData : Data | undefined;

    /*   -----------------------------------------------------------------   */

    if (ConnectionMkt.oConn == null)
      continue;

    /*   -----------------------------------------------------------------   */

    //if (Utilities.FindItem(oStore, oSettings[i].token) == AppMain.IMAGINARY)
    oData = ConnectionMkt.oStore.get(sToken);

    if (oData == undefined)
      {
      oData = ConnectionMkt.getMktItem(sSymbol, sExchange, sToken);
      ConnectionMkt.oStore.set(sToken, oData);

      if (iLBType != undefined)
        oData.lookback = ConnectionHis.FindLookBack(iLBType);

      let book_levels = Connection.oSettings[i].iOBLevels;

      if (book_levels)
        oData.book_levels = book_levels;

      oData.sv_account = Connection.oSettings[i].sAccount;
      }

    /*   -----------------------------------------------------------------   */

    //oResp.bars = oResp.bbo = oResp.mode = oResp.ref = oResp.trade = 0;

    /*   -----------------------------------------------------------------   */

    //if (bReconnected == true)
      oMsg = ConnectionMkt.oConn.Rq_RefData_Merge(oMsg,
                                                  sSymbol,
                                                  sExchange,
                                                  sToken,
                                                  "auto");

    /*   -----------------------------------------------------------------   */

    ConnectionMkt.oConn?.Send(oMsg);
    oMsg = null;

    /*   -----------------------------------------------------------------   */

    // if (ConnectionMkt.bEco == true)
      oMsg = ConnectionMkt.oConn.Rq_Snapshot_Merge(oMsg,
                                                  sSymbol,
                                                  sExchange,
                                                  sToken)
    // else
    //   {
    //   oMsg = ConnectionMkt.oConn.Rq_Subscribe_Merge(oMsg,
    //                                                 sSymbol,
    //                                                 sExchange,
    //                                                 sToken);
    //   oData.sub_mkt = true;
    //   }


    ConnectionMkt.oConn?.Send(oMsg);
    oMsg = null;
    }

  /*   -------------------------------------------------------------------   */

  if (oMsg != null)
    {
    // Utilities.Sendlog("**Mkt: Store count: " + oStore.size);
    // iUpdate++;
    // bUpdate = true;

    //Utilities.Sendlog("Requesting Bars (auto) for symbols: " + Connection.oSettings.length + " from: " + Utilities.GetStartTime(oLookBack.LookbackMin) + " time - " + new Date( Utilities.GetStartTime(oLookBack.LookbackMin) * 1000).toString());

    if (__DEV__)
      Utilities.Sendlog("Requesting Ref Data (auto) for symbols: " + Connection.oSettings.length);
    // ConnectionMkt.oConn?.Send(oMsg);
    }

  if (ConnectionMkt.oConn != null)
    ConnectionMkt.oConn.bInitRequestSent = true;
}

/*   ---------------------------------------------------------------------   */

public static GetSymbolsFromSettings(bReconnected : boolean = false)
{
  let oMsg : Uint8Array | null = null;

  /*   -------------------------------------------------------------------   */

  for (let i = 0; i < Connection.oSettings.length; i++)
    {
    let sToken  = Connection.oSettings[i].token;
    let iLBType = Connection.oSettings[i].iLookBack;
    let oVals   = Utilities.processToken(sToken);

    /*   -----------------------------------------------------------------   */

    if (oVals.length != 2)
      continue;

    /*   -----------------------------------------------------------------   */

    let sSymbol   = oVals[0];
    let sExchange = oVals[1];
    let oData : Data | undefined;

    /*   -----------------------------------------------------------------   */

    if (ConnectionMkt.oConn == null)
      continue;

    /*   -----------------------------------------------------------------   */

    //if (Utilities.FindItem(oStore, oSettings[i].token) == AppMain.IMAGINARY)
    oData = ConnectionMkt.oStore.get(sToken);

    if (oData == undefined)
      {
      oData = ConnectionMkt.getMktItem(sSymbol, sExchange, sToken);
      ConnectionMkt.oStore.set(sToken, oData);

      if (iLBType != undefined)
        oData.lookback = ConnectionHis.FindLookBack(iLBType);

      let book_levels = Connection.oSettings[i].iOBLevels;

      if (book_levels)
        oData.book_levels = book_levels;

      oData.sv_account = Connection.oSettings[i].sAccount;
      }

    /*   -----------------------------------------------------------------   */

    //oResp.bars = oResp.bbo = oResp.mode = oResp.ref = oResp.trade = 0;

    /*   -----------------------------------------------------------------   */

    //if (bReconnected == true)
      oMsg = ConnectionMkt.oConn.Rq_RefData_Merge(oMsg,
                                                  sSymbol,
                                                  sExchange,
                                                  sToken,
                                                  "auto");

    /*   -----------------------------------------------------------------   */

    //ConnectionMkt.oConn?.Send(oMsg);
    //oMsg = null;

    /*   -----------------------------------------------------------------   */

    // if (ConnectionMkt.bEco == true)
      oMsg = ConnectionMkt.oConn.Rq_Snapshot_Merge(oMsg,
                                                   sSymbol,
                                                   sExchange,
                                                   sToken)
    // else
    //   {
    //   oMsg = ConnectionMkt.oConn.Rq_Subscribe_Merge(oMsg,
    //                                                 sSymbol,
    //                                                 sExchange,
    //                                                 sToken);
    //   oData.sub_mkt = true;
    //   }


    //ConnectionMkt.oConn?.Send(oMsg);
    //oMsg = null;
    }

  /*   -------------------------------------------------------------------   */

  if (oMsg != null)
    {
    // Utilities.Sendlog("**Mkt: Store count: " + oStore.size);
    // iUpdate++;
    // bUpdate = true;

    //Utilities.Sendlog("Requesting Bars (auto) for symbols: " + Connection.oSettings.length + " from: " + Utilities.GetStartTime(oLookBack.LookbackMin) + " time - " + new Date( Utilities.GetStartTime(oLookBack.LookbackMin) * 1000).toString());

    if (__DEV__)
      Utilities.Sendlog("Requesting ref data and snapshot (auto) for symbols: " + Connection.oSettings.length);

    ConnectionMkt.oConn?.Send(oMsg);
    }

  //ConnectionMkt.oConn?.Rq_Binary_RefData();

  if (ConnectionMkt.oConn != null)
    ConnectionMkt.oConn.bInitRequestSent = true;
}

/*   ---------------------------------------------------------------------   */

static ProcessUlying(keys      : any[],
                     values    : any[],
                     usrmgs   : any[])
{
if (usrmgs[2] == "update_underlying")
  {
  if (usrmgs[3]) //token
    {
    let oData = ConnectionMkt.oStore.get(usrmgs[3]);

    if (oData != undefined)
      {
      for (let i = 0; i < keys.length; i++)
        {
        switch(keys[i])
          {
          case MnmIds.MNM_IS_UNDERLYING_FOR_BINARY_CONTRACTS:
            if (values[i].toLowerCase() == "yes")
              oData.is_evt_enabled = true;
    
            if (__DEV__)
              Utilities.Sendlog("sim: event contract underlying: " + oData.token + " " + values[i]);

            ConnectionMkt.oConn?.oOnAlert(ConnectionMkt.oConn,
                                          Connection.MSG_EVT_AVBL,
                                          oData);

            break;
          }
        }
      }
    }

  return(true);
  }

return(false);
}

/*   ---------------------------------------------------------------------   */

static ProcessRefData(oKeys      : any[],
                      oValues    : any[],
                      oUsrMsgs   : any[])
{
if (Connection.getResonseCode(oKeys, oValues) == Connection.NO_ERROR)
  {
  ConnectionMkt.AddSymbol(oUsrMsgs[0], oUsrMsgs[2] != "auto", oUsrMsgs[3], oUsrMsgs[2]);
  return(true);
  }
else
  {
  if (oUsrMsgs[1] == "cycle")
    {
    ConnectionMkt.GetSymbolInfo(oUsrMsgs[0].toUpperCase(), oUsrMsgs[2], oUsrMsgs[3]);
    return(false);
    }
  else
      {
      //alert("ref fail2");

      if (__DEV__)
        Utilities.Sendlog("invalid symbol..." + oUsrMsgs[0] + " " + Utilities.GetKeyValueString(oKeys, oValues));
      //setSymInvalid(true);

      ConnectionMkt.oConn?.oOnAlert(ConnectionMkt.oConn,
                                    Connection.MSG_REF_DATA_FAIL,
                                    null);

      // if (m_update_txt)
      //   m_update_txt(1);

      return(false);
      }
  }
}

/*   ---------------------------------------------------------------------   */

static ReOrder()
{
  if (Connection.oSettings != null)
    {
    if (__DEV__)      
      Utilities.Sendlog("reordering...");  
    //oSettings = oSettAlt;

    let   oStoreLocal = new Map();
      
    for (let i = 0; i < Connection.oSettings.length; i++)
        oStoreLocal.set(Connection.oSettings[i].token,
                        ConnectionMkt.oStore.get (Connection.oSettings[i].token));


    Connection.oStore = oStoreLocal;
    //oSettAlt  = null;
    }
}

/*   -------------------------------------------------------------------   */

static AddSymbol(sToken        : string,
                 bUpdateNow    : boolean,
                 sReplaceToken : string,
                 sUsrMsg       : string)
{

  let oVals = Utilities.processToken(sToken);


  /*   -------------------------------------------------------------------   */

  if (oVals.length != 2)
    return;

  /*   -------------------------------------------------------------------   */

  let sSymbol   = oVals[0];
  let sExchange = oVals[1];

  let bManual   = bUpdateNow;
  
  let oData : Data | undefined;

  /*   -------------------------------------------------------------------   */

  //if (Utilities.FindItem(oStore, sToken) == AppMain.IMAGINARY)
  oData = ConnectionMkt.oStore.get(sToken);

  /*   -------------------------------------------------------------------   */

  if (oData == undefined)
    {
    oData = ConnectionMkt.getMktItem(sSymbol, sExchange, sToken);
    ConnectionMkt.oStore.set(sToken, oData);

    if (bUpdateNow == true)
      {
      let bUpdated = false;

      if (sUsrMsg && sUsrMsg.startsWith("add_next"))
        {
          bManual    = false;
          let tokens = sUsrMsg.split(' ');

          if (tokens.length == 2)
            {
            let z = Utilities.FindItem(Connection.oSettings, tokens[1]);

            if (z != AppMain.IMAGINARY) //if underlying found
              {
              //Connection.oSettings.splice(z, 1);

              //z = Utilities.FindItem(Connection.oSettings, tokens[1]);              

              //if (z != AppMain.IMAGINARY) //if underlying found
                {
                Connection.oSettings.splice(z + 1, 0, {token:sToken});
                ConnectionMkt.ReOrder();
                ConnectionOrd.SaveSettings();
                bUpdated = true;
                }
              }
            }
        }

      if (bUpdated == false)
        ConnectionOrd.SaveSettings(sToken, false, sReplaceToken, bManual, oData);
      }
    }

  /*   -------------------------------------------------------------------   */

  if (sReplaceToken)
  {
  let oFromData = Connection.oStore.get(sReplaceToken);

  if (oFromData)
    {
    oData.lookback   = oFromData.lookback;
    oData.sv_account = oFromData.sv_account;
    }

  ConnectionMkt.RemoveSymbol(sReplaceToken);
  ConnectionMkt.ReOrder();
  }

  /*   -------------------------------------------------------------------   */

  oData.ref_data_got = true;

  /*   -------------------------------------------------------------------   */

  // if (oData.instr_type == "Future" && oData.evt_got == false)
  //   {
  //   oData.evt_got = true;
  //   ConnectionMkt.oConn?.Rq_Binary_RefData(oData.trading_symbol? oData.trading_symbol:oData.symbol, oData.token);
  //   }

  /*   -------------------------------------------------------------------   */

  //Utilities.Sendlog("*******added: " + sToken + " - " + oStore.length);

  //eco dis
  //if (ConnectionMkt.bEco == false)
    {
    if (bUpdateNow == true)
      {
      ConnectionMkt.oConn?.Rq_Subscribe(sSymbol, sExchange, sToken);
      oData.sub_mkt = true;
      }
    }
  //eco dis
  //else
  //  ConnectionMkt.oConn?.Rq_Snapshot(sSymbol, sExchange, sToken);

  /*   -------------------------------------------------------------------   */

  if (ConnectionHis.oConn?.GetLoginStatus() == true && bUpdateNow == true)
    {
    //ConnectionHis.FindLookBack(oData.lookback.LookbackType)
    ConnectionHis.oConn?.Rq_GetBars(sSymbol, sExchange, sToken,
                                    oData.lookback);
                                    //ConnectionHis.oDefaultLookBack);
    ConnectionHis.oConn?.Rq_Subscribe(sSymbol, sExchange, sToken,
                                      oData.lookback);
                                      //ConnectionHis.oDefaultLookBack);
    oData.sub_bars = true;
    }

  /*   -------------------------------------------------------------------   */


  // ConnectionMkt.oConn?.oOnAlert(ConnectionMkt.oConn,
  //                               Connection.MSG_REF_DATA_SUCCESS,
  //                               bUpdateNow);

  //iUpdate++;

  /*   -------------------------------------------------------------------   */

  // if (bUpdateNow == true)
  //   {
  //   setUpdateUI(iUpdate);
  //   }
  // else
  //   bUpdate = true;
}

/*   ---------------------------------------------------------------------   */

  static RemoveSymbol(sToken : string)
  {
    if (sToken.length == 0)
    return(false);

  // let oData = Connection.oStoreAddl.get(sToken);  

  // if (oData == undefined)
  let oData = Connection.oStore.get(sToken);

  if (oData != undefined)
    {
    if (oData.sub_opt == false)
      ConnectionMkt.oConn?.Rq_Unsubscribe(oData.symbol,
                                          oData.exchange,
                                          oData.token);
    oData.sub_mkt = false;
    //oData.sub_opt = false;


    if (oData.sub_bars == true)
      {
      ConnectionHis.oConn?.Rq_Unsubscribe(oData.symbol,
                                          oData.exchange,
                                          oData.token,
                                          oData.lookback);

      oData.sub_bars = false;
      }

    if (Connection.oStore.delete(sToken))
      {
      if (__DEV__)        
        Utilities.Sendlog("Deleted: " + sToken);
      }

    ConnectionMkt.UnassignDataFromOB(oData);

    if (sToken == AppMain.sDef_Symbol)
      {
      ConnectionOrd.SetDefSymbol(undefined);
      }

    return(true);
    }
  else
    {
    if (__DEV__)
      Utilities.Sendlog("Not found to unsub: " + sToken);
    }

  return(false);
  }

 /*   --------------------------------------------------------------------   */

 static AddSymbolSub(oData : Data)
 {
 if (oData != undefined)
   {
  if (oData.sub_mkt == false)
    {
    if (__DEV__)      
      Utilities.Sendlog("Visible items: add sub: " + oData.token);

    if  (oData.sub_opt == false)
      ConnectionMkt.oConn?.Rq_Subscribe(oData.symbol,
                                        oData.exchange,
                                        oData.token);
    oData.sub_mkt = true;
    //}


  if (oData.sub_bars == false)
    {
     ConnectionHis.oConn?.Rq_Subscribe(oData.symbol,
                                       oData.exchange,
                                       oData.token,
                                       oData.lookback);

     oData.sub_bars = true;
     }


  // ConnectionMkt.oConn?.oOnAlert(ConnectionMkt.oConn,
  //                               Connection.MSG_SUBSCRIBE,
  //                               oData.token);

  if (oData.visible_index == 1)
     {
     if (ConnectionMkt.SubscribeOB(oData))
        ConnectionMkt.oConn?.oOnAlert(ConnectionMkt.oConn,
                                      Connection.MSG_SUB_OB,
                                      oData.token,
                                      oData);
    

     }
    }

  /*   ------------------------------------------------------------   */

  // if (oData.visible_index != 3)
  //   return;

  let oEvData : EvtData | undefined;
  
  if (oData.evt_exp && oData.evt_index < oData.evt_exp.length)
    {
    oEvData = oData.evt_exp[oData.evt_index];//ConnectionMkt.GetEvtData(oData);
    }
    

  if (oEvData && oEvData.oEvtList)
    {
    for (var [dStrike, oEvtItem] of oEvData.oEvtList.entries()) 
      {
      if (oEvtItem.oCallData)
        {
        ConnectionMkt.oConn?.Rq_Subscribe(oEvtItem.oCallData.symbol,
                                          oEvtItem.oCallData.exchange,
                                          oEvtItem.oCallData.token);
        oEvtItem.oCallData.sub_opt = true;

        //let oData = Conne
        }

      if (oEvtItem.oPutData)
        {
        ConnectionMkt.oConn?.Rq_Subscribe(oEvtItem.oPutData.symbol,
                                          oEvtItem.oPutData.exchange,
                                          oEvtItem.oPutData.token);
        oEvtItem.oPutData.sub_opt = true;
        }          
      }
    }

  /*   ------------------------------------------------------------   */      


   return(true);
   }
 else
  return(false);
 }

/*   --------------------------------------------------------------------   */

 static AddSymbolSubConform(oData : Data)
 {
 if (oData != undefined)
  {
  if (oData.sub_mkt == true)
    {
    if (__DEV__)      
      Utilities.Sendlog("Visible items: add sub conform: " + oData.token);

    if  (oData.sub_opt == false)
      ConnectionMkt.oConn?.Rq_Subscribe(oData.symbol,
                                        oData.exchange,
                                        oData.token);
    //oData.sub_mkt = true;
    //}


  if (oData.sub_bars == true)
    {
     ConnectionHis.oConn?.Rq_Subscribe(oData.symbol,
                                       oData.exchange,
                                       oData.token,
                                       oData.lookback);

     //oData.sub_bars = true;
     }


  // ConnectionMkt.oConn?.oOnAlert(ConnectionMkt.oConn,
  //                               Connection.MSG_SUBSCRIBE,
  //                               oData.token);

    if (oData.visible_index == 1)
      ConnectionMkt.SubscribeOB(oData, false, true);
    }

  /*   ------------------------------------------------------------   */

  // if (oData.visible_index != 3)
  //   return;

  //let oEvData = ConnectionMkt.GetEvtData(oData);

  let oEvData : EvtData | undefined;
  
  if (oData.evt_exp && oData.evt_index < oData.evt_exp.length)
    {
    oEvData = oData.evt_exp[oData.evt_index];//ConnectionMkt.GetEvtData(oData);
    }


  if (oEvData && oEvData.oEvtList)
    {
    for (var [dStrike, oEvtItem] of oEvData.oEvtList.entries()) 
      {
      if (oEvtItem.oCallData)
        {
        if (oEvtItem.oCallData.sub_opt == true)
          ConnectionMkt.oConn?.Rq_Subscribe(oEvtItem.oCallData.symbol,
                                            oEvtItem.oCallData.exchange,
                                            oEvtItem.oCallData.token);
        //oEvtItem.oCallData.sub_opt = true;

        //let oData = Conne
        }

      if (oEvtItem.oPutData)
        {
        if (oEvtItem.oPutData.sub_opt == true)
          ConnectionMkt.oConn?.Rq_Subscribe(oEvtItem.oPutData.symbol,
                                            oEvtItem.oPutData.exchange,
                                            oEvtItem.oPutData.token);
        //oEvtItem.oPutData.sub_opt = true;
        }          
      }
    }

  /*   ------------------------------------------------------------   */      


   return(true);
   }
 else
  return(false);
 }

/*   --------------------------------------------------------------------   */

  static RemoveSymbolSub(oData : Data)
  {
  if (oData != undefined)
    {
    if (oData.sub_mkt == true)
      {
      if (oData.sub_opt == false)
        ConnectionMkt.oConn?.Rq_Unsubscribe(oData.symbol,
                                            oData.exchange,
                                            oData.token);
      oData.sub_mkt = false;
      }


    if (oData.sub_bars == true)
      {
      ConnectionHis.oConn?.Rq_Unsubscribe(oData.symbol,
                                          oData.exchange,
                                          oData.token,
                                          oData.lookback);

      oData.sub_bars = false;
      }

    if (oData.visible_index == 1)
      {
      ConnectionMkt.UnSubscribeOB(oData);
      //oData.obo_visible = false;
      }


    /*   ------------------------------------------------------------   */

    //let oEvData = ConnectionMkt.GetEvtData(oData);
    let oEvData : EvtData | undefined;
  
    if (oData.evt_exp && oData.evt_index < oData.evt_exp.length)
      {
      oEvData = oData.evt_exp[oData.evt_index];//ConnectionMkt.GetEvtData(oData);
      }
  

    if (oEvData && oEvData.oEvtList)
      {
      for (var [dStrike, oEvtItem] of oEvData.oEvtList.entries()) 
        {
        if (oEvtItem.oCallData && 
            oEvtItem.oCallData.sub_mkt == false && oEvtItem.oCallData.sub_opt == true)
          {
          ConnectionMkt.oConn?.Rq_Unsubscribe(oEvtItem.oCallData.symbol,
                                              oEvtItem.oCallData.exchange,
                                              oEvtItem.oCallData.token);
          oEvtItem.oCallData.sub_opt = false;
          }

        if (oEvtItem.oPutData && 
            oEvtItem.oPutData.sub_mkt == false && oEvtItem.oPutData.sub_opt == true)
          {
          ConnectionMkt.oConn?.Rq_Unsubscribe(oEvtItem.oPutData.symbol,
                                              oEvtItem.oPutData.exchange,
                                              oEvtItem.oPutData.token);
          oEvtItem.oPutData.sub_opt = false;
          }          
        }
      }

    /*   ------------------------------------------------------------   */      

    return(true);
    }
  else
    return(false);
  }

/*   --------------------------------------------------------------------   */

static RemoveSymbolSubOpt(sToken : string | undefined)
{
if (sToken == undefined)
  {
    if (__DEV__)    
      Utilities.Sendlog("Event Contract: token undefined");

    return;
  }

let oData = Connection.oStoreAddl.get(sToken);

if (oData == undefined)
  {
  if (__DEV__)    
    Utilities.Sendlog("Event Contract: data undefined for " + sToken);

  return;
  }

if (oData.sub_mkt == false && oData.sub_opt == true)
  {
  ConnectionMkt.oConn?.Rq_Unsubscribe(oData.symbol,
                                      oData.exchange,
                                      oData.token);

  
  }

  oData.sub_opt = false;
// oData = Connection.oStore.get(sToken);

// if (oData)
//   oData.sub_opt = false;
}

/*   --------------------------------------------------------------------   */

static AddSymbolSubOpt(sToken : string | undefined)
{
if (sToken == undefined)
  {
  if (__DEV__)    
    Utilities.Sendlog("Event Contract: token undefined");

  return;
  }

let oData = Connection.oStoreAddl.get(sToken);

if (oData == undefined)
  {
  if (__DEV__)    
    Utilities.Sendlog("Event Contract: data undefined for " + sToken);

  return;
  }

//if (oData.sub_mkt == false)
  ConnectionMkt.oConn?.Rq_Subscribe(oData.symbol,
                                    oData.exchange,
                                    oData.token);

oData.sub_opt = true;

// let oGData = Connection.oStore.get(sToken);

// if (oGData)
//   oGData.sub_opt = true;

return(oData);
}

/*   --------------------------------------------------------------------   */

static getFmt(price : number | undefined,
              oData : Data)
{
if (price == undefined)
  return("");

if (oData.display_fmt)
  return(PriceFormat.getFlaggedDisplayFormat(price, oData.display_fmt));
else
  return(price.toFixed(oData.f2qp));
}

/*   -------------------------------------------------------------------   */

static getFmtUndefined(price : number | undefined,
                       oData : Data)
{
if (price == undefined)
  return(undefined);

if (oData.display_fmt)
  return(PriceFormat.getFlaggedDisplayFormat(price, oData.display_fmt));
else
  return(price.toFixed(oData.f2qp));
}

/*   -------------------------------------------------------------------   */

static getFmtWithPad(price : number | undefined,
                     oData : Data,
                     sPad  : string)
{
if (price == undefined)
  return("");

if (oData.display_fmt)
return(sPad + PriceFormat.getFlaggedDisplayFormat(price, oData.display_fmt));
else
return(sPad + price.toFixed(oData.f2qp));
}

/*   -------------------------------------------------------------------   */

static getFmtPriceUndefined(price : number | undefined,
                            token : string | undefined)
{
if (price == undefined || token == undefined)
  return(undefined);

let oData = Connection.oStore.get(token);

if (oData == undefined)
return(price.toString());

if (oData.display_fmt)
return(PriceFormat.getFlaggedDisplayFormat(price, oData.display_fmt));
else
return(price.toFixed(oData.f2qp));
}

/*   -------------------------------------------------------------------   */

static getFmtPrice(price : number,
                   token : string)
{
let oData = Connection.oStore.get(token);

if (oData == undefined)
  return(price.toString());

if (oData.display_fmt)
return(PriceFormat.getFlaggedDisplayFormat(price, oData.display_fmt));
else
return(price.toFixed(oData.f2qp));
}

/*   -------------------------------------------------------------------   */

static RepopulateBookBlank(oOBData : OBData,
                           bForce  : boolean = false)
{
  if (bForce == true)
    {
    oOBData.book.splice(0, oOBData.book.length);  
    }
  else if (oOBData.book.length == oOBData.book_levels)
    return;

  for (let i = 0; i < oOBData.book_levels; i++)
  {
    let oItem      = new BookItem(i);
    oOBData.book.push(oItem);
  }
}

/*   -------------------------------------------------------------------   */

static RepopulateBook(oOBData : OBData,
                      oData   : Data)
{
let dAnchor : number | undefined = undefined;
let iAnchor : number;

/*   --------------------------------------------------------------------   */

if (__DEV__)
  Utilities.Sendlog("Populating book..." + oData.token);

//if (oData.trade_got == true)
  //{
  if (oData.last != undefined)
    dAnchor = oData.last;
  else if (oData.close)
    dAnchor = oData.close;
  else if (oData.settlement)
    dAnchor = oData.settlement;
  //}
//else if (oData.bbo_got == true)
  //{
  else if (oData.bid_size)
    dAnchor = oData.bid;
  else if (oData.ask_size)
    dAnchor = oData.ask;
  // else if (oData.settlement)
  //   dAnchor = oData.settlement;
  // else if (oData.close)
  //   dAnchor = oData.close;


//   else
//     {
//     ConnectionMkt.RepopulateBookBlank(oOBData);
//     return;    
//     }
//   }
// else
//   {
//   ConnectionMkt.RepopulateBookBlank(oOBData);
//   return;
//   }

if (dAnchor == undefined)
  {
   ConnectionMkt.RepopulateBookBlank(oOBData);
   return;
  }

/*   --------------------------------------------------------------------   */

if (__DEV__)
  Utilities.Sendlog(oData.token + " Anchor price: " + dAnchor);
//Utilities.Sendlog(JSON.stringify(oData));

/*   --------------------------------------------------------------------   */

oOBData.qpc         = oData.qpc;
oOBData.f2qp        = oData.f2qp;
iAnchor             = Math.round(dAnchor);

/*   --------------------------------------------------------------------   */

dAnchor += oData.qpc * oOBData.book_levels/2;

/*   --------------------------------------------------------------------   */

if (oOBData.book.length == 0)
  {
  for (let i = 0; i < oOBData.book_levels; i++)
    {
    let oItem      = new BookItem(i);
    
    oItem.Price      = Utilities.round(dAnchor - (i * oData.qpc), oData.f2qp);
    oItem.PriceKey   = ConnectionMkt.getFmt(oItem.Price, oData);

    // oItem.C_Price    = iAnchor - i;
    // oItem.C_PriceKey = ConnectionMkt.getFmt(oOBData.book[i].C_Price, 
    //                                         oData);
    
    oOBData.book.push(oItem);
    }
  }
else
  {
  //alert ("ticks changed: " + (oOBData.book[0].Price - dAnchor)/oData.qpc);

  if (oOBData.book[0].PriceKey                                          != "" &&
      Math.round( Math.abs(oOBData.book[0].Price - dAnchor)/oData.qpc ) < 10)
    {
    oOBData.clear = true;

    // Utilities.Sendlog("CLEARING book..." + oData.token);  
    // for (let i = 0; i < BOOK_LEVEL; i++)
    //   {
    //   oOBData.book[i].AskSize  = 0;
    //   oOBData.book[i].BidSize  = 0;
    //   }
  
    return;
    }

  for (let i = 0; i < oOBData.book_levels; i++)
    {
    oOBData.book[i].Price      = Utilities.round(dAnchor - (i * oData.qpc),
                                                 oData.f2qp);
    oOBData.book[i].PriceKey   = ConnectionMkt.getFmt(oOBData.book[i].Price, 
                                                      oData);

    // oOBData.book[i].C_Price    = iAnchor - i;
    // oOBData.book[i].C_PriceKey = ConnectionMkt.getFmt(oOBData.book[i].C_Price, 
    //                                                   oData);

    oOBData.book[i].AskSize     = 0;
    oOBData.book[i].BidSize     = 0;
    // oOBData.book[i].C_AskSize   = 0;
    // oOBData.book[i].C_BidSize   = 0;    
    }
  }
}

/*   --------------------------------------------------------------------   */

static GetSymbolInfo(sToken          : string | null | undefined,
                     sUsrMsg         : string = "",
                     sReplaceToken   : string = "") : number
{
  if (!sToken)
    {
    if (__DEV__)      
      Utilities.Sendlog("symbol is empty...");

    //if (m_update_txt)
    //  m_update_txt(true);

    return(ReturnTypes.ERR_EMPTY);
    }

  let oData = ConnectionMkt.oStore.get(sToken);

  //if (Utilities.FindItem(oStore, sToken) != AppMain.IMAGINARY)
  //if (ConnectionMkt.oStore.has(sToken) == true)
  if (oData != undefined)
    {
    if (__DEV__)      
      Utilities.Sendlog("Duplicate symbol: " + sToken);
    //alert("duplicate");
    // if (OnUpdateError)
    //   OnUpdateError(2);

    if (sReplaceToken)
    {
    ConnectionOrd.SaveSettingsWithReplace(sToken, sReplaceToken);
    ConnectionMkt.RemoveSymbol(sReplaceToken);
    ConnectionMkt.ReOrder();

    ConnectionMkt.oConn?.oOnAlert(ConnectionMkt.oConn,
                                  Connection.MSG_REF_DATA_SUCCESS,
                                  true,
                                  oData);

    return(ReturnTypes.OK);
    }

    ConnectionMkt.oConn?.oOnAlert(ConnectionMkt.oConn,
                                  Connection.MSG_REF_DATA_DUPLICATE,
                                  sToken);

    return(ReturnTypes.ERR_DUPLICATE);
    }

  let oVals = Utilities.processToken(sToken);

  if (oVals.length != 2)
    {
    if (__DEV__)      
      Utilities.Sendlog("Invalid symbol: " + sToken);

    // if (OnUpdateError)
    //   OnUpdateError(1);

    return(ReturnTypes.ERR_INVALID);
    }

  let sSymbol   = oVals[0];
  let sExchange = oVals[1];

  if (sSymbol   != oVals[0].toUpperCase() ||
      sExchange != oVals[1].toUpperCase())
      ConnectionMkt.oConn?.Rq_RefData_Cycle(sSymbol, sExchange, sToken, sUsrMsg, sReplaceToken);
  else
      ConnectionMkt.oConn?.Rq_RefData_Final(sSymbol, sExchange, sToken, sUsrMsg, sReplaceToken);

  return(ReturnTypes.WAITING);
  }

/*   ---------------------------------------------------------------------   */

static ProcessOrderBook(sToken : string,
                        oData  : OBData,
                        keys   : any[], 
                        values : any[])
{
  let obid_price:number[] | undefined;
  let oask_price:number[] | undefined;

  let obid_size:number[] | undefined;
  let oask_size:number[] | undefined;
  let itype = 0;

  /*   ---------------------------------------------------------------------   */

  if (oData.book.length != oData.book_levels)
    return;

  /*   ---------------------------------------------------------------------   */

  for (let i = 0, j = keys.length; i < j; i++)
    {
    switch(keys[i])
      {
      case MnmIds.MNM_MARKET_DEPTH_BID_PRICE:
        if (obid_price == undefined)
           obid_price = new Array(0);

        obid_price.push(Utilities.round(values[i], oData.f2qp));
        break;
      case MnmIds.MNM_MARKET_DEPTH_BID_SIZE:
        if (obid_size == undefined)
           obid_size = new Array(0);

        obid_size.push(values[i]);
        break;
      case MnmIds.MNM_MARKET_DEPTH_ASK_PRICE:
        if (oask_price == undefined)
           oask_price = new Array(0);

        oask_price.push(Utilities.round(values[i], oData.f2qp));
        break;
      case MnmIds.MNM_MARKET_DEPTH_ASK_SIZE:
        if (oask_size == undefined)
           oask_size = new Array(0);

        oask_size.push(values[i]);
        break;
      case MnmIds.MNM_MARKET_DEPTH_UPDATE_TYPE:
        itype = values[i];

        if (__DEV__)
          {
          if (itype == Rq.UpdateType.SNAPSHOT_IMAGE)
            {
            Utilities.Sendlog("OB response for " + sToken + " keys: " + keys.length + " bids: " + obid_price?.length + " asks: " + oask_price?.length);
            }
          else if (itype == Rq.UpdateType.NO_BOOK)
            {
            Utilities.Sendlog("OB response for " + sToken + " NO BOOK");
            }
          }

        // if (itype == Rq.UpdateType.NO_BOOK)
        //   Utilities.Sendlog("OB response for " + sToken + " NO BOOK");

        break;
      }
    }

/*   ---------------------------------------------------------------------   */

if (oData.clear == true)
    {
    if (__DEV__)
      {
      if (itype == Rq.UpdateType.SNAPSHOT_IMAGE)
        {
        Utilities.Sendlog("OB response for " + sToken + " data items: " + keys.length + " bids: " + obid_price?.length + " asks: " + oask_price?.length);
        //Utilities.Sendlog(Utilities.GetKeyValueString(keys, values));
        }
      else if (itype == Rq.UpdateType.NO_BOOK)
        Utilities.Sendlog("OB response for " + sToken + " NO BOOK");

      Utilities.Sendlog("CLEARING book..." + " bids: " + obid_price?.length + " asks: " + oask_price?.length);
      }

    for (let i = 0; i < oData.book_levels; i++)
      {
      oData.book[i].AskSize   = 0;
      oData.book[i].BidSize   = 0;
      // oData.book[i].C_AskSize = 0;
      // oData.book[i].C_BidSize = 0;      
      }

    oData.clear = false;

    if (__DEV__)
      Utilities.Sendlog("**Notifying book image for: " + sToken);

    ConnectionOrd.NotifyOrder(sToken);    
    }

/*   ---------------------------------------------------------------------   */    

if (obid_price && obid_size)
  {
  for (let i = 0, j = obid_price.length; i < j; i++)
    {
    if (obid_price[i] > oData.book[0].Price ||
        obid_price[i] < oData.book[oData.book_levels - 1].Price)
        continue;

    let iLevel = Math.round((oData.book[0].Price - obid_price[i])/oData.qpc);

    if (iLevel >= oData.book_levels)
      continue;

    oData.book[iLevel].BidSize = obid_size[i];
    }
  }

/*   ---------------------------------------------------------------------   */  

let price : number;

if (oask_price && oask_size)
  {
  for (let i = 0, j = oask_price.length; i < j; i++)
    {
    // price = Math.round(oask_price[i]);


    if (oask_price[i] > oData.book[0].Price ||
        oask_price[i] < oData.book[oData.book_levels - 1].Price)
        continue;

    let iLevel = Math.round((oData.book[0].Price - oask_price[i])/oData.qpc);

    if (iLevel >= oData.book_levels)
      continue;

    oData.book[iLevel].AskSize = oask_size[i];
    }
  }

//if (oData.symbol == "ES")
  {
  //Utilities.Sendlog("book => " + JSON.stringify(oData.book));
  }
}

/*   ---------------------------------------------------------------------   */

static UpdatePrice(oData  : OBData, 
                   prices : number[], 
                   sizes : number[])
{
//   for (let i = 0, j = oask_price.length; i < j; i++)  
// if (prices[i] > oData.book[0].Price ||
//     prices[i] < oData.book[BOOK_LEVEL - 1].Price)
//     return;

// let iLevel = Math.round((oData.book[0].Price - obid_price[i])/oData.qpc);

// if (iLevel >= BOOK_LEVEL)
//   continue;

// oData.book[iLevel].BidSize = obid_size[i];
}

/*   ---------------------------------------------------------------------   */

public static Rq_GetEventContracts(oData: Data)
{
//New_EVT    
//return;

if (oData.instr_type                     == "Future" && 
    oData.evt_got                        == false    && 
    oData.is_evt_enabled                 == true)
  {
  oData.evt_got       = true;
  oData.evt_org_token = oData.token;

  ConnectionMkt.oConn?.
  Rq_Binary_RefData(oData.trading_symbol? 
                    oData.trading_symbol:oData.symbol, 
                    oData.trading_exchange? 
                    oData.trading_exchange:oData.exchange, 
                    oData.token);
  }
}

/*   ---------------------------------------------------------------------   */

static ProcessMBO(keys, values, tokens, usrmsgs)
{
  //Utilities.Sendlog("MBO=> " + Utilities.GetKeyValueString(keys, values));

  let iSeqNo     : number | undefined;
  let dPrice     : number | undefined;
  let oSizes     : number[] = new Array(0);
  let oQP        : number[] = new Array(0);
  let oOrders    : string[] = new Array(0);

  let oData      : MBOData;
  let iIndex     : number | undefined;
  //let oOrdData   : OrdData | undefined;
  let oOBData    : OBData  | undefined;

  /*   -------------------------------------------------------------------   */

  let [symbol, exchange]  = tokens;

  /*   -------------------------------------------------------------------   */

  if (symbol && exchange)
    {
    let token   = symbol + "." + exchange;
    oOBData     = ConnectionMkt.oOBStore.get(token);

    if (oOBData == undefined || !oOBData.oMBOData?.length)
      {
      if (__DEV__)        
        Utilities.Sendlog("MBO RR: symbol not found");   

      return;
      }
    }
  else
    {
    return;
    }

  /*   -------------------------------------------------------------------   */

  oData                = oOBData.oMBOData[0];  //oOrdData.oMBO;

  oData.iQty           = 0;
  oData.iQtyAhead      = 0;
  oData.iQtyBehind     = 0;
  oData.iOrdersAhead   = 0;
  oData.iOrdersBehind  = 0;

  /*   -------------------------------------------------------------------   */

  for (let i = 0, j = keys.length; i < j; i++)  
    {
    switch (keys[i])
      {
      case MnmIds.MNM_RESPONSE_CODE:
          return;

      case MnmIds.MNM_SEQUENCE_NUMBER:
        iSeqNo   = values[i];

        // oOrdData = ConnectionOrd.oOrdStore.get(usrmsgs[0]);

        // if (oOrdData == undefined || oOrdData.oMBO?.iSeqNo == iSeqNo)
        //   {
        //   return;
        //   }

        break;

      case MnmIds.MNM_MARKET_DEPTH_PRICE:
        dPrice = values[i];
        break;

      case MnmIds.MNM_MARKET_DEPTH_SIZE:
        oSizes.push(values[i]);
        break;

      case MnmIds.MNM_MARKET_DEPTH_ORDER_PRIORITY:
        oQP.push(values[i]);
        break;

      case MnmIds.MNM_EXCH_ORD_ID:
        oOrders.push(values[i]);

        if (values[i] == oData.sExchOrdId) //usrmsgs[1])
          iIndex = oOrders.length - 1;
        break;

      }
    }

  /*   -------------------------------------------------------------------   */

  if (dPrice == undefined) // || oOrdData == undefined)
    {
    if (__DEV__)      
      Utilities.Sendlog(oData.dPrice + "=> MBO RR: price not found: " + oData.sExchOrdId);  

    return;
    }

  /*   -------------------------------------------------------------------   */

   if (iIndex == undefined) // || oOrdData == undefined)
    {
    if (__DEV__)      
      Utilities.Sendlog(oData.dPrice + "=> MBO RR: order not found: " + oData.sExchOrdId);  

    //return;
    }

  /*   -------------------------------------------------------------------   */

  // if (oOrdData.oMBO == undefined)
  //   {
  //   oData         = new MBOData()
  //   oOrdData.oMBO = oData;
  //   }
  // else
    // {
    // oData                = oOBData.oMBOData[0];  //oOrdData.oMBO;

    // oData.iQty           = 0;
    // oData.iQtyAhead      = 0;
    // oData.iQtyBehind     = 0;
    // oData.iOrdersAhead   = 0;
    // oData.iOrdersBehind  = 0;
    // }

  /*   -------------------------------------------------------------------   */

  oData.iSeqNo = iSeqNo? iSeqNo : 0;
  oData.dPrice = dPrice;

  if (iIndex != undefined)
    oData.iQP = oQP[iIndex];

  /*   -------------------------------------------------------------------   */

  for (let i = 0, j = oOrders.length; i < j; i++)
    {
    oData.oOrders.set(oOrders[i], new MBOOrder(oQP[i], oSizes[i]));

    if (iIndex == undefined)
      continue;

    if (oQP[i] > oData.iQP)
      {
      oData.iQtyBehind += oSizes[i];
      oData.iOrdersBehind++;
      }
    else if (oQP[i] < oData.iQP)
      {
      oData.iQtyAhead += oSizes[i];
      oData.iOrdersAhead++;
      }
    else
      {
      oData.iQty = oSizes[i];
      }
    }

  if (__DEV__)
    Utilities.Sendlog(oData.dPrice + "=> MBO RR: processed RR");    
}

/*   ---------------------------------------------------------------------   */

static RecalculateMBO(oData        : MBOData,
                      sExchOrderId : string)
{
let oOrder = oData.oOrders.get(sExchOrderId);

if (oOrder == undefined)
  return;

oData.iQty           = oOrder.iSize;
oData.iQP            = oOrder.iQP;
oData.iQtyAhead      = 0;
oData.iQtyBehind     = 0;
oData.iOrdersAhead   = 0;
oData.iOrdersBehind  = 0;

for (let [key, oOther] of oData.oOrders.entries())
  {
  if (oOther.iQP > oData.iQP)
    {
    oData.iQtyBehind += oOther.iSize;
    oData.iOrdersBehind++;
    }
  else if (oOther.iQP < oData.iQP)
    {
    oData.iQtyAhead += oOther.iSize;
    oData.iOrdersAhead++;
    }
  }

  if (__DEV__)
    Utilities.Sendlog(oData.dPrice + "=> MBO: recalc"); 
}

/*   ---------------------------------------------------------------------   */

static ProcessMBOUpdates(keys, values, tokens, usrmsgs)
{
  //Utilities.Sendlog("MBO=> " + Utilities.GetKeyValueString(keys, values));
  
  
  let iSeqNo      : number | undefined = undefined;

  let oSizes      : number[]  = new Array(0);
  let oQP         : number[]  = new Array(0);
  let oUpdates    : number[]  = new Array(0);

  let oOrders     : string[]  = new Array(0);
  let oPrices     : number[]  = new Array(0);

  let oPrev       : number[]  | undefined;
  let oPrevFlag   : boolean[] | undefined;

  let iIndex      : number | undefined = undefined;
  let oOrdData    : OrdData | undefined;
  let oOBData     : OBData  | undefined;

  /*   -------------------------------------------------------------------   */

  let [symbol, exchange]  = tokens;

  /*   -------------------------------------------------------------------   */

  if (symbol && exchange)
    {
    let token   = symbol + "." + exchange;
    oOBData     = ConnectionMkt.oOBStore.get(token);

    if (oOBData == undefined || !oOBData.oMBOData?.length)
      {
      if (__DEV__)        
        Utilities.Sendlog("MBO: price not found...");

      return;
      }
    }
  else
    {
    if (__DEV__)      
      Utilities.Sendlog("MBO: symbol not found...");

    return;
    }

  /*   -------------------------------------------------------------------   */

  let oMBOPrice  = oOBData.oMBOData[0];  //oOrdData.oMBO;

  /*   -------------------------------------------------------------------   */

  for (let i = 0, j = keys.length; i < j; i++)  
    {
    switch (keys[i])
      {
      case MnmIds.MNM_SEQUENCE_NUMBER:
        iSeqNo   = Number(values[i]);
        break;

      case MnmIds.MNM_MARKET_DEPTH_PRICE:
        oPrices.push(values[i]);
        break;

      case MnmIds.MNM_UPDATE_TYPE:
        oUpdates.push(values[i]);
        break;

      case MnmIds.MNM_PREVIOUS_MARKET_DEPTH_PRICE:
        if (oPrev == undefined)
          oPrev = new Array(0);

        oPrev.push(values[i]);
        break;

      case MnmIds.MNM_PREVIOUS_MARKET_DEPTH_PRICE_FLAG:
        if (oPrevFlag == undefined)
          oPrevFlag = new Array(0);

        oPrevFlag.push(values[i]);
        break;

      case MnmIds.MNM_MARKET_DEPTH_SIZE:
        oSizes.push(values[i]);
        break;

      case MnmIds.MNM_MARKET_DEPTH_ORDER_PRIORITY:
        oQP.push(values[i]);
        break;

      case MnmIds.MNM_EXCH_ORD_ID:
        oOrders.push(values[i]);

        if (values[i] == oMBOPrice.sExchOrdId)
           iIndex = oOrders.length - 1;
        break;

      }
    }

  /*   -------------------------------------------------------------------   */

  if (iSeqNo)
    oMBOPrice.iSeqNo = iSeqNo;

  /*   -------------------------------------------------------------------   */

  let bRecalc;

  for (let i = 0; i < oOrders.length; i++)
  {
  //some other price
  if (oMBOPrice.dPrice != oPrices[i])
    {
    //price change to an uninterested price  
    if (oPrevFlag && oPrevFlag[i] && oPrev && oPrev[i] == oMBOPrice.dPrice && oUpdates[i] == Rq.MBOUpdateType.CHANGE) //a previous price exists
      {
      oUpdates[i] = Rq.MBOUpdateType.DELETE;

      if (__DEV__)
        Utilities.Sendlog(oMBOPrice.dPrice + "=> MBO: modify out-> " + oOrders[i] + " remove...");
      }
    else
      continue;
    }

  switch(oUpdates[i])
    {
    case Rq.MBOUpdateType.CHANGE:
      let oOrder = oMBOPrice.oOrders.get(oOrders[i]);

      //add if order not found
      if (oOrder == undefined)
        {
        // if (iIndex != undefined)
        if (oOrders[i] != oMBOPrice.sExchOrdId)
          {
          if (oQP[i] > oMBOPrice.iQP)
            {
            oMBOPrice.iQtyBehind += oSizes[i];
            oMBOPrice.iOrdersBehind++;
            }
          else if (oQP[i] < oMBOPrice.iQP)
            {
            oMBOPrice.iQtyAhead   += oSizes[i];
            oMBOPrice.iOrdersAhead++;
            }
          }
        else
          {
          //oMBOPrice.iQP  = oQP[i];
          //oMBOPrice.iQty = oSizes[i];
          bRecalc        = true;
          }
        // else if (oOrders[i] != oMBOPrice.sExchOrdId)
        //   {  
        //   oMBOPrice.iQtyBehind += oSizes[i];
        //   oMBOPrice.iOrdersBehind++;
        //   }

        oMBOPrice.oOrders.set(oOrders[i], new MBOOrder(oQP[i], oSizes[i]));

        if (__DEV__)
          Utilities.Sendlog(oMBOPrice.dPrice + "=> MBO change: " + oOrders[i] + " order not found, add..." + oMBOPrice.dPrice + "=> " + oMBOPrice.iOrdersBehind + " 1 " + oMBOPrice.iOrdersAhead);

        continue;
        }
    
      //size increase, put it behind        
      if (oMBOPrice.iQP != oQP[i]) 
        {
        //remove old
        if (oOrder.iQP > oMBOPrice.iQP)
          {
          oMBOPrice.iQtyBehind -= oOrder.iSize;
          oMBOPrice.iQtyBehind += oSizes[i];
          }
        else if (oOrder.iQP < oMBOPrice.iQP)
          {
          oMBOPrice.iQtyAhead -= oOrder.iSize;
          oMBOPrice.iOrdersAhead--;

          oMBOPrice.iQtyBehind += oSizes[i];
          oMBOPrice.iOrdersBehind++;
          }

        oOrder.iQP   = oQP[i];
        oOrder.iSize = oSizes[i];

        if (__DEV__)
          Utilities.Sendlog(oMBOPrice.dPrice + "=> MBO change: " + oOrders[i] + " size increase, put it behind..." + oMBOPrice.dPrice + "=> " + oMBOPrice.iOrdersBehind + " 1 " + oMBOPrice.iOrdersAhead);
        }
      //size decrease  
      else 
        {
        if (oOrder.iQP > oMBOPrice.iQP)
          {
          oMBOPrice.iQtyBehind -= oOrder.iSize;
          oMBOPrice.iQtyBehind += oSizes[i];
          }
        else if (oOrder.iQP < oMBOPrice.iQP)
          {
          oMBOPrice.iQtyAhead   -= oOrder.iSize;
          oMBOPrice.iQtyAhead   += oSizes[i];
          }

        oOrder.iSize = oSizes[i];

        if (__DEV__)
          Utilities.Sendlog(oMBOPrice.dPrice + "=> MBO change: " + oOrders[i] + " size decrease, stay put..." + oMBOPrice.dPrice + "=> " + oMBOPrice.iOrdersBehind + " 1 " + oMBOPrice.iOrdersAhead);
        }
      break;

    case Rq.MBOUpdateType.DELETE:
      oOrder = oMBOPrice.oOrders.get(oOrders[i]);

      //do nothing if order is not found
      if (oOrder == undefined)
        {

        if (__DEV__)
          Utilities.Sendlog(oMBOPrice.dPrice + "=> MBO delete: " + oOrders[i] + " order not found...");

        continue;
        }
    
      //remove order  
      //if (oQP[i] > oMBOPrice.iQP)
      if (oOrder.iQP > oMBOPrice.iQP)
        {
        oMBOPrice.iQtyBehind -= oOrder.iSize;
        oMBOPrice.iOrdersBehind--;
        }
      else if (oOrder.iQP < oMBOPrice.iQP)
        {
        oMBOPrice.iQtyAhead -= oOrder.iSize;
        oMBOPrice.iOrdersAhead--;
        }
      else
        {
        //anchor order removed
        oMBOPrice.iQtyBehind    = 0;
        oMBOPrice.iQtyAhead     = 0;

        oMBOPrice.iOrdersBehind = 0;
        oMBOPrice.iOrdersAhead  = 0;
        }

      //delete mbo order
      oMBOPrice.oOrders.delete(oOrders[i]);

      if (__DEV__)
        Utilities.Sendlog(oMBOPrice.dPrice + "=> MBO delete: " + oOrders[i] + " remove..." + oMBOPrice.dPrice + "=> " + oMBOPrice.iOrdersBehind + " 1 " + oMBOPrice.iOrdersAhead);
      break;

    case Rq.MBOUpdateType.NEW:
        //add new
        oMBOPrice.iQtyBehind         += oSizes[i];
        oMBOPrice.iOrdersBehind++;
        oMBOPrice.oOrders.set(oOrders[i], new MBOOrder(oQP[i], oSizes[i]));

        if (__DEV__)
          Utilities.Sendlog(oMBOPrice.dPrice + "=> MBO new: " + oOrders[i] + " add behind..." + oMBOPrice.dPrice + "=> " + oMBOPrice.iOrdersBehind + " 1 " + oMBOPrice.iOrdersAhead);
      break;      
    }
  }

  if (bRecalc)
    ConnectionMkt.RecalculateMBO(oMBOPrice, oMBOPrice.sExchOrdId);

  // if (iIndex == undefined || oOrdData == undefined)
  //   return;

  // /*   -------------------------------------------------------------------   */

  // if (oOrdData.oMBO == undefined)
  //   {
  //   oData         = new MBOData()
  //   oOrdData.oMBO = oData;
  //   }
  // else
  //   {
  //   oData                = oOrdData.oMBO;

  //   oData.iQty           = 0;
  //   oData.iQtyAhead      = 0;
  //   oData.iQtyBehind     = 0;
  //   oData.iOrdersAhead   = 0;
  //   oData.iOrdersBehind  = 0;
  //   }

  // /*   -------------------------------------------------------------------   */

  // oData.iSeqNo = iSeqNo? iSeqNo : 0;
  // oData.dPrice = dPrice? dPrice : 0;

  // /*   -------------------------------------------------------------------   */

  // for (let i = 0, j = oOrders.length; i < j; i++)
  //   {
  //   if (oQP[i] > oQP[iIndex])
  //     {
  //     oData.iQtyBehind += oSizes[i];
  //     oData.iOrdersBehind++;
  //     }
  //   else if (oQP[i] < oQP[iIndex])
  //     {
  //     oData.iQtyAhead += oSizes[i];
  //     oData.iOrdersAhead++;
  //     }
  //   else
  //     {
  //     oData.iQty = oSizes[i];
  //     }
  //   }
}

/*   ---------------------------------------------------------------------   */

public static AddMBOOrder()
{

}

/*   ---------------------------------------------------------------------   */

private static oWs_Mkt_onmessage(x : any[][])
  {
  let [template, keys, values, tokens, usermsgs] = x;

  /*   -------------------------------------------------------------------   */

  ConnectionMkt.iMsg++;

  /*   -------------------------------------------------------------------   */

  //Utilities.Sendlog("ALL response: " + Utilities.GetKeyValueString(keys, values));

  switch (template[0])
    {
    case TemplateId.FORCED_LOGOUT:

      if (__DEV__)
        Utilities.Sendlog("Mkt FORCE logout: " + Utilities.GetKeyValueString(keys, values));

      ConnectionMkt.oConn?.oOnAlert(ConnectionMkt.oConn,
                                    Connection.MSG_FORCE_LOGOUT,
                                    null);

      return;

    case TemplateId.REJECT_RESPONSE:
      if (ConnectionMkt.oConn)
        {
        ConnectionMkt.oConn.sLastReject =  Utilities.formatTimeStatusbar(Date.now()) + ": " + 
                                           Utilities.GetKeyValueStringForce(keys, values);
        }

      if (__DEV__)
        Utilities.Sendlog("****????Mkt REJECT response: " + ConnectionMkt.oConn?.sLastReject);
      return;


    case TemplateId.DEPTH_BY_ORDER_SNAPSHOT_RESPONSE:
      ConnectionMkt.ProcessMBO(keys, values, tokens, usermsgs);
      return;

    case TemplateId.DEPTH_BY_ORDER_END_EVENT:
      //symbol, exchange, seq no
      if (__DEV__)
        Utilities.Sendlog("MBO update end: " + usermsgs[0] + ": " + Utilities.GetKeyValueString(keys, values));
      return;
    case TemplateId.DEPTH_BY_ORDER_UPDATES_RESPONSE:
      //resp code
      if (__DEV__)
        Utilities.Sendlog("MBO update resp: " + usermsgs[0] + ": " + Utilities.GetKeyValueString(keys, values));
      return;            

    case TemplateId.DEPTH_BY_ORDER:
      if (__DEV__)
        Utilities.Sendlog("MBO update: " + Utilities.GetKeyValueString(keys, values));

      ConnectionMkt.ProcessMBOUpdates(keys, values, tokens, usermsgs);
      //symbol, exchange, seq no //ConnectionMkt.ProcessMBO(keys, values, tokens, usermsgs);
      return;            


    case TemplateId.HEARTBEAT_RESPONSE:
        if (usermsgs[0])
          ConnectionMkt.iLastSsboeHb = parseInt(usermsgs[0]) ;

        //Utilities.Sendlog("Mkt Hb: " + ConnectionMkt.iLastSsboeHb);
        return;
    case TemplateId.MARKET_DATA_UPDATE_RESPONSE:
      if (__DEV__)
        Utilities.Sendlog("Mkt Data update response: " + usermsgs[0] + ": " + Utilities.GetKeyValueString(keys, values));
      return;

    case TemplateId.MRKT_DATA_SNAPSHOT_RESPONSE:
      //Utilities.Sendlog("Mkt Data snapshot response: " + usermsgs[0] + ": " + Utilities.GetKeyValueString(keys, values));
      return;

    case TemplateId.LOGIN_RESPONSE:
      if (__DEV__)
        Utilities.Sendlog("unique login mkt: " + Utilities.GetKeyValueString(keys, values));
      // if (usermsgs[0] == StringTable.RECONNECT)
      //   LoginResponseMkt_Reconnect(keys, values)
      // else
      //   LoginResponseMkt(keys, values);

      ConnectionMkt.LoginResponseMkt(keys, values);

      return;

  case TemplateId.LOGIN_INFO_RESPONSE:
    //Utilities.Sendlog("login info MKT: " + Utilities.GetKeyValueString(keys, values));
    return;


    case TemplateId.BINARY_CONTRACT_REF_DATA_RESPONSE:
      if (__DEV__)
        Utilities.Sendlog("Event Contract Data response: " + usermsgs[0] + ": " + Utilities.GetKeyValueString(keys, values));
      ConnectionMkt.ProcessEventContract(keys, values, tokens, usermsgs);
      return;

    case TemplateId.REFERENCE_DATA_RESPONSE:
      if (__DEV__)
        Utilities.Sendlog("Ref Data response: " + usermsgs[0] + ": " + Utilities.GetKeyValueString(keys, values));

      if (ConnectionMkt.ProcessUlying(keys, values, usermsgs) == true)
          return;

      if (ConnectionMkt.ProcessRefData(keys, values, usermsgs) == false)
        return;

      //Utilities.Sendlog(usermsgs[0] +  " - ref data");
      break;

      // case TemplateId.END_OF_DAY_PRICES:
      //   //console.log("End of day prices: " + usermsgs[0] + ": " + Utilities.GetKeyValueString(keys, values));
      //   for (let i = 0; i < keys.length; i++)
      //   {
      //   switch(keys[i])
      //     {
      //     case MnmIds.MNM_NET_CHANGE:
      //       oData.nc    = values[i];
      //       break;
      //     }
      //   }

      //   return;

      case TemplateId.ORDER_BOOK:
        let token = tokens[0] + "." + tokens[1];
        //let token = usermsgs[0];
        let oData = ConnectionMkt.oOBStore.get(token); //Utilities.FindItem(oStore, token);

        if (oData != undefined)
          {
          //if (tokens[0] == "MYMM2")
          //Utilities.Sendlog("Book response: " + token + ": " + Utilities.GetKeyValueString(keys, values));

          if (oData.oFMData)
            oData.oFMData.msgs_curr++;

          if (oData.oData)
            oData.oData.msgs_curr++;

          ConnectionMkt.ProcessOrderBook(token, oData, keys, values);
          }
        else
          {
          if (__DEV__)            
            Utilities.Sendlog("OB response : invalid token for book: " + token);
          }
      return;
    }

  /*   -------------------------------------------------------------------   */

  //return;

  let token = tokens[0] + "." + tokens[1];
  let oData = ConnectionMkt.oStore.get(token); //Utilities.FindItem(oStore, token);

  /*   -------------------------------------------------------------------   */

  //
  // if (oData)
  //   {
  //   ConnectionMkt.oWs_Mkt_onmessage2(template, keys, values, usermsgs, oData);

  //   }


  //

  if (oData == undefined)
    {
    oData = ConnectionMkt.oStoreAddl.get(token); //Utilities.FindItem(oStore, token); 
    //Utilities.Sendlog("Event Contract Mkt Data: " + Utilities.GetKeyValueString(keys,values));     
    }

  if (oData == undefined)    
    {
    if (__DEV__)      
      Utilities.Sendlog("Market: Symbol not found in the store: " +
                        token + " template: " + template[0]);
    return;
    }

/*   -------------------------------------------------------------------   */

  //Utilities.Sendlog("template: " + template[0]);

  //if (template[0] == TemplateId.BEST_BID_OFFER)
    //Utilities.Sendlog("All data: " + usermsgs[0] + ": " + Utilities.GetKeyValueString(keys, values));

  oData.msgs_curr++;

  /*   -------------------------------------------------------------------   */

  for (let i = 0; i < keys.length; i++)
    {
    switch(keys[i])
      {
      case MnmIds.MNM_RESPONSE_CODE:
          if (values[i] != 0)
            {
            if (__DEV__)              
              Utilities.Sendlog(usermsgs[0] +  " - market data error: " + Utilities.GetKeyValueString(keys, values)); 

            return;
            }
  
        //if (template[0] == TemplateId.REFERENCE_DATA_RESPONSE)
          {
          //Utilities.Sendlog(oData.token + "=> " + oData.qpc);
          
          }

        break;

      case MnmIds.MNM_NET_CHANGE:
        oData.nc    = values[i];
        break;

      case MnmIds.MNM_PERCENT_CHANGE:
        oData.pc    = values[i];
        break;

      case MnmIds.MNM_SYMBOL_NAME:
        oData.symbol_name = values[i];
        break;

      case MnmIds.MNM_PRODUCT_CODE:
        oData.product_code = values[i];
        break;        

      case MnmIds.MNM_IS_UNDERLYING_FOR_BINARY_CONTRACTS:
        if (values[i].toLowerCase() == "yes")
          oData.is_evt_enabled = true;

        if (__DEV__)
          Utilities.Sendlog(template[0] + " event contract underlying: " + oData.token + " " + values[i]);
        break;        

      case MnmIds.MNM_SYMBOL_NAME:
        oData.symbol_name = values[i];
        break;        

      case MnmIds.MNM_INSTRUMENT_TYPE:
        oData.instr_type = values[i];
        break;        

      case MnmIds.MNM_SETTLEMENT_PRICE:
        oData.settlement = values[i];
        //alert(template[0])
        if (__DEV__)
          Utilities.Sendlog(template[0] + " settlement: " + oData.token + " " + oData.settlement);
        break;

      case MnmIds.MNM_PREVIOUS_DAYS_ADJUSTED_CLOSING_PRICE:
        oData.adj_close = values[i];
        //alert(template[0])
        if (__DEV__)
          Utilities.Sendlog(template[0] + " adj close: " + oData.token + " " + oData.adj_close);
        break;        

      case MnmIds.MNM_CLOSE_TRADE_PRICE:
        oData.close = values[i];

        if (__DEV__)
          Utilities.Sendlog(template[0] + " close: " + oData.token + " " + oData.close);

        //Utilities.Sendlog(template[0] + " settlement? -> " + Utilities.GetKeyValueString(keys, values));
        break;        

      case MnmIds.MNM_HIGH_PRICE:
        oData.high = Utilities.round(values[i], oData.f2qp);
        break;

      case MnmIds.MNM_LOW_PRICE:
        oData.low = Utilities.round(values[i], oData.f2qp);
        break;        

      case MnmIds.MNM_TRADE_PRICE:
        //oData.last = values[i];
        //oData.lastKey = oData.last.toFixed(oData.q)
        oData.last = Utilities.round(values[i], oData.f2qp);


        // if (oItem.closes[oItem.closes.length - 1] != values[i])
        //   oItem.closes = oItem.closes.concat(values[i]);
        break;

      case MnmIds.MNM_TRADE_VOLUME:
        oData.vol    = values[i];
        break;

      case MnmIds.MNM_TRADING_SYMBOL:
        oData.trading_symbol = values[i];
        break;

      case MnmIds.MNM_TRADING_EXCHANGE:
        oData.trading_exchange = values[i];

        //alert(oData.trading_exchange);
        break;        

      case MnmIds.MNM_SYMBOL:
        oData.symbol = values[i];
        break;

      case MnmIds.MNM_MARKET_MODE:
        oData.mode = values[i];

        if (__DEV__)
          Utilities.Sendlog(usermsgs[0] +  " **************** - got MARKET MODE: " + Utilities.GetKeyValueString(keys, values)); 
        break;

      case MnmIds.MNM_BID_PRICE:
        oData.bid    = values[i];
        break;

      case MnmIds.MNM_PRICE_DISPLAY_FORMAT:
        oData.display_fmt = values[i];
        //Utilities.Sendlog(usermsgs[0] + " ***fmt: " + values[i]);
        break;

      case MnmIds.MNM_MIN_QPRICE_CHANGE:
        //Utilities.Sendlog(usermsgs[0] + " ***qpc: " + values[i].toLocaleString("en-US", { maximumFractionDigits: 15 }));

        //Utilities.Sendlog(oData.token + "=> " + values[i]);
        oData.qpc = values[i];

        let split = (values[i] + 1).toString().split('.');

        if (split.length > 1)
          oData.f2qp = split[1].length;
        else if (split.length == 1)
          oData.f2qp = 0;
        break;

      case MnmIds.MNM_ASK_PRICE:
        oData.ask    = values[i];
        break;

      case MnmIds.MNM_BID_SIZE:
        oData.bid_size    = values[i];
        break;

      case MnmIds.MNM_ASK_SIZE:
        oData.ask_size    = values[i];
        break;

      case MnmIds.MNM_CLEAR_BITS:
        // enum PresenceBits {
        //   BID          =  1;
        //   ASK          =  2;
        //   LEAN_PRICE   =  4;
        //    }

        if (template[0] == TemplateId.BEST_BID_OFFER) //1, 2, 4
          {
          if (Utilities.IsPresent(values[i], Rq.ClearBits.BID))
            {
            oData.bid_size = undefined;
            oData.bid      = undefined;
            }

          if (Utilities.IsPresent(values[i], Rq.ClearBits.ASK))
            {
            oData.ask_size = undefined;
            oData.ask      = undefined;
            }            

          // let iBit = values[i] - 4;

          // switch(iBit)
          //   {
          //   case 1:
          //     oData.bid_size = undefined;
          //     oData.bid      = undefined;
          //     break;  
          //   case 2:
          //     oData.ask_size = undefined;
          //     oData.ask      = undefined;
          //     break;  
          //   case 3:
          //     oData.bid_size = undefined;
          //     oData.bid      = undefined;

          //     oData.ask_size = undefined;
          //     oData.ask      = undefined;
          //     break;                
          //   }
          }
        break;        

      case MnmIds.MNM_TRADE_SIZE:
        oData.last_size    = values[i];
        break;

      case MnmIds.MNM_SECONDS_SINCE_BOE:
        // if (values[i] < oData.time)
        //   Utilities.Sendlog(usermsgs[0] +  " **************** - time is LESS: " + Utilities.GetKeyValueString(keys, values)); 

        oData.time                   = values[i];
        ConnectionMkt.iLastSsboe_Msg = values[i];
        break;
      }
    }

    /*   -----------------------------------------------------------------   */

    // if (oData.time%10 == 0)
    //   oData.mode = "End of Day";
    // else
    //   oData.mode = "Open";

    switch(template[0])
    {
      //to remove
      case TemplateId.END_OF_DAY_PRICES:
        // if (oData.token == "ESU2.CME")
        //   Utilities.Sendlog("SD:155:=> " + Utilities.GetKeyValueString(keys, values));
        break;

      case TemplateId.REFERENCE_DATA_RESPONSE:
        if (oData.trading_symbol && oData.trading_symbol != oData.symbol)
          {
          oData.bContSymbol   = true;
          // oData.trading_token = oData.trading_symbol + "." + oData.exchange;

          //New_EVT
          ConnectionMkt.oConn?.Rq_RefData_Final(oData.trading_symbol,
                                                oData.trading_exchange,
                                                oData.token,
                                                "update_underlying",
                                                oData.token);
          }

        //New_EVT  
        // if (oData.instr_type == "Future" && oData.evt_got == false)
        //   {
        //   oData.evt_got = true;
        //   ConnectionMkt.oConn?.
        //   Rq_Binary_RefData(oData.trading_symbol? 
        //                     oData.trading_symbol:oData.symbol, 
        //                     oData.trading_exchange? 
        //                     oData.trading_exchange:oData.exchange, 
        //                     oData.token);
        //   }

        ConnectionMkt.oConn?.oOnAlert(ConnectionMkt.oConn,
                                      Connection.MSG_REF_DATA_SUCCESS,
                                      usermsgs[2] != "auto",
                                      oData);
        break;

      case TemplateId.MARKET_MODE:
        if (oData.mode_got == false)
          {
          oData.mode_got = true;
          //iUpdate++;
          //bUpdate = true;
          if (__DEV__)
            Utilities.Sendlog(token +  " - market mode");
          }
        break;

      case TemplateId.BEST_BID_OFFER:
        if (oData.bbo_got == false)
          {
          oData.bbo_got = true;
          //iUpdate++;
          //bUpdate = true;
          if (__DEV__)
            Utilities.Sendlog(token +  " - bbo");

          //ConnectionMkt.GetBook(oData);
          }
        break;

      case TemplateId.LAST_TRADE:
        if (oData.trade_got == false)
          {
          oData.trade_got = true;
          //iUpdate++;
          //bUpdate = true;
          if (__DEV__)
            Utilities.Sendlog(token +  " - trade");

          //ConnectionMkt.GetBook(oData);
          }
        break;
    }

  /*   -------------------------------------------------------------------   */
}

// private static oWs_Mkt_onmessage2(template, keys, values, usermsgs, oData : Data)
//   {
//   oData.msgs_curr++;

//   /*   -------------------------------------------------------------------   */

//   for (let i = 0; i < keys.length; i++)
//     {
//     switch(keys[i])
//       {
//       case MnmIds.MNM_RESPONSE_CODE:
//           if (values[i] != 0)
//             {
//             Utilities.Sendlog(usermsgs[0] +  " - market data error: " + Utilities.GetKeyValueString(keys, values)); 
//             return;
//             }
  
//         //if (template[0] == TemplateId.REFERENCE_DATA_RESPONSE)
//           {
//           //Utilities.Sendlog(oData.token + "=> " + oData.qpc);
          
//           }

//         break;

//       case MnmIds.MNM_NET_CHANGE:
//         oData.nc    = values[i];
//         break;

//       case MnmIds.MNM_PERCENT_CHANGE:
//         oData.pc    = values[i];
//         break;

//       case MnmIds.MNM_SYMBOL_NAME:
//         oData.symbol_name = values[i];
//         break;

//       case MnmIds.MNM_PRODUCT_CODE:
//         oData.product_code = values[i];
//         break;        

//       case MnmIds.MNM_SYMBOL_NAME:
//         oData.symbol_name = values[i];
//         break;        

//       case MnmIds.MNM_INSTRUMENT_TYPE:
//         oData.instr_type = values[i];
//         break;        

//       case MnmIds.MNM_SETTLEMENT_PRICE:
//         oData.settlement = values[i];
//         //alert(template[0])
//         Utilities.Sendlog(template[0] + " settlement: " + oData.token + " " + oData.settlement);
//         break;

//       case MnmIds.MNM_PREVIOUS_DAYS_ADJUSTED_CLOSING_PRICE:
//         oData.adj_close = values[i];
//         //alert(template[0])
//         Utilities.Sendlog(template[0] + " adj close: " + oData.token + " " + oData.adj_close);
//         break;        

//       case MnmIds.MNM_CLOSE_TRADE_PRICE:
//         oData.close = values[i];
//         Utilities.Sendlog(template[0] + " close: " + oData.token + " " + oData.close);

//         Utilities.Sendlog(template[0] + " settlement? -> " + Utilities.GetKeyValueString(keys, values));
//         break;        

//       case MnmIds.MNM_HIGH_PRICE:
//         oData.high = Utilities.round(values[i], oData.f2qp);
//         break;

//       case MnmIds.MNM_LOW_PRICE:
//         oData.low = Utilities.round(values[i], oData.f2qp);
//         break;        

//       case MnmIds.MNM_TRADE_PRICE:
//         //oData.last = values[i];
//         //oData.lastKey = oData.last.toFixed(oData.q)
//         oData.last = Utilities.round(values[i], oData.f2qp);


//         // if (oItem.closes[oItem.closes.length - 1] != values[i])
//         //   oItem.closes = oItem.closes.concat(values[i]);
//         break;

//       case MnmIds.MNM_TRADE_VOLUME:
//         oData.vol    = values[i];
//         break;

//       case MnmIds.MNM_TRADING_SYMBOL:
//         oData.trading_symbol = values[i];
//         break;

//       case MnmIds.MNM_TRADING_EXCHANGE:
//         oData.trading_exchange = values[i];

//         //alert(oData.trading_exchange);
//         break;        

//       case MnmIds.MNM_SYMBOL:
//         oData.symbol = values[i];
//         break;

//       case MnmIds.MNM_MARKET_MODE:
//         oData.mode = values[i];

//         Utilities.Sendlog(usermsgs[0] +  " **************** - got MARKET MODE: " + Utilities.GetKeyValueString(keys, values)); 
//         break;

//       case MnmIds.MNM_BID_PRICE:
//         oData.bid    = values[i];
//         break;

//       case MnmIds.MNM_PRICE_DISPLAY_FORMAT:
//         oData.display_fmt = values[i];
//         //Utilities.Sendlog(usermsgs[0] + " ***fmt: " + values[i]);
//         break;

//       case MnmIds.MNM_MIN_QPRICE_CHANGE:
//         //Utilities.Sendlog(usermsgs[0] + " ***qpc: " + values[i].toLocaleString("en-US", { maximumFractionDigits: 15 }));

//         //Utilities.Sendlog(oData.token + "=> " + values[i]);
//         oData.qpc = values[i];

//         let split = (values[i] + 1).toString().split('.');

//         if (split.length > 1)
//           oData.f2qp = split[1].length;
//         else if (split.length == 1)
//           oData.f2qp = 0;
//         break;

//       case MnmIds.MNM_ASK_PRICE:
//         oData.ask    = values[i];
//         break;

//       case MnmIds.MNM_BID_SIZE:
//         oData.bid_size    = values[i];
//         break;

//       case MnmIds.MNM_ASK_SIZE:
//         oData.ask_size    = values[i];
//         break;

//       case MnmIds.MNM_TRADE_SIZE:
//         oData.last_size    = values[i];
//         break;

//       case MnmIds.MNM_SECONDS_SINCE_BOE:
//         // if (values[i] < oData.time)
//         //   Utilities.Sendlog(usermsgs[0] +  " **************** - time is LESS: " + Utilities.GetKeyValueString(keys, values)); 

//         oData.time                   = values[i];
//         ConnectionMkt.iLastSsboe_Msg = values[i];
//         break;
//       }
//     }

//     /*   -----------------------------------------------------------------   */

//     // if (oData.time%10 == 0)
//     //   oData.mode = "End of Day";
//     // else
//     //   oData.mode = "Open";

//     switch(template[0])
//     {
//       //to remove
//       case TemplateId.END_OF_DAY_PRICES:
//         // if (oData.token == "ESU2.CME")
//         //   Utilities.Sendlog("SD:155:=> " + Utilities.GetKeyValueString(keys, values));
//         break;

//       case TemplateId.REFERENCE_DATA_RESPONSE:
//         if (oData.trading_symbol && oData.trading_symbol != oData.symbol)
//           oData.bContSymbol = true;

//         if (oData.instr_type == "Future" && oData.evt_got == false)
//           {
//           oData.evt_got = true;
//           ConnectionMkt.oConn?.
//           Rq_Binary_RefData(oData.trading_symbol? 
//                             oData.trading_symbol:oData.symbol, 
//                             oData.trading_exchange? 
//                             oData.trading_exchange:oData.exchange, 
//                             oData.token);
//           }

//         ConnectionMkt.oConn?.oOnAlert(ConnectionMkt.oConn,
//                                       Connection.MSG_REF_DATA_SUCCESS,
//                                       usermsgs[2] != "auto",
//                                       oData);
//         break;

//       case TemplateId.MARKET_MODE:
//         if (oData.mode_got == false)
//           {
//           oData.mode_got = true;
//           //iUpdate++;
//           //bUpdate = true;
//           Utilities.Sendlog(oData.token +  " - market mode");
//           }
//         break;

//       case TemplateId.BEST_BID_OFFER:
//         if (oData.bbo_got == false)
//           {
//           oData.bbo_got = true;
//           //iUpdate++;
//           //bUpdate = true;
//           Utilities.Sendlog(oData.token +  " - bbo");

//           //ConnectionMkt.GetBook(oData);
//           }
//         break;

//       case TemplateId.LAST_TRADE:
//         if (oData.trade_got == false)
//           {
//           oData.trade_got = true;
//           //iUpdate++;
//           //bUpdate = true;
//           Utilities.Sendlog(oData.token +  " - trade");

//           //ConnectionMkt.GetBook(oData);
//           }
//         break;
//     }

//   /*   -------------------------------------------------------------------   */
// }

}

/*   =======================================================================  */

class ConnectionHis extends Connection
{
public static oConn : ConnectionHis | null = null;

/*   -------------------------------------------------------------------   */

public static GetDefLookBack() : Lookback
{
  var oLB = ConnectionHis.oLookBacks.
            find(oLB=> oLB.LookbackType == LookbackType.Day1);

  if (oLB == undefined)
    return(ConnectionHis.oLookBacks[4]);
  else
    return(oLB);
}

/*   -------------------------------------------------------------------   */

public static FindIndicator(iIndicator? : number)
{
if (iIndicator == undefined)
  return(undefined);

for (let i = 0; i < ConnectionHis.oIndicators.length; i++)
  {
  if (ConnectionHis.oIndicators[i].iId == iIndicator)
    return(ConnectionHis.oIndicators[i]);
  }

return(undefined);
}

/*   -------------------------------------------------------------------   */

public static FindIndicatorIndex(iIndicator? : number)
{
if (iIndicator == undefined)
  return(undefined);

for (let i = 0; i < ConnectionHis.oIndicators.length; i++)
  {
  if (ConnectionHis.oIndicators[i].iId == iIndicator)
    return(i);
  }

return(undefined);
}

/*   -------------------------------------------------------------------   */

public static oColors : string[][] = 
[
  ['#0096FF', 'red'],
  ['#0096FF', 'magenta'],
  [FontInfo.sDimGrayTpTp, FontInfo.sDimGrayTpTp],
  [FontInfo.sYellow, 'red'],
  [FontInfo.sYellow, 'magenta'],
]

/*   -------------------------------------------------------------------   */

public static oIndicators = 
[
 new IndicatorInfo(  
  { 
    sId: "AB", 
    iId: IndicatorType.AB,
    sDesc: "Acceleration Bands",

    // sCol1: '#0096FF',
    // sCol2: 'red',
    // sCol3: 'red',

    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 0,
    iPeriod3: 0,

    bOverlay: true,
  }),  


  new IndicatorInfo(  
  { 
    sId: "AD", 
    iId: IndicatorType.AD,
    sDesc: "Accumulation/Distribution",

    // sCol1: '#0096FF',

    iCol1   : 0,
    iCol2   : 0,
    iCol3   : 0,

    iPeriod1: 0,
    iPeriod2: 0,
    iPeriod3: 0,
  }),  


 new IndicatorInfo(  
  { 
    sId: "AO", 
    iId: IndicatorType.AO,
    sDesc: "Awesome Oscillator",

    // sCol1: '#0096FF',
    // sCol2: '#0096FF',
    iCol1   : 0,
    iCol2   : 0,
    iCol3   : 0,

    iPeriod1: 14,
    iPeriod2: 7,
    iPeriod3: 0,
  }),


new IndicatorInfo(  
  { 
    sId: "ATR", 
    iId: IndicatorType.ATR,
    sDesc: "Avg True Range",

    // sCol1: '#0096FF',
    // sCol2: 'red',
    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 0,
    iPeriod3: 0,
  }),

new IndicatorInfo(  
  { 
    sId: "BB", 
    iId: IndicatorType.BB,
    sDesc: "Bollinger Bands",

    // sCol1: '#0096FF',
    // sCol2: 'red',
    // sCol3: 'red',
    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 0,
    iPeriod3: 0,

    bOverlay: true,
  }),


 new IndicatorInfo(  
  { 
    sId: "CMF", 
    iId: IndicatorType.CMF,
    sDesc: "Chaikin Money Flow",

    // sCol1: '#0096FF',
    iCol1   : 0,
    iCol2   : 0,
    iCol3   : 0,

    iPeriod1: 14,
    iPeriod2: 0,
    iPeriod3: 0,
  }),


 new IndicatorInfo(  
  { 
    sId: "CMI", 
    iId: IndicatorType.CMI,
    sDesc: "Community Channel Index",

    // sCol1: '#0096FF',
    iCol1   : 0,
    iCol2   : 0,
    iCol3   : 0,

    iPeriod1: 14,
    iPeriod2: 0,
    iPeriod3: 0,
  }),


 new IndicatorInfo(  
  { 
    sId: "CO", 
    iId: IndicatorType.CO,
    sDesc: "Chaikin Oscillator", //needs volume

    // sCol1: '#0096FF',
    // sCol2: 'red',
    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 7,
    iPeriod3: 0,
  }),


new IndicatorInfo(  
  { 
    sId: "DC", 
    iId: IndicatorType.DC,
    sDesc: "Donchian Channel",

    // sCol1: '#0096FF',
    // sCol2: 'red',
    // sCol3: 'red',
    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 0,
    iPeriod3: 0,

    bOverlay: true,
  }),


new IndicatorInfo(  
  { 
    sId: "DEMA", 
    iId: IndicatorType.DEMA,
    sDesc: "Double Exponential Moving Avg",

    // sCol1: '#0096FF',
    // sCol2: 'magenta',
    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 7,
    iPeriod3: 0,

    bOverlay: true,
  }),


new IndicatorInfo(  
  { 
    sId: "EMA", 
    iId: IndicatorType.EMA,
    sDesc: "Exponential Moving Avg",

    // sCol1: '#0096FF',
    // sCol2: 'red',
    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 7,
    iPeriod3: 0,

    bOverlay: true,
  }),    


 new IndicatorInfo(  
  { 
    sId: "EMV", 
    iId: IndicatorType.EMV,
    sDesc: "Ease of Movement",

    // sCol1: '#0096FF',
    iCol1   : 0,
    iCol2   : 0,
    iCol3   : 0,

    iPeriod1: 14,
    iPeriod2: 0,
    iPeriod3: 0,
  }),


 new IndicatorInfo(  
  { 
    sId: "FI", 
    iId: IndicatorType.FI,
    sDesc: "Force Index",

    // sCol1: '#0096FF',
    iCol1   : 0,
    iCol2   : 0,
    iCol3   : 0,

    iPeriod1: 14,
    iPeriod2: 0,
    iPeriod3: 0,
  }),


new IndicatorInfo(  
  { 
    sId: "KC", 
    iId: IndicatorType.KC,
    sDesc: "Keltner Channel",

    // sCol1: '#0096FF',
    // sCol2: 'red',
    // sCol3: 'red',
    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 0,
    iPeriod3: 0,

    bOverlay: true,
  }),


 new IndicatorInfo(  
  { 
    sId: "MACD", 
    iId: IndicatorType.MACD,
    sDesc: "Moving Avg Convergence/Divergence",

    // sCol1: '#0096FF',
    // sCol2: 'red',
    // sCol3: 'red',
    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 7,
    iPeriod3: 3,
  }),


  new IndicatorInfo(  
  { 
    sId: "MFI", 
    iId: IndicatorType.MFI,
    sDesc: "Money Flow Index",

    // sCol1: '#0096FF',
    iCol1   : 0,
    iCol2   : 0,
    iCol3   : 0,

    iPeriod1: 14,
    iPeriod2: 0,
    iPeriod3: 0,
  }),


  new IndicatorInfo(  
  { 
    sId: "OBV", 
    iId: IndicatorType.OBV,
    sDesc: "On-Balance Volume",

    // sCol1: '#0096FF',
    iCol1   : 0,
    iCol2   : 0,
    iCol3   : 0,

    iPeriod1: 0,
    iPeriod2: 0,
    iPeriod3: 0,
  }),  


  new IndicatorInfo(  
  { 
    sId: "PO", 
    iId: IndicatorType.PO,
    sDesc: "Projection Oscillator",

    // sCol1: '#0096FF',
    // sCol2: 'red',
    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 7,
    iPeriod3: 0,
  }),  


  new IndicatorInfo(  
  { 
    sId: "PPO", 
    iId: IndicatorType.PPO,
    sDesc: "Percentage Price Oscillator",

    // sCol1: '#0096FF',
    // sCol2: 'red',
    // sCol3: 'red',
    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 7,
    iPeriod3: 3,
  }),
 

 new IndicatorInfo(  
  { 
    sId: "RMA", 
    iId: IndicatorType.RMA,
    sDesc: "Rolling Moving Avg",

    // sCol1: '#0096FF',
    // sCol2: 'red',
    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 7,
    iPeriod3: 0,

    bOverlay: true,
  }),


new IndicatorInfo(  
  { 
    sId: "RSI", 
    iId: IndicatorType.RSI,
    sDesc: "Relative Strength Index",

    // sCol1: '#0096FF',
    iCol1   : 0,
    iCol2   : 0,
    iCol3   : 0,

    iPeriod1: 14,
    iPeriod2: 0,
    iPeriod3: 0,
  }),    


new IndicatorInfo(  
  { 
    sId: "SMA", 
    iId: IndicatorType.SMA,
    sDesc: "Simple Moving Avg",

    // sCol1: '#0096FF',
    // sCol2: 'magenta',
    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 7,
    iPeriod3: 0,

    bOverlay: true,
  }),  


new IndicatorInfo(  
  { 
    sId: "SO", 
    iId: IndicatorType.SO,
    sDesc: "Stochastic Oscillator",

    // sCol1: '#0096FF',
    // sCol2: 'magenta',
    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 7,
    iPeriod3: 3,
  }),  


new IndicatorInfo(  
  { 
    sId: "TEMA", 
    iId: IndicatorType.TEMA,
    sDesc: "Triple Exponential Moving Avg",

    // sCol1: '#0096FF',
    // sCol2: 'magenta',
    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 7,
    iPeriod3: 0,

    bOverlay: true,
  }),

 
 new IndicatorInfo(  
  { 
    sId: "TP", 
    iId: IndicatorType.TP,
    sDesc: "Typical Price",

    // sCol1: '#0096FF',
    iCol1   : 0,
    iCol2   : 0,
    iCol3   : 0,

    iPeriod1: 0,
    iPeriod2: 0,
    iPeriod3: 0,

    bOverlay: true,
  }),
  

new IndicatorInfo(  
  { 
    sId: "TRIMA", 
    iId: IndicatorType.TRIMA,
    sDesc: "Triangular Moving Avg",

    // sCol1: '#0096FF',
    // sCol2: 'magenta',
    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 7,
    iPeriod3: 0,

    bOverlay: true,
  }),


 new IndicatorInfo(  
  { 
    sId: "TRIX", 
    iId: IndicatorType.TRIX,
    sDesc: "Triple Exponential Avg",

    // sCol1: '#0096FF',
    // sCol2: 'magenta',
    iCol1   : 0,
    iCol2   : 1,
    iCol3   : 1,

    iPeriod1: 14,
    iPeriod2: 0,
    iPeriod3: 0,
    
    bOverlay: false,
  }),


new IndicatorInfo(  
  { 
    sId: "VOL", 
    iId: IndicatorType.VOL,
    sDesc: "Volume",

    // sCol1: '#0096FF',
    iCol1   : 0,
    iCol2   : 0,
    iCol3   : 0,

    iPeriod1: 0,
    iPeriod2: 0,
    iPeriod3: 0,
  }),  


new IndicatorInfo(  
  { 
    sId: "VPT", 
    iId: IndicatorType.VPT,
    sDesc: "Volume Price Trend",

    // sCol1: '#0096FF',
    iCol1   : 0,
    iCol2   : 0,
    iCol3   : 0,

    iPeriod1: 0,
    iPeriod2: 0,
    iPeriod3: 0,
  }),  

 
new IndicatorInfo(  
  { 
    sId: "WR", 
    iId: IndicatorType.WR,
    sDesc: "Williams R",

    // sCol1: '#0096FF',
    iCol1   : 0,
    iCol2   : 0,
    iCol3   : 0,

    iPeriod1: 14,
    iPeriod2: 0,
    iPeriod3: 0,
  }),  
  
]  

/*   -------------------------------------------------------------------   */

public static oLookBacks = 
[
new Lookback(  
  { 
    LookbackType: LookbackType.Min1, 
    Text: "1Min",
    LookbackMin:1, 
    Period:1, PeriodSub: 1, Max:61, 
    BarType: Rq.BarType.SECOND_BAR, 
    DateOnly: false,
    Fmt:"h:mm:ssa",
  }),

new Lookback(  
  { 
    LookbackType: LookbackType.Min5, 
    Text: "5Min",
    LookbackMin:5, 
    Period:3, PeriodSub: 3, Max:101, 
    BarType: Rq.BarType.SECOND_BAR, 
    DateOnly: false,
    Fmt:"h:mm:ssa",
  }),  

new Lookback(  
  { 
    LookbackType: LookbackType.Hour1, 
    Text: "1Hr",
    LookbackMin:60, 
    Period:1, PeriodSub: 1, Max:61, //PeriodSub: 60
    BarType: Rq.BarType.MINUTE_BAR, 
    DateOnly: false,
    Fmt:"h:mma",
  }),

new Lookback(
  {
    LookbackType: LookbackType.Day1, 
    Text: "1D",
    LookbackMin:1440, 
    Period:30, PeriodSub: 30, Max:49, //PeriodSub: 60 * 30
    BarType: Rq.BarType.MINUTE_BAR, 
    DateOnly: false,
    Fmt:"D MMM h:mma",
  }),

// new Lookback(
//     {
//       LookbackType: LookbackType.Week1, 
//       Text: "2W",    
//       LookbackMin:1440 * 7, 
//       Period:30, PeriodSub: 60 * 30, Max:673, 
//       BarType: Rq.BarType.MINUTE_BAR, 
//       DateOnly: false,
//       Fmt:"D MMM h:mma",
//     }),

// new Lookback(
//     {
//       LookbackType: LookbackType.Week2, 
//       Text: "2W",    
//       LookbackMin:1440 * 14, 
//       Period:120, PeriodSub: 60 * 120, Max:169, 
//       BarType: Rq.BarType.MINUTE_BAR, 
//       DateOnly: false,
//       Fmt:"D MMM h:mma",
//     }),
  
new Lookback(
  {
    LookbackType: LookbackType.Week2, 
    Text: "2W",    
    LookbackMin:1440 * 14, 
    Period:1, PeriodSub: 0, Max:14, 
    BarType: Rq.BarType.DAILY_BAR, 
    DateOnly: true,
    Fmt:"D MMM YYYY",  
  }),

new Lookback(
  {
    LookbackType: LookbackType.Month1, 
    Text: "1M",
    LookbackMin:1440 * 30, 
    Period:1, PeriodSub: 0, Max:1, 
    BarType: Rq.BarType.DAILY_BAR, 
    DateOnly: true,
    Fmt:"D MMM YYYY",
  }),

new Lookback(
  {
    LookbackType: LookbackType.Month3, 
    Text: "3M",
    LookbackMin:1440 * 90, 
    Period:1, PeriodSub: 0, Max:1, 
    BarType: Rq.BarType.DAILY_BAR, 
    DateOnly: true,
    Fmt:"D MMM YYYY",
  }),  

new Lookback(
  {
    LookbackType: LookbackType.Year1, 
    Text: "1Y",
    LookbackMin:1440 * 365, 
    Period:1, PeriodSub: 0, Max:1, 
    BarType: Rq.BarType.WEEKLY_BAR, 
    DateOnly: true,
    Fmt:"D MMM YYYY",
  }),

// new Lookback(
//   {
//     LookbackType: LookbackType.Week2, 
//     Text: "5D",    
//     LookbackMin:1440 * 5, 
//     Period:60, PeriodSub: 60 * 60, Max:121, 
//     BarType: BarType.MINUTE_BAR, 
//     DateOnly: false,
//     Fmt:"Do MMM h:mma",  
//   }),

];

// public static oLookBacks2 = 
// [

//   {
//     Type: LookbackType.Year1, 
//     Text: "1Y",
//     LookbackMin:1440 * 365, 
//     Period:1, PeriodSub: 0, Max:1, 
//     BarType: Rq.BarType.WEEKLY_BAR, 
//     DateOnly: true,
//     Fmt:"Do MMM YYYY",
//   },

//   {
//     Type: LookbackType.Month3, 
//     Text: "3M",
//     LookbackMin:1440 * 90, 
//     Period:1, PeriodSub: 0, Max:1, 
//     BarType: Rq.BarType.DAILY_BAR, 
//     DateOnly: true,
//     Fmt:"Do MMM YYYY",
//   }, 

//   {
//     Type: LookbackType.Month1, 
//     Text: "1M",
//     LookbackMin:1440 * 30, 
//     Period:1, PeriodSub: 0, Max:1, 
//     BarType: Rq.BarType.DAILY_BAR, 
//     DateOnly: true,
//     Fmt:"Do MMM YYYY",
//   },

//   {
//     Type: LookbackType.Day5, 
//     Text: "5D",    
//     LookbackMin:1440 * 5, 
//     Period:60, PeriodSub: 60 * 60, Max:121, 
//     BarType: Rq.BarType.MINUTE_BAR, 
//     DateOnly: false,
//     Fmt:"Do MMM h:mma",
//   }, 

//   {
//     Type: LookbackType.Day1, 
//     Text: "1D",
//     LookbackMin:1440, 
//     Period:30, PeriodSub: 60 * 30, Max:49, 
//     BarType: Rq.BarType.MINUTE_BAR, 
//     DateOnly: false,
//     Fmt:"Do MMM h:mma",
//   },

//   { 
//     Type: LookbackType.Hour1, 
//     Text: "1H",
//     LookbackMin:60, 
//     Period:1, PeriodSub: 60, Max:61, 
//     BarType: Rq.BarType.MINUTE_BAR, 
//     DateOnly: false,
//     Fmt:"Do MMM h:mma",
//   },

//   { 
//     Type: LookbackType.Min1, 
//     Text: "1M",
//     LookbackMin:1, 
//     Period:1, PeriodSub: 1, Max:61, 
//     BarType: Rq.BarType.SECOND_BAR, 
//     DateOnly: false,
//     Fmt:"h:mm:ssa",
//   },

// ];

/*   -------------------------------------------------------------------   */

public static FindLookBack(iLBType : number)
{
for (let i = 0, j = ConnectionHis.oLookBacks.length; i < j; i++)  
  {
  if (ConnectionHis.oLookBacks[i].LookbackType == iLBType)
    return(ConnectionHis.oLookBacks[i]);
  }

return(ConnectionHis.oDefaultLookBack);
}

/*   -------------------------------------------------------------------   */


// public static oDefaultLookBack = ConnectionHis.oLookBacks.
//                                  find(lb=> lb.Type == LookbackType.Day1);


public static oDefaultLookBack = ConnectionHis.GetDefLookBack();
                                //oLookBacks.
                                 //find(oLB=> oLB.LookbackType == LookbackType.Day1);

/*   -------------------------------------------------------------------   */

public static Init(oLoginParams : LoginParams,
                   oOnAlert : (conn        : Connection, 
                               msg         : number,
                               data        : any,
                               store_data? : any) => void,
                   iRetryCount = 0)
{
try
  {
  if (__DEV__)
    Utilities.Sendlog("**Staring History...");

  ConnectionHis.oConn = new ConnectionHis("History",
                                          oLoginParams.sSys,
                                          oLoginParams.sUrl,
                                          oLoginParams.sUsr,
                                          oLoginParams.sPwd,
                                          Connection.TYPE_HISTORY_PLANT,
                                          ConnectionHis.oWs_His_onmessage,
                                          oOnAlert,
                                          Connection.CXT_TYPE_OTH);

  ConnectionHis.oConn.iRetry = iRetryCount;
  ConnectionHis.oConn.Start();
  }
catch(error)
  {
  //setLoginState('💥');
  //alert("Order connection failed - " + error);  
  }    
}

/*   -------------------------------------------------------------------   */

public static Dispose()
{
// if (ConnectionHis.oConn?.GetLoginStatus())
//   {
//   for (let [key, value] of Connection.oStore.entries()) 
//     {
//     if (value.sub_bars == true)
//       {
//       ConnectionHis.oConn.Rq_Unsubscribe(value.symbol, 
//                                         value.exchange, 
//                                         value.token, 
//                                         value.lookback);
//       value.sub_bars = false;
//       }
//     }
//   }

ConnectionHis.oConn?.SetLoginStatus(false);
ConnectionHis.oConn?.SetReconnect();
ConnectionHis.oConn?.Close();
ConnectionHis.oConn    = null;
}

/*   -------------------------------------------------------------------   */

public static Rq_GetBarsAndSubscribe(props : Data,
                                     oLB   : Lookback)
{
// props.lookback      = lookback;  
// alert(lookback.Text + " bar type: " + lookback.BarType + " period " + lookback.Period + " lb: " + lookback.LookbackMin);  
// return;

if (ConnectionHis.oConn?.GetLoginStatus() == true)
    {
    // if (lookback.Type == LookbackType.Month)
    //   {
    //     if (props.month_closes.length != 0)
    //       {
    //       props.closes        = [...props.month_closes];
    //       props.times         = [...props.month_times];

    //       if (props.sub_bars == true)
    //         {
    //         ConnectionHis.oConn?.Rq_Unsubscribe(props.symbol, props.exchange, props.token, props.lookback);
    //         props.sub_bars = false;
    //         }

    //       props.lookback      = lookback;
    //       props.update_chart  = true;
    //       return;
    //       }
    //   }
    // else if (lookback.Type == LookbackType.Year)
    //   {
    //     if (props.year_closes.length != 0)
    //       {
    //       props.closes        = [...props.year_closes];
    //       props.times         = [...props.year_times];
    
    //       if (props.sub_bars == true)
    //         {
    //         ConnectionHis.oConn?.Rq_Unsubscribe(props.symbol, props.exchange, props.token, props.lookback);
    //         props.sub_bars = false;
    //         }

    //       props.lookback      = lookback;
    //       props.update_chart  = true;            
    //       return;
    //       }
    //   }

    /*   -----------------------------------------------------------------   */

    if (props.times.length > 0)
      props.times.splice(0, props.times.length);

    if (props.close_times.length > 0)
      props.close_times.splice(0, props.close_times.length);

    if (props.closes.length > 0)
      props.closes.splice(0, props.closes.length);

    if (props.ohlc.length > 0)
      props.ohlc.splice(0, props.ohlc.length);      

    if (props.highs.length > 0)
      props.highs.splice(0, props.highs.length);      

    if (props.lows.length > 0)
      props.lows.splice(0, props.lows.length);

    if (props.vols.length > 0)
      props.vols.splice(0, props.vols.length);

    /*   -----------------------------------------------------------------   */

    //new 
    //props.closes[0]       = 0;

    props.max             = undefined;
    props.min             = undefined;
    props.update_chart    = false;
    props.update_chart_rr = false;
    props.update_orders   = false;
    props.closes_got      = false;

    /*   -----------------------------------------------------------------   */    

    if (props.sub_bars == true)
      {
      ConnectionHis.oConn?.Rq_Unsubscribe(props.symbol, 
                                          props.exchange, 
                                          props.token, 
                                          props.lookback);
      props.sub_bars = false;
      }

    /*   -----------------------------------------------------------------   */      

    props.lookback = oLB;

    let z = Utilities.FindItem(Connection.oSettings, props.token);

    if (z != AppMain.IMAGINARY)
      Connection.oSettings[z].iLookBack = oLB.LookbackType;

    /*   -----------------------------------------------------------------   */

    if (__DEV__)
      Utilities.Sendlog("Requesting bars: " + props.symbol + "<>" + props.exchange + " bartype: " + props.lookback.BarType + " period: " + props.lookback.Period + " from: " + new Date( Utilities.GetStartTime(props.lookback.LookbackMin) * 1000 ).toString());

    ConnectionHis.oConn?.Rq_GetBars(props.symbol, 
                                    props.exchange, 
                                    props.token, 
                                    props.lookback);

    if (props.lookback.PeriodSub != 0)
      {                                    
      ConnectionHis.oConn?.Rq_Subscribe(props.symbol, 
                                        props.exchange, 
                                        props.token, 
                                        props.lookback);
      props.sub_bars = true;
      }

    /*   ---------------------------------------------------------------   */

    ConnectionOrd.SaveSettings();
    }
}

/*   -------------------------------------------------------------------   */

public Rq_GetBars(sSymbol   : string, 
                  sExchange : string, 
                  sToken    : string, 
                  oLookBack : Lookback)
{
  //Utilities.Sendlog("Requesting bars: " + sSymbol + "<>" + sExchange);
  this.Send(Utilities.GetMergedMsg(
    MnmIds.MNM_TEMPLATE_ID, TemplateId.TIME_BAR_REPLAY_REQUEST,

    MnmIds.MNM_SYMBOL, sSymbol,
    MnmIds.MNM_EXCHANGE, sExchange,
    
    MnmIds.MNM_USER_MSG, sToken,

    MnmIds.MNM_DATA_BAR_TYPE,  oLookBack.BarType,
    MnmIds.MNM_TIME_BAR_PERIOD, oLookBack.Period,

    MnmIds.MNM_START_INDEX, 
    Utilities.GetStartTime(oLookBack.LookbackMin,
                           oLookBack.DateOnly),
    MnmIds.MNM_FINISH_INDEX, 
    Utilities.GetEndTime(oLookBack.DateOnly),
  
    //MnmIds.MNM_USER_MAX_COUNT, oLookBack.Max,
    MnmIds.MNM_DIRECTION, oLookBack.DateOnly? 
                          Rq.Direction.FIRST : Rq.Direction.LAST,

    MnmIds.MNM_TIME_ORDER, Rq.TimeOrder.FORWARDS
    ));
}

/*   -------------------------------------------------------------------   */

public Rq_Subscribe(sSymbol   : string, 
                    sExchange : string, 
                    sToken    : string, 
                    oLookBack : Lookback)
{
  //Utilities.Sendlog("Subscribe bars: " + sSymbol + "<>" + sExchange);
  this.Send(Utilities.GetMergedMsg(
    MnmIds.MNM_TEMPLATE_ID, TemplateId.TIME_BAR_UPDATE_REQUEST,

    MnmIds.MNM_SYMBOL, sSymbol,
    MnmIds.MNM_EXCHANGE, sExchange,
    
    MnmIds.MNM_USER_MSG, sToken,

    MnmIds.MNM_REQUEST, Rq.Request.SUBSCRIBE,

    MnmIds.MNM_DATA_BAR_TYPE, oLookBack.BarType,
    MnmIds.MNM_TIME_BAR_PERIOD, oLookBack.PeriodSub
    ));
}

/*   -------------------------------------------------------------------   */

public Rq_Unsubscribe(sSymbol   : string, 
                      sExchange : string, 
                      sToken    : string, 
                      oLookBack : Lookback)
{
  if (oLookBack.PeriodSub == 0)
    return;

  if (__DEV__)    
    Utilities.Sendlog("Unsubscribe bars: " + sSymbol + "<>" + sExchange);

  this.Send(Utilities.GetMergedMsg(
    MnmIds.MNM_TEMPLATE_ID, TemplateId.TIME_BAR_UPDATE_REQUEST,

    MnmIds.MNM_SYMBOL, sSymbol,
    MnmIds.MNM_EXCHANGE, sExchange,
    
    MnmIds.MNM_USER_MSG, sToken,

    MnmIds.MNM_REQUEST, Rq.Request.UNSUBSCRIBE,

    MnmIds.MNM_DATA_BAR_TYPE, oLookBack.BarType,
    MnmIds.MNM_TIME_BAR_PERIOD, oLookBack.PeriodSub 
    ));
}

/*   -------------------------------------------------------------------   */

public Rq_GetBars_Merge(oMsg      : Uint8Array | null, 
                        sSymbol   : string, 
                        sExchange : string, 
                        sToken    : string, 
                        oLookBack : Lookback)
{
  //Utilities.Sendlog("Requesting bars (auto): " + sSymbol + "<>" + sExchange);
  var oMsgNew =
  Utilities.GetMergedMsg(
  MnmIds.MNM_TEMPLATE_ID, TemplateId.TIME_BAR_REPLAY_REQUEST,
  MnmIds.MNM_SYMBOL, sSymbol,
  MnmIds.MNM_EXCHANGE, sExchange,

  MnmIds.MNM_USER_MSG, sToken,
  
  MnmIds.MNM_DATA_BAR_TYPE, oLookBack.BarType,
  MnmIds.MNM_TIME_BAR_PERIOD, oLookBack.Period, 

  MnmIds.MNM_START_INDEX, 
  Utilities.GetStartTime(oLookBack.LookbackMin,
                         oLookBack.DateOnly),
  MnmIds.MNM_FINISH_INDEX, 
  Utilities.GetEndTime(oLookBack.DateOnly),

  //MnmIds.MNM_USER_MAX_COUNT, oLookBack.Max,
  MnmIds.MNM_DIRECTION, oLookBack.DateOnly? 
                        Rq.Direction.FIRST : Rq.Direction.LAST,

  MnmIds.MNM_TIME_ORDER, Rq.TimeOrder.FORWARDS
  );

  return( Utilities.MergeMsg(oMsg, oMsgNew) );
}

/*   ---------------------------------------------------------------------   */

public Rq_Subscribe_Merge(oMsg      : Uint8Array, 
                          sSymbol   : string, 
                          sExchange : string, 
                          sToken    : string, 
                          oLookBack : Lookback)
{
  //Utilities.Sendlog("Subscribe bars (merge): " + sSymbol + "<>" + sExchange);
  var oMsgNew =
  Utilities.GetMergedMsg(
    MnmIds.MNM_TEMPLATE_ID, TemplateId.TIME_BAR_UPDATE_REQUEST,

    MnmIds.MNM_SYMBOL, sSymbol,
    MnmIds.MNM_EXCHANGE, sExchange,
    
    MnmIds.MNM_USER_MSG, sToken,

    MnmIds.MNM_REQUEST, Rq.Request.SUBSCRIBE,

    MnmIds.MNM_DATA_BAR_TYPE, oLookBack.BarType,
    MnmIds.MNM_TIME_BAR_PERIOD, oLookBack.PeriodSub,
    );

  return( Utilities.MergeMsg(oMsg, oMsgNew) );
}

/*   -------------------------------------------------------------------   */

public static GetBarsFromSettings(oLookBack = ConnectionHis.oDefaultLookBack,
                                  bForce    = false)
{

  // if (oLookBack == false)
  //   {
  //   alert("lookback null");
  //   return;
  //   }
  // else alert(oLookBack.Text);

  /*   -----------------------------------------------------------------   */

  if (ConnectionHis.oConn?.GetLoginStatus() == false)
    return;

  /*   -----------------------------------------------------------------   */

  let oMsg : Uint8Array | null = null;
  let iMsg = 0;

  /*   -----------------------------------------------------------------   */

  for (let i = 0; i < Connection.oSettings.length; i++)
    {
    let oVals = Utilities.processToken(Connection.oSettings[i].token);

    if (oVals.length != 2)
      return;
  
    let sSymbol   = oVals[0];
    let sExchange = oVals[1];

    /*   -----------------------------------------------------------------   */

    if (ConnectionHis.oConn == null)
      continue;

    /*   -----------------------------------------------------------------   */      

    let iLBType = Connection.oSettings[i].iLookBack;

    if (iLBType != undefined)
      oLookBack = ConnectionHis.FindLookBack(iLBType);

    /*   -----------------------------------------------------------------   */      

    let oMktData = Connection.oStore.get(Connection.oSettings[i].token);

    if (oMktData != undefined)
      {
      if (bForce == false)
        {
        if (oMktData.rq_bars == true)
          continue;
        }

      iMsg++;
      oMktData.rq_bars         = true;
      oMktData.times           = [];
      oMktData.close_times     = [];

      oMktData.ohlc.splice(0, oMktData.ohlc.length);
      oMktData.highs.splice(0, oMktData.highs.length);
      oMktData.lows.splice(0, oMktData.lows.length);
      oMktData.vols.splice(0, oMktData.vols.length);

      //new
      oMktData.closes.splice(0, oMktData.closes.length);
      //oMktData.closes          = [0];

      oMktData.max             = undefined;
      oMktData.min             = undefined;

      oMktData.update_chart    = false;
      oMktData.update_chart_rr = false;
      oMktData.update_orders   = false;
      oMktData.closes_got      = false;
      oMktData.lookback        = oLookBack;
      }
    else
      continue;

    /*   -----------------------------------------------------------------   */      

    oMsg = ConnectionHis.oConn.Rq_GetBars_Merge(oMsg, 
                                                sSymbol, 
                                                sExchange, 
                                                Connection.oSettings[i].token,
                                                oLookBack);

    // oWs_His.Rq_GetBars(
    //   sSymbol, 
    //   sExchange, 
    //   oSettings[i].token);


    if (oLookBack.PeriodSub != 0)
      {
      oMsg = ConnectionHis.oConn.Rq_Subscribe_Merge(oMsg, 
                                                    sSymbol, 
                                                    sExchange, 
                                                    Connection.oSettings[i].token,
                                                    oLookBack);

      if (oMktData != undefined)                                                    
        oMktData.sub_bars = true;
      }

    //ConnectionHis.oConn?.Send(oMsg);
    //oMsg = null;
    }

  if (oMsg != null)
    {
    if (__DEV__)      
      Utilities.Sendlog("**His: Store count: " + Connection.oStore.size); 
    // iUpdate++;
    // bUpdate = true;
  
    if (__DEV__)
      Utilities.Sendlog("Requesting Bars (auto) for symbols: " + iMsg + " out of " + Connection.oSettings.length + " from: " + Utilities.GetStartTime(oLookBack.LookbackMin) + " time - " + new Date( Utilities.GetStartTime(oLookBack.LookbackMin) * 1000).toString());

    ConnectionHis.oConn?.Send(oMsg);

    if (ConnectionHis.oConn != null)
      ConnectionHis.oConn.bInitRequestSent = true;

    return(true);
    }

return(false);    
}

/*   -------------------------------------------------------------------   */

private static LoginResponseHis(keys   : Array<any>, 
                                values : Array<any>) 
{
  
if (Connection.getResonseCodeLogin(keys, 
                                   values,
                                   ConnectionHis.oConn) == Connection.NO_ERROR)
    {
    //ConnectionHis.oConn?.ResetRetry();

    if (ConnectionHis.oConn?.GetLoginStatus() == true)
      {
      if (__DEV__)        
        Utilities.Sendlog("History already logged in");  

      return;
      }

    //setStatus("Sign out");
    //setBarStatus(true);
    ConnectionHis.oConn?.SetLoginStatus(true);

    if (__DEV__)
      Utilities.Sendlog("History login status: " + ConnectionHis.oConn?.GetLoginStatus());

    ConnectionHis.oConn?.SendLoginInfo();

    ConnectionHis.oConn?.oOnAlert(ConnectionHis.oConn, 
                                  Connection.MSG_LOGIN_SUCCESS, 
                                  null);

    ConnectionHis.oConn?.ResetRetry();                                  
    //GetBars();
    }
  else
    {
    if (__DEV__)      
      Utilities.Sendlog("History login failure...");

    ConnectionHis.oConn?.NoRetry();

    ConnectionHis.oConn?.oOnAlert(ConnectionHis.oConn, 
                                  Connection.MSG_LOGIN_FAIL,
                                  null);
    // setUsrInvalid(true);
    // setPwdInvalid(true);
    // CloseConnection();
    }  
}

/*   ---------------------------------------------------------------------   */

private static HandleCloseTrade(oData  : Data,
                                oValue : number,
                                bRR    : boolean)
{
//new  
// if (oData.closes[0] == 0)
//   {
//   oData.closes[0] = oValue;
//   // oData.max       = oValue;
//   // oData.min       = oValue;
//   }
// else
  {
  oData.closes.push(oValue);

  // if (oData.max == undefined || oData.max < oValue)
  //   oData.max = oValue;

  // if (oData.min == undefined || oData.min > oValue)
  //   oData.min = oValue;
  }

if (bRR == true)
  return;

if (oData.closes.length > oData.lookback.Max)
  {
  // if (oData.closes[0] == oData.max || oData.closes[0] == oData.min)
  //   {
  //     oData.max = oData.closes[1];
  //     oData.min = oData.closes[1];
    
  //     for (let i = 2; i < oData.closes.length; i++)
  //       {
  //       if (oData.max < oData.closes[i])
  //         oData.max = oData.closes[i];
      
  //       if (oData.min > oData.closes[i])
  //         oData.min = oData.closes[i];
  //       }
  //   }

  oData.closes.splice(0, 1);
  }

oData.update_chart = true;
}

/*   ---------------------------------------------------------------------   */

private static HandleOHLC(oData  : Data,
                          oCData : ChartData,
                          bRR    : boolean)
{
if (oData.ohlc.length == 0)
  {
  oData.ohlc.push(oCData);
  oData.max       = oCData.high;
  oData.min       = oCData.low;

  //new
  oData.closes.push(oCData.close);


  oData.highs.push(oCData.high);
  oData.lows.push(oCData.low);
  oData.vols.push(oCData.vol);
  }
else
  {
  oData.ohlc.push(oCData);

  //new
  oData.closes.push(oCData.close);

  oData.highs.push(oCData.high);
  oData.lows.push(oCData.low);
  oData.vols.push(oCData.vol);

  if (oData.max == undefined || oData.max < oCData.high)
    oData.max = oCData.high;

  if (oData.min == undefined || oData.min > oCData.low)
    oData.min = oCData.low;
  }

if (bRR == true)
  return;

if (oData.ohlc.length > oData.lookback.Max)
  {
  if (oData.ohlc[0].high == oData.max || oData.ohlc[0].low == oData.min)
    {
      oData.max = oData.ohlc[1].high;
      oData.min = oData.ohlc[1].low;
    
      for (let i = 2; i < oData.ohlc.length; i++)
        {
        if (oData.max < oData.ohlc[i].high)
          oData.max = oData.ohlc[i].high;
      
        if (oData.min > oData.ohlc[i].low)
          oData.min = oData.ohlc[i].low;
        }
    }

  oData.ohlc.splice(0, 1);

  //new
  oData.closes.splice(0, 1);

  oData.highs.splice(0, 1);
  oData.lows.splice(0, 1);
  oData.vols.splice(0, 1);
  }

//new
oData.update_chart = true;
}

/*   ---------------------------------------------------------------------   */

private static oWs_His_onmessage(x : any[][])
{
let [template, keys, values, tokens, usermsgs] = x;

//Utilities.Sendlog("history=>"  + template[0] + ": " + values);  

let open, close, high, low, vol;

switch (template[0])
{
  case TemplateId.FORCED_LOGOUT:
    if (__DEV__)
      Utilities.Sendlog("His FORCE logout: " + Utilities.GetKeyValueString(keys, values));

    ConnectionHis.oConn?.oOnAlert(ConnectionHis.oConn,
                                  Connection.MSG_FORCE_LOGOUT,
                                  null);

    return;      

  case TemplateId.HEARTBEAT_RESPONSE:
    return;

  case TemplateId.REJECT_RESPONSE:
    if (ConnectionHis.oConn)
      {
      ConnectionHis.oConn.sLastReject = Utilities.formatTimeStatusbar(Date.now()) + ": " + 
                                        Utilities.GetKeyValueStringForce(keys, values);
      }

    if (__DEV__)
      Utilities.Sendlog("****????His REJECT response: " + ConnectionHis.oConn?.sLastReject);
    return;
  
  case TemplateId.TIME_BAR_UPDATE_RESPONSE:
    //Utilities.Sendlog("time bar update response..." + Utilities.GetKeyValueString(keys, values));
    return;
      
  case TemplateId.LOGIN_RESPONSE:
    if (__DEV__)
      Utilities.Sendlog("unique login history: " + Utilities.GetKeyValueString(keys, values));

    ConnectionHis.LoginResponseHis(keys, values);
    return;

  case TemplateId.LOGIN_INFO_RESPONSE:
    //Utilities.Sendlog("login info history: " + Utilities.GetKeyValueString(keys, values));
    return;

  case TemplateId.TIME_BAR:
    //Utilities.Sendlog("time bar update...");
    let token = tokens[0] + "." + tokens[1];
    let oData = Connection.oStore.get(token); //Utilities.FindItem(oStore, token);
  
    /*   -----------------------------------------------------------------   */

    if (oData == undefined)
    {
    if (__DEV__)      
      Utilities.Sendlog("History: Symbol not found in the store: " + 
                        token + " template: " + template[0]);
    return;
    }

    /*   -----------------------------------------------------------------   */

    if (oData.closes_got == false)
      return;

    /*   -----------------------------------------------------------------   */

    //Utilities.Sendlog("****keys, values:=> " + Utilities.GetKeyValueString(keys, values));

    for (let i = 0; i < keys.length; i++)
      {
      switch(keys[i])
        {
        // case MnmIds.MNM_TIMEBAR_MARKER:
        //   if (oItem.closes.length == 2)
        //     Utilities.Sendlog(usermsgs[0] +  " - time: " + Utilities.GetDateFromSsboe(values[i]));
        //   break;
        // case MnmIds.MNM_DATA_BAR_TYPE:
        //   if (oItem.closes.length == 2)
        //     Utilities.Sendlog(usermsgs[0] +  " - bar type: " + values[i]);
        //   break;
        // case MnmIds.MNM_TIME_BAR_PERIOD:
        //   if (oItem.closes.length == 2)
        //     Utilities.Sendlog(usermsgs[0] +  " - period: " + values[i]);
        //   break;                    
        
        case MnmIds.MNM_TIMEBAR_MARKER:
          let sDt = Utilities.FormatLookBackTime(values[i], oData.lookback);

          oData.times.push(sDt);
          oData.close_times.push(values[i]);

          if (oData.times.length > oData.lookback.Max)
            {
            oData.times.splice(0, 1);
            oData.close_times.splice(0, 1);
            }


          //if (token == "ES.CME")
           // Utilities.Sendlog("time bar update: " + token + " at " + sDt);

            //Utilities.Sendlog(usermsgs[0] +  " - time: " + values[i]);
          break;

        case MnmIds.MNM_OPEN_PRICE:
          open = values[i];
          break;
        case MnmIds.MNM_HIGH_PRICE:
          high = values[i];
          break;
        case MnmIds.MNM_LOW_PRICE:
          low = values[i];
          break;          
        case MnmIds.MNM_TIME_BAR_TRADE_VOLUME:
          vol = values[i];
          break;          
  
        case MnmIds.MNM_CLOSE_TRADE_PRICE:
          close = values[i];

          //new
          //ConnectionHis.HandleCloseTrade(oData, values[i], false);
          break;
        }
      }

      if (open  != undefined && 
          close != undefined && 
          high  != undefined && 
          low   != undefined)
        {
        // if (open == close && high == low)          
        //  {
        //  close += 0.0000001; 
        //  high  += 0.0000001;
        //  }

        ConnectionHis.HandleOHLC(oData, new ChartData(open, 
                                                      close, 
                                                      high, 
                                                      low, 
                                                      vol==undefined? 0 : vol), false);
        // let oCData = new ChartData(open, close, high, low);
        // oCData.open  = open;
        // oCData.close = close;
        // oCData.high  = high;
        // oCData.low   = low;
        // oData.ohlc.push(oCData);  
        }
  

    return;  
  case TemplateId.TIME_BAR_REPLAY_RESPONSE:
    //Utilities.Sendlog(usermsgs[0] +  " - bar resp: " + Utilities.GetKeyValueString(keys, values)); 

    oData = Connection.oStore.get(usermsgs[0]); // Utilities.FindItem(oStore, usermsgs[0])

    if (oData == undefined)
      {
      if (__DEV__)        
        Utilities.Sendlog("Bar (History): symbol not found in store=>"  + usermsgs[0]);

      return;
      }

    if (oData.closes_got == true)
        return;

    let sret = Utilities.GetKeyValueString(keys, values);

    for (let i = 0; i < keys.length; i++)
      {
      switch(keys[i])
        {
        case MnmIds.MNM_TIMEBAR_MARKER:
            oData.times.push(Utilities.FormatLookBackTime(values[i], oData.lookback));
            oData.close_times.push(values[i]);

            //if (oData.times.length > oData.lookback.Max)
              //oData.times.splice(0, 1);
        
          //if (oData.closes.length == 1)
            //Utilities.Sendlog(usermsgs[0] +  " - time: " + values[i]);
          break;
        case MnmIds.MNM_DATA_BAR_TYPE:
          //if (oData.closes.length == 1)
            //Utilities.Sendlog(usermsgs[0] +  " - bar type: " + values[i]);
          break;
        case MnmIds.MNM_TIME_BAR_PERIOD:
          //if (oData.closes.length == 1)
            //Utilities.Sendlog(usermsgs[0] +  " - period: " + values[i]);
          break;                    

        case MnmIds.MNM_OPEN_PRICE:
          open = values[i];
          break;
        case MnmIds.MNM_HIGH_PRICE:
          high = values[i];
          break;
        case MnmIds.MNM_LOW_PRICE:
          low = values[i];
          break;
        case MnmIds.MNM_TIME_BAR_TRADE_VOLUME:
          vol = values[i];
          break;                    
        case MnmIds.MNM_CLOSE_TRADE_PRICE:
          close = values[i];
          //new
          //ConnectionHis.HandleCloseTrade(oData, values[i], true);

          // if (oData.closes[0] == 0)
          //   oData.closes[0] = values[i];
          // else
          //   oData.closes.push(values[i]);

            // //if (oData.closes.length > oData.lookback.Max)
            //   //oData.closes.splice(0, 1);

          break;

        case MnmIds.MNM_RESPONSE_CODE:
          if (values[i] != 0)
            {
            if (__DEV__)              
              Utilities.Sendlog(usermsgs[0] +  " - bars error: " + Utilities.GetKeyValueString(keys, values)); 

            return;
            }

          if (oData.closes_got == false)
            {
            oData.closes_got = true;

            if (__DEV__)
              Utilities.Sendlog(usermsgs[0] +  " - bars"); 

            //Utilities.Sendlog(usermsgs[0] +  " - " + " bars (" + oData.closes.length + ") : " + oData.closes); 
            //Utilities.Sendlog(usermsgs[0] +  " - " + " times (" + oData.times.length + ") : " + oData.times); 
            
            //iUpdate++;
            //bUpdate = true;

            // if (oData.lookback.Type == LookbackType.Month)
            //   {
            //   if (oData.closes.length > 1)
            //     {
            //     oData.month_closes = [...oData.closes];
            //     oData.month_times  = [...oData.times];
            //     }
            //   }
            // else if (oData.lookback.Type == LookbackType.Year)
            //   {
            //   if (oData.closes.length > 1)
            //     {
            //     oData.year_closes = [...oData.closes];
            //     oData.year_times  = [...oData.times];
            //     }
            //   }

            oData.update_chart_rr = true;
            oData.update_orders   = true;

            ConnectionHis.oConn?.oOnAlert(ConnectionHis.oConn, 
                                          Connection.MSG_GET_BARS,
                                          null);
            }    

          //setUpdateUI(iUpdate);
          //Utilities.Sendlog("history update symbol: " + usermsgs[0] + " " + i_update_ui);
          break;
        }
      }

      if (open  != undefined && 
          close != undefined && 
          high  != undefined && 
          low   != undefined)
        {
        // if (open == close && high == low)          
        //    {
        //    close += 0.0000001; 
        //    high  += 0.0000001;
        //    }
  
        ConnectionHis.HandleOHLC(oData, new ChartData(open, 
                                                      close, 
                                                      high, 
                                                      low, 
                                                      vol==undefined? 0 : vol), true);
        // let oCData = new ChartData();
        // oCData.open  = open;
        // oCData.close = close;
        // oCData.high  = high;
        // oCData.low   = low;
        // oData.ohlc.push(oCData);  
        }
  }

  //Utilities.Sendlog("history=>"  + template[0] + ": " + values);  
}
}

/*   =======================================================================  */

class ConnectionSys extends Connection
{
public static oConn      : ConnectionSys | null = null;
public static oSystems   = new Map<string, SysData>(); 
public static bRequested = false;

public static readonly INIT_CONN =  "wss://rprotocol-mobile.rithmic.com:443"; //"wss://rprotocol-beta.rithmic.com:443";
public static readonly BETA_CONN =  "wss://rprotocol-beta.rithmic.com:443"; //"wss://rprotocol-beta.rithmic.com:443";

/*   -------------------------------------------------------------------   */

static OnAlert(conn : Connection,
               msg  : number,
               data : any) {}

/*   -------------------------------------------------------------------   */

private static AddDev()
{
  let oSys       = new SysData("Rithmic Dev");
  oSys.requested = true;

  let oGwy       = new GwyData("Orangeburg", "wss://rittz00100.rithmic.com:443", false);
  oSys.gateways.push(oGwy);

  oGwy       = new GwyData("Orangeburg (test)", "ws://rittz00100.rithmic.com:40056", false);
  oSys.gateways.push(oGwy);
  
  ConnectionSys.oSystems.set(oSys.label, oSys);
}

/*   -------------------------------------------------------------------   */

private static AddTest()
{
  let oSys       = new SysData("Rithmic Test");
  oSys.requested = true;
  let oGwy       = new GwyData("Orangeburg", "wss://rituz00100.rithmic.com", false);

  oSys.gateways.push(oGwy);
  ConnectionSys.oSystems.set(oSys.label, oSys);
}

/*   -------------------------------------------------------------------   */

private static AddPaper()
{
  let oSys       = new SysData("Rithmic Paper Trading");
  oSys.requested = false;

  let oGwy       = new GwyData("Chicago Area", ConnectionSys.INIT_CONN); // "wss://rtraderpro-mobile.rithmic.com:443");
  oSys.gateways.push(oGwy);

  oGwy = new GwyData("Seoul", "wss://rprotocol-kr.rithmic.com:443");
  oSys.gateways.push(oGwy);

  oGwy = new GwyData("Mumbai", "wss://rprotocol-in.rithmic.com:443");
  oSys.gateways.push(oGwy);

  oGwy = new GwyData("Hong Kong", "wss://rprotocol-hk.rithmic.com:443");
  oSys.gateways.push(oGwy);

  oGwy = new GwyData("Sao Paolo", "wss://rprotocol-br.rithmic.com:443");
  oSys.gateways.push(oGwy);

  oGwy = new GwyData("Singapore", "wss://rprotocol-sg.rithmic.com:443");
  oSys.gateways.push(oGwy);

  oGwy = new GwyData("Sydney", "wss://rprotocol-au.rithmic.com:443");
  oSys.gateways.push(oGwy);

  oGwy = new GwyData("Europe", "wss://rprotocol-ie.rithmic.com:443");
  oSys.gateways.push(oGwy);

  oGwy = new GwyData("Tokyo", "wss://rprotocol-jp.rithmic.com:443");
  oSys.gateways.push(oGwy);

  // oGwy = new GwyData("Test (beta)", ConnectionSys.BETA_CONN);
  // oSys.gateways.push(oGwy);

  ConnectionSys.oSystems.set(oSys.label, oSys);
}

/*   -------------------------------------------------------------------   */

private static AddBeta()
{
  let oSys       = new SysData("Rithmic Paper Trading (beta)", 
                               "Rithmic Paper Trading");
  oSys.requested = true;

  let oGwy = new GwyData("Chicago Area", "wss://rprotocol-beta.rithmic.com:443", false);

  oSys.gateways.push(oGwy);
  ConnectionSys.oSystems.set(oSys.label, oSys);
}

/*   -------------------------------------------------------------------   */

private static AddSystems()
{
  this.AddPaper();
  //this.AddBeta();

  /*   -----------------------------------------------------------------   */

  this.AddRest();

  /*   -----------------------------------------------------------------   */

  this.AddTest();
  //this.AddDev();   
}

/*   -------------------------------------------------------------------   */

private static AddRest()
{
  let oSys       = new SysData("Rithmic 01");
  oSys.requested = false;

  let oGwy = new GwyData("Chicago Area", "wss://rprotocol-mobile.rithmic.com:443");
  oSys.gateways.push(oGwy);

  oGwy = new GwyData("Seoul", "wss://rprotocol-kr.rithmic.com:443");
  oSys.gateways.push(oGwy);

  oGwy = new GwyData("Mumbai", "wss://rprotocol-in.rithmic.com:443");
  oSys.gateways.push(oGwy);

  oGwy = new GwyData("Hong Kong", "wss://rprotocol-hk.rithmic.com:443");
  oSys.gateways.push(oGwy);

  oGwy = new GwyData("Sao Paolo", "wss://rprotocol-br.rithmic.com:443");
  oSys.gateways.push(oGwy);

  oGwy = new GwyData("Singapore", "wss://rprotocol-sg.rithmic.com:443");
  oSys.gateways.push(oGwy);

  oGwy = new GwyData("Sydney", "wss://rprotocol-au.rithmic.com:443");
  oSys.gateways.push(oGwy);

  oGwy = new GwyData("Europe", "wss://rprotocol-ie.rithmic.com:443");
  oSys.gateways.push(oGwy);

  oGwy = new GwyData("Tokyo", "wss://rprotocol-jp.rithmic.com:443");
  oSys.gateways.push(oGwy);

  // oGwy = new GwyData("Test (beta)", ConnectionSys.BETA_CONN);
  // oSys.gateways.push(oGwy);

  ConnectionSys.oSystems.set(oSys.label, oSys);

  /*   -----------------------------------------------------------------   */

  oSys       = new SysData("Rithmic 04 Colo");
  oSys.requested = false;

  oGwy = new GwyData("Chicago Area", "wss://rprotocol-mobile.rithmic.com:443");
  oSys.gateways.push(oGwy);

  // oGwy = new GwyData("Test (beta)", ConnectionSys.BETA_CONN);
  // oSys.gateways.push(oGwy);

  ConnectionSys.oSystems.set(oSys.label, oSys);

  /*   -----------------------------------------------------------------   */

  oSys       = new SysData("TopstepTrader");
  oSys.requested = false;

  oGwy = new GwyData("Chicago Area", "wss://rprotocol-mobile.rithmic.com:443");
  oSys.gateways.push(oGwy);

  // oGwy = new GwyData("Test (beta)", ConnectionSys.BETA_CONN);
  // oSys.gateways.push(oGwy);

  ConnectionSys.oSystems.set(oSys.label, oSys);

  /*   -----------------------------------------------------------------   */

  oSys       = new SysData("SpeedUp");
  oSys.requested = false;

  oGwy = new GwyData("Chicago Area", "wss://rprotocol-mobile.rithmic.com:443");
  oSys.gateways.push(oGwy);

  ConnectionSys.oSystems.set(oSys.label, oSys);

  /*   -----------------------------------------------------------------   */

  oSys       = new SysData("TradeFundrr");
  oSys.requested = false;

  oGwy = new GwyData("Chicago Area", "wss://rprotocol-mobile.rithmic.com:443");
  oSys.gateways.push(oGwy);

  // oGwy = new GwyData("Test (beta)", ConnectionSys.BETA_CONN);
  // oSys.gateways.push(oGwy);

  ConnectionSys.oSystems.set(oSys.label, oSys);

  /*   -----------------------------------------------------------------   */

  oSys       = new SysData("UProfitTrader");
  oSys.requested = false;

  oGwy = new GwyData("Chicago Area", "wss://rprotocol-mobile.rithmic.com:443");
  oSys.gateways.push(oGwy);

  // oGwy = new GwyData("Test (beta)", ConnectionSys.BETA_CONN);
  // oSys.gateways.push(oGwy);

  ConnectionSys.oSystems.set(oSys.label, oSys);

  /*   -----------------------------------------------------------------   */

  oSys       = new SysData("Apex");
  oSys.requested = false;

  oGwy = new GwyData("Chicago Area", "wss://rprotocol-mobile.rithmic.com:443");
  oSys.gateways.push(oGwy);

  // oGwy = new GwyData("Test (beta)", ConnectionSys.BETA_CONN);
  // oSys.gateways.push(oGwy);

  ConnectionSys.oSystems.set(oSys.label, oSys);

  /*   -----------------------------------------------------------------   */

  oSys       = new SysData("Leeloo Trading");
  oSys.requested = false;

  oGwy = new GwyData("Chicago Area", "wss://rprotocol-mobile.rithmic.com:443");
  oSys.gateways.push(oGwy);

  // oGwy = new GwyData("Test (beta)", ConnectionSys.BETA_CONN);
  // oSys.gateways.push(oGwy);

  ConnectionSys.oSystems.set(oSys.label, oSys);

  /*   -----------------------------------------------------------------   */

  oSys       = new SysData("MES Capital");
  oSys.requested = false;

  oGwy = new GwyData("Chicago Area", "wss://rprotocol-mobile.rithmic.com:443");
  oSys.gateways.push(oGwy);

  // oGwy = new GwyData("Test (beta)", ConnectionSys.BETA_CONN);
  // oSys.gateways.push(oGwy);

  ConnectionSys.oSystems.set(oSys.label, oSys);

  /*   -----------------------------------------------------------------   */

  oSys       = new SysData("FundedFuturesNetwork");
  oSys.requested = false;

  oGwy = new GwyData("Chicago Area", "wss://rprotocol-mobile.rithmic.com:443");
  oSys.gateways.push(oGwy);

  // oGwy = new GwyData("Test (beta)", ConnectionSys.BETA_CONN);
  // oSys.gateways.push(oGwy);

  ConnectionSys.oSystems.set(oSys.label, oSys);

  /*   -----------------------------------------------------------------   */

  oSys       = new SysData("TheTradingPit");
  oSys.requested = false;

  oGwy = new GwyData("Chicago Area", "wss://rprotocol-mobile.rithmic.com:443");
  oSys.gateways.push(oGwy);

  // oGwy = new GwyData("Test (beta)", ConnectionSys.BETA_CONN);
  // oSys.gateways.push(oGwy);

  ConnectionSys.oSystems.set(oSys.label, oSys);

  /*   -----------------------------------------------------------------   */

  oSys       = new SysData("Bulenox");
  oSys.requested = false;

  oGwy = new GwyData("Chicago Area", "wss://rprotocol-mobile.rithmic.com:443");
  oSys.gateways.push(oGwy);

  // oGwy = new GwyData("Test (beta)", ConnectionSys.BETA_CONN);
  // oSys.gateways.push(oGwy);

  ConnectionSys.oSystems.set(oSys.label, oSys);

  /*   -----------------------------------------------------------------   */

  oSys       = new SysData("Neurostreet Funding");
  oSys.requested = false;

  oGwy = new GwyData("Chicago Area", "wss://rprotocol-mobile.rithmic.com:443");
  oSys.gateways.push(oGwy);

  // oGwy = new GwyData("Test (beta)", ConnectionSys.BETA_CONN);
  // oSys.gateways.push(oGwy);

  ConnectionSys.oSystems.set(oSys.label, oSys);

  /*   -----------------------------------------------------------------   */

}

/*   -------------------------------------------------------------------   */

public static AddDefaults()
{
ConnectionSys.AddSystems();
//ConnectionSys.AddPaper();
//ConnectionSys.AddBeta();
}

/*   -------------------------------------------------------------------   */

public static Init(OnAlert : (conn        : Connection,
                              msg         : number,
                              data        : any) => void,
                   sGwySys = "")
{
try
  {
  if (sGwySys == "")
    {
    if (ConnectionSys.bRequested == true)
      return;

    //ConnectionSys.InitSys();
    ConnectionSys.bRequested = true;
    }
  else
    {
    let oSys = ConnectionSys.oSystems.get(sGwySys);  

    if (oSys != undefined)
      {
      if (oSys.requested == true)
        {
        ConnectionSys.oConn?.oOnAlert(ConnectionSys.oConn, 
                                      Connection.MSG_SYS_RQ,
                                      sGwySys);
        return;
        }

      oSys.requested = true;
      }
    }

  if (__DEV__)
    Utilities.Sendlog("**Starting System...");

  ConnectionSys.oConn = new ConnectionSys("System",
                                          "Rithmic Paper Trading",
                                          //"wss://rtraderpro-mobile.rithmic.com:443",
                                          ConnectionSys.INIT_CONN,
                                          "",
                                          "",
                                          Connection.TYPE_TICKER_PLANT,
                                          ConnectionSys.oWs_Sys_onmessage,
                                          OnAlert,
                                          sGwySys? Connection.CXT_TYPE_GWY : Connection.CXT_TYPE_SYS,
                                          sGwySys);

  ConnectionSys.oConn.iRetry = 0;
  ConnectionSys.oConn.Start();
  }
catch(error)
  {
  //setLoginState('💥');
  //alert("Order connection failed - " + error);
  }
}

/*   -------------------------------------------------------------------   */

public static getGateways(sSys : string)
{
let oSys = ConnectionSys.oSystems.get(sSys);

if (oSys == undefined || oSys.gateways.length == 0)
  return([new GwyData("", "", false)]);
else
  return(Array.from(oSys.gateways));
}

/*   -------------------------------------------------------------------   */

public static getSystem(sSys : string)
{
let oSys = ConnectionSys.oSystems.get(sSys);

if (oSys == undefined)
  return("");

if (oSys.system)
  return(oSys.system);
else
return(oSys.value);
}

/*   -------------------------------------------------------------------   */

public static getGwy(sSys   : string,
                     iIndex : number)
{
let oSys = ConnectionSys.oSystems.get(sSys);

if (oSys == undefined || iIndex >= oSys.gateways.length)
  return("");
else
  return(oSys.gateways[iIndex].value);
}

/*   -------------------------------------------------------------------   */

public static getGwyInfo(sSys   : string,
                         iIndex : number) : GwyData | undefined
{
let oSys = ConnectionSys.oSystems.get(sSys);

if (oSys == undefined || iIndex >= oSys.gateways.length)
  return(undefined);
else
  return(oSys.gateways[iIndex]);
}

/*   -------------------------------------------------------------------   */

public static getTargetableUri(sSys     : string,
                               iIndex   : number,
                               sGwyName : string | undefined)
{
let oGwy = ConnectionSys.getGwyInfo(sSys, iIndex);

if (sGwyName && oGwy?.value == sGwyName)
  {
  return(oGwy.uri);
  }
else
  {
  let sUri = ConnectionSys.getUriFromGwyName(sSys, sGwyName);

  if (!sUri)
    return(oGwy? oGwy.uri : "");

  return(sUri);
  }
}

/*   -------------------------------------------------------------------   */

public static getSavableGwyInfo(sSys     : string,
                                iIndex   : number,
                                sGwyName : string | undefined)
{
let oGwy = ConnectionSys.getGwyInfo(sSys, iIndex);

if (sGwyName && oGwy?.value == sGwyName)
  {
  return({gwy: sGwyName, index: iIndex});
  }
else
  {
  let oGwy = ConnectionSys.getGwyInfoFromGwyName(sSys, sGwyName);

  if (oGwy == undefined)
    return({gwy: sGwyName, index: iIndex});

  return({gwy: oGwy.gwy.value, index: oGwy.index});
  }
}

/*   -------------------------------------------------------------------   */

public static getInitialGwy(sSys     : string,
                            iIndex   : number,
                            sGwyName : string | undefined)
{
let sGwy = ConnectionSys.getGwy(sSys, iIndex);

if (sGwyName && sGwy == sGwyName)
  return(sGwy);
else
  {
  let sGwyFromName = ConnectionSys.getGwyFromGwyName(sSys, sGwyName);

  if (!sGwyFromName)
    return(sGwy);

  return(sGwyFromName);
  }
}

/*   -------------------------------------------------------------------   */

public static getGwyFromGwyName(sSys     : string,
                                sGwyName : string | undefined)
{
if (!sGwyName)
  return("");

/*   -------------------------------------------------------------------   */  

let oSys = ConnectionSys.oSystems.get(sSys);

/*   -------------------------------------------------------------------   */  

if (oSys == undefined || !oSys.gateways.length)
  {
  return("");
  }
else
  {
  for (let i = 0; i < oSys.gateways.length; i++)
    {
    if (oSys.gateways[i].value == sGwyName)
      return(oSys.gateways[i].value);
    }
  }

return("");
}

/*   -------------------------------------------------------------------   */

public static getGwyInfoFromGwyName(sSys     : string,
                                    sGwyName : string | undefined)
{
if (!sGwyName)
  return(undefined);

/*   -------------------------------------------------------------------   */  

let oSys = ConnectionSys.oSystems.get(sSys);

/*   -------------------------------------------------------------------   */  

if (oSys == undefined || !oSys.gateways.length)
  {
  return(undefined);
  }
else
  {
  for (let i = 0; i < oSys.gateways.length; i++)
    {
    if (oSys.gateways[i].value == sGwyName)
      return({gwy: oSys.gateways[i], index: i});
    }
  }

return(undefined);
}

/*   -------------------------------------------------------------------   */

public static getUri(sSys   : string,
                     iIndex : number)
{
let oSys = ConnectionSys.oSystems.get(sSys);

if (oSys == undefined || iIndex >= oSys.gateways.length)
  return("");
else
  return(oSys.gateways[iIndex].uri);
}

/*   -------------------------------------------------------------------   */

public static getUriFromGwyName(sSys     : string,
                                sGwyName : string | undefined)
{
if (!sGwyName)
  return("");

/*   -------------------------------------------------------------------   */  

let oSys = ConnectionSys.oSystems.get(sSys);

/*   -------------------------------------------------------------------   */  

if (oSys == undefined || !oSys.gateways.length)
  {
  return("");
  }
else
  {
  for (let i = 0; i < oSys.gateways.length; i++)
    {
    if (oSys.gateways[i].value == sGwyName)
      return(oSys.gateways[i].uri);
    }
  }

return("");
}

/*   -------------------------------------------------------------------   */

public static Dispose()
{
ConnectionSys.oConn?.SetLoginStatus(false);
ConnectionSys.oConn?.SetReconnect();
ConnectionSys.oConn?.Close();
ConnectionSys.oConn = null;
}

/*   -------------------------------------------------------------------   */

public static FindGateway(oSys  : SysData,  
                          sGwy  : string)
{
for (let i = 0; i < oSys.gateways.length; i++)
  {
  if (oSys.gateways[i].value == sGwy)
    return(i);
  }

return(AppMain.IMAGINARY);
}

/*   -------------------------------------------------------------------   */

private static oWs_Sys_onmessage(x : any[][])
  {
  let [template, keys, values, tokens, usermsgs] = x;

  /*   -------------------------------------------------------------------   */

  ConnectionMkt.iMsg++;

  /*   -------------------------------------------------------------------   */

  //Utilities.Sendlog("ALL SYSTEM-GWY response: " + Utilities.GetKeyValueString(keys, values));

  switch (template[0])
    {
      case TemplateId.RITHMIC_SYSTEM_INFO_RESPONSE:
        //let bChanged = false;

        if (__DEV__)
          Utilities.Sendlog("***System response: " + Utilities.GetKeyValueString(keys, values));
  
        for (let i = 0; i < keys.length; i++)
        {
          switch(keys[i])
            {
            case MnmIds.MNM_RITHMIC_SYSTEM_NAME:
              
              //if (values[i] != "Rithmic Paper Trading")
              if (ConnectionSys.oSystems.get(values[i]) == undefined)
                {
                ConnectionSys.oSystems.set(values[i], new SysData(values[i]));
                //bChanged = true;
                }

              // if (values[i] == "Rithmic Paper Trading")
              //   ConnectionSys.AddBeta();

              break;
            }
        }

        //ConnectionSys.AddTest();
        //ConnectionSys.AddDev();
      
        //if (bChanged)
          ConnectionSys.oConn?.oOnAlert(ConnectionSys.oConn, 
                                        Connection.MSG_SYS_RQ,
                                        null);
        return;

      case TemplateId.GATEWAY_INFO_RESPONSE:
        if (__DEV__)
          Utilities.Sendlog("***System Gwy response: " + Utilities.GetKeyValueString(keys, values));

        let sSys  : string    = "";
        let oGwys : string[]  = Array(0);
        let oUris : string[]  = Array(0);
        let oAggs : boolean[] = Array(0);

        for (let i = 0; i < keys.length; i++)
        {
          switch(keys[i])
            {
            case MnmIds.MNM_RITHMIC_SYSTEM_NAME:
              sSys = values[i];
              break;              
            case MnmIds.MNM_GATEWAY_NAME:
              oGwys.push(values[i]);
              //oGwy.label = values[i];
              //oGwy.value = values[i];
              break;
            case MnmIds.MNM_GATEWAY_URI:
              oUris.push(values[i]);
              //oGwy.uri = values[i];
              break;
            case MnmIds.MNM_GATEWAY_HAS_AGG_QUOTES:
              oAggs.push(values[i]? true: false);
              break;              
            }
        }

        /*   -------------------------------------------------------------   */

        if (usermsgs.length > 0)
          {
          sSys = usermsgs[0];
          }

        /*   -------------------------------------------------------------   */          

        if (sSys)
          {
          let oSys = ConnectionSys.oSystems.get(sSys);

          if (oSys == undefined)
              return;

          for (let i = 0; i < oGwys.length; i++)
            {
            // if (sSys     == "Rithmic Paper Trading" &&
            //     oGwys[i] == "Chicago Area")
            //     continue;
            if (!oUris[i])
              continue;
              
            let z = ConnectionSys.FindGateway(oSys, oGwys[i]);

            if (z != AppMain.IMAGINARY)
              {
              oSys.gateways[z].uri = oUris[i];
              oSys.gateways[z].agg = oAggs[i];
              }
            else
              oSys.gateways.push(new GwyData(oGwys[i], oUris[i], oAggs[i]));

            // for (let j = 0; j < oSys.gateways.length; j++)
            //   {
            //   if (oSys.gateways[j].value == oGwys[i])
            //     {
            //     oSys.gateways[j].uri = oUris[i];
            //     oSys.gateways[j].agg = oAggs[i];
            //     continue;
            //     }
            //   }

            // oSys.gateways.push(new GwyData(oGwys[i], oUris[i], oAggs[i]));
            }

          if (oSys.gateways.length && oSys.gateways[oSys.gateways.length - 1].value != "Test (beta)")
            oSys.gateways.push(new GwyData("Test (beta)", ConnectionSys.BETA_CONN));
          
          ConnectionSys.oConn?.oOnAlert(ConnectionSys.oConn, 
                                        Connection.MSG_SYS_RQ,
                                        sSys);
          }
          
        return;
    }
  }

}

/*   =======================================================================  */

export 
{
  Connection,
  ConnectionOrd,
  ConnectionRMS,
  ConnectionMkt,
  ConnectionHis,
  ConnectionSys
}